import ReactDOM from 'react-dom';
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as d3 from "d3"
import AdaptiveIsovalue from "./AdaptiveIsovalue";
import {Button, Switch} from 'antd';
import {PointToSegDist} from "./util"

var FileSaver = require('file-saver');
//import Quadtree from '@timohausmann/quadtree-js'
const {ShapeInfo, Intersection,Point2D,IntersectionQuery} = require("kld-intersections");


// var colors=['#f700ff','#0885c2','#1c8b3c','#ed334e']

// var colors=['#f16b22','#7e519f','#713e3a'] //fig1
var colors=['#e1642c','#d35d6d','#cecf7b','#4aa15f','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']   //fig2
//var colors=['#fbf4a4','#c4da90','#a7bfd9','#f3c4d3','#f5c3a0','#a5c3af','#b9b9b4','#d2c1d5','#e7f1f5','#f9dce2','#e7f1f5','#cdcadb'] //fig3
//var colors=['#d35d6d','#0885c2','#4aa15f','#6950a1','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']   //drawFig
//var colors=['#f700ff','#0885c2','#1c8b3c','#ed334e']
// var colors=['#fbf4a4','#c4da90','#a7bfd9','#f3c4d3','#f5c3a0','#a5c3af','#b9b9b4','#d2c1d5','#e7f1f5','#f9dce2','#e7f1f5','#cdcadb'] //fig3
//var colors=['#f16b22','#7e519f','#713e3a'] //fig1

var jsgraphs = require('js-graph-algorithms');
var POINT_EDGE_EPS=10
var DBSCAN_EPS=40
var VirtrualNodeBuffer=50


var clustering = require('density-clustering');
var weightCross=1
var weightDistance=1
var weightMess=1

var maxCross=Number.MIN_VALUE
var DISTANCE_THRESHHOLD=Number.MAX_VALUE

var priority_queue = require('./priority_queue.js');
var svgid = "#mainsvg"
var opsvgid = "#leftsvg"
var svg;
var g;
var offsetX,offsetY,viewWidth,viewHeight;

var subOldPoints = []
var addNewPoints = []
var subOldEdges = []
var addNewEdges = []
var editPoints = []
var editEdges = []
var preEdges = []
var tmpEditEdges = []
var prePoint
var preEdgeDict
var curEdgeDict
var editView = false
var BeforeWidth = 1920
var BeforeHeight = 1040
var ScreenWidth = 1920
var ScreenHeight = 1040

function clone(obj) {
    // Handle the 3 simple types, and null or undefined or function
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        var copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array or Object
    if (obj instanceof Array | obj instanceof Object) {
        var copy = (obj instanceof Array)?[]:{};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr))
                copy[attr] = clone(obj[attr]);
        }
        return copy;
    }
    throw new Error("Unable to clone obj! Its type isn't supported.");
}

//var Quadtree = require('./quadtree.js');

class HierarchicalCluster extends Component{
    static propTypes = {
        pointData: PropTypes.array,
    }

    static defaultProps = {
        pointData:[]
    }

    constructor() {
        super();
        this.state = {
            read: false,
            pointData:[],
            edges:[],
            hasinit:false,
            hasEdit:false,
            hascreated:false,
            editV:false,
            colorArray:['#e1642c','#d35d6d','#cecf7b','#4aa15f','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']
        }
        this.issplit=false
        this.pointData=[]
        this.canvasWidth=-1
        this.canvasHeight=-1
        this.maxX=-1
        this.maxY=-1
        this.minX=-1
        this.minY=-1
        this.maxDis=Number.MIN_VALUE
        this.catPointDict={}
        this.edges=[]
        this.graph=null
        this.clustergraph=null
        this.maxDistance=-1
        this.itemShape=""
        this.isSelect=false
        this.selectItem=null
        this.clusterDict={}
        this.clustergraphInfo={}
        this.clusterArr=[]
        this.noiseDict={}
        this.itemBBox=[]
        this.intersecEdges=[]
        this.vis = []
        this.heap1 = {}
        this.heap2 = {}
        this.QTree = null;
        this.f = []
        this.edgesdict = []
        this.idx = 0
        this.draggedIndex=-1
        this.draggedEdgeIndex=-1
        this.draggedEdgeSeg=-1
        this.nodeStartDict=[]
        this.nodeEndDict=[]
        this.lastClickIndex=-1
        this.lastClickItem=null
        this.deletedEdge=[]
        this.addedEdge=[]
        this.tempEdges=[]
    }

    init(){

        colors=['#e1642c','#d35d6d','#cecf7b','#4aa15f','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']

        POINT_EDGE_EPS = 10
        DBSCAN_EPS = 40
        VirtrualNodeBuffer = 50

        weightCross = 1
        weightDistance = 1
        weightMess = 1

        maxCross = Number.MIN_VALUE
        DISTANCE_THRESHHOLD = Number.MAX_VALUE

        svgid = "#mainsvg"
        opsvgid = "#leftsvg"

        subOldPoints = []
        addNewPoints = []
        subOldEdges = []
        addNewEdges = []
        editPoints = []
        editEdges = []
        preEdges = []
        tmpEditEdges = []
        editView = false

        this.setState({
            read: false,
            pointData:[],
            edges:[],
            hasinit:false,
            hasEdit:false,
            hascreated:false,
            editV:false,
            colorArray:['#e1642c','#d35d6d','#cecf7b','#4aa15f','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']
        })
        this.pointData=[]
        this.canvasWidth=-1
        this.canvasHeight=-1
        this.maxX=-1
        this.maxY=-1
        this.minX=-1
        this.minY=-1
        this.maxDis=Number.MIN_VALUE
        this.catPointDict={}
        this.edges=[]
        this.graph=null
        this.clustergraph=null
        this.maxDistance=-1
        this.itemShape=""
        this.isSelect=false
        this.selectItem=null
        this.clusterDict={}
        this.clustergraphInfo={}
        this.clusterArr=[]
        this.noiseDict={}
        this.itemBBox=[]
        this.intersecEdges=[]
        this.vis = []
        this.heap1 = {}
        this.heap2 = {}
        this.QTree = null;
        this.f = []
        this.edgesdict = []
        this.idx = 0
        this.draggedEdgeIndex=-1
        this.draggedEdgeSeg=-1
        this.nodeStartDict=[]
        this.nodeEndDict=[]
        this.lastClickIndex=-1
        this.lastClickItem=null
        this.deletedEdge=[]
        this.addedEdge=[]
        this.tempEdges=[]

        this.componentWillMount()
        this.render()
        this.componentDidMount()

        this.child.init_all()

    }

    searchFather(x){
        while(x!=this.f[x]){
            this.f[x] = this.f[this.f[x]];
            x = this.f[x];
        }
        return x;
    }

    unionFather(x,y){
        this.f[this.searchFather(y)] = this.searchFather(x);
    }

    componentWillMount() {
        ScreenHeight = window.screen.availHeight
        ScreenWidth = window.screen.availWidth
    }

    componentDidMount() {
        this.props.onRef(this)
        this.canvasWidth=document.getElementById("mainsvg").getBoundingClientRect().width
        this.canvasHeight=document.getElementById("mainsvg").getBoundingClientRect().height
        // this.setState({
        //     hasLoadData:this.props.hasLoadData
        // })
        //V1
        //this.QTree = new Quadtree({
        //    x: 0,
        //    y: 0,
        //    width: this.canvasWidth,
        //    height: this.canvasHeight
        //});
        //this.getData()
    }

    centralizeData(){
        let minx=Number.MAX_VALUE
        let miny=Number.MAX_VALUE
        let maxx=Number.MIN_VALUE
        let maxy=Number.MIN_VALUE
        for (let i=0;i<this.pointData.length;i++){
            if (this.pointData[i].x>maxx)
                maxx=this.pointData[i].x
            if(this.pointData[i].y>maxy)
                maxy=this.pointData[i].y
            if(this.pointData[i].x<minx)
                minx=this.pointData[i].x
            if(this.pointData[i].y<miny)
                miny=this.pointData[i].y
        }

        /*        let centerx=minx+(maxx-minx)/2
                let centery=miny+(maxy-miny)/2
                let move=[this.canvasWidth/2-centerx,this.canvasHeight/2-centery]

                for (let i=0;i<this.pointData.length;i++){
                    this.pointData[i].x+=move[0]
                    this.pointData[i].y+=move[1]
                }*/
        this.maxX=maxx
        this.minX=minx
        this.maxY=maxy
        this.minY=miny
        //console.log(this.minX,this.maxX,this.minY,this.maxY)

        d3.select("#mainsvg")
            .attr("viewBox",(minx-20)+" "+(miny-20)+" "+(maxx-minx+40)+" "+(maxy-miny+40))

        d3.select("#leftsvg")
            .attr("viewBox",(minx-20)+" "+(miny-20)+" "+(maxx-minx+40)+" "+(maxy-miny+40))
        /*        for (let i=0;i<this.pointData.length;i++){
                    this.pointData[i].x-=this.minX-20
                    this.pointData[i].y-=this.minY-20
                }*/

        offsetX = minx-20;
        offsetY = miny-20;
        viewWidth = maxx-minx+40;
        viewHeight = maxy-miny+40

    }

    calEPS(){
        // POINT_EDGE_EPS=Math.max(this.maxX-this.minX,this.maxY-this.minY)*0.03
        let dissum=0
        let disnum=0
        let maxDis=Number.MIN_VALUE
        for (let i=0;i<this.pointData.length;i++){
            for (let j=i+1;j<this.pointData.length;j++){
                let dis=this.calDistance(this.pointData[i],this.pointData[j])
                dissum+=dis
                disnum+=1
                if(dis>maxDis){
                    maxDis=dis
                }
            }
        }
        POINT_EDGE_EPS=maxDis*0.035
        // DBSCAN_EPS=POINT_EDGE_EPS
        this.maxDis=maxDis
        /*                d3.select(svgid)
                    .append("circle")
                    .attr("cx",POINT_EDGE_EPS)
                    .attr("cy",POINT_EDGE_EPS)
                    .attr("r",POINT_EDGE_EPS)
                    .attr("fill","black")*/

        DISTANCE_THRESHHOLD=dissum/disnum-10
        //console.log(POINT_EDGE_EPS)
        //console.log("avreage distance: "+dissum/disnum)
        //console.log("max distance: "+this.maxDis)


    }

    addNewPoints(point){
        point.x=parseFloat(point.x)
        point.y=parseFloat(point.y)
        point.id=this.pointData.length
        point.cat=point.cat.toString()
        let cats=point.cat.split(",")
        let catarray=[]
        if (cats.length>1){
            point.multicat=true
            for (let c=0;c<cats.length;c++){
                catarray.push(cats[c])
            }
        }
        else{
            point.multicat=false
            catarray.push(point.cat)
        }
        point.catArray=catarray

        for (let c=0;c<point.catArray.length;c++){
            let nowcat=point.catArray[c]
            if(!this.catPointDict.hasOwnProperty(nowcat)){
                this.catPointDict[nowcat]=[]
            }
            this.catPointDict[nowcat].push(point)
        }

        this.pointData.push(point)

        let tmpp1 = clone(this.pointData[this.pointData.length - 1])
        tmpp1.flag = true
        tmpp1.id = this.pointData.length - 1
        editPoints.push(tmpp1)

        //this.centralizeData()

        this.calEPS()

        this.drawPointData()

        this.optimizeMST(true)

        this.setState({
            pointData: this.pointData
        })
        this.setState({
            edges: this.edges
        })


    }

    getData(){

        colors = this.props.colorArray
        this.setState({
            colorArray:colors
        })

        //let that=this
        //fetch('/data/BubbleSetExample1.txt',{
        //    method:'GET',
        //    headers:{
        //        'Content-Type':'application/json;charset=UTF-8'
        //    },
        //    mode:'cors',
        //    cache:'default'
        //})
        //    .then(res=>res.json())
        //    .then(data=>{
        //console.log(data)

        // if(!this.props.hasLoadData){
        //     return
        // }

        if(this.state.hasinit){
            this.applyEdit()
        }
        else{
            if(this.props.pointData){
                this.init();

                if(this.props.edges){
                    this.edges=this.props.edges
                }

                // alert("Finish input and start creating spanning tree!");
                this.pointData=this.props.pointData
                //this.pointData=data
                this.itemShape=this.pointData[0].shape
                //console.log(this.itemShape)
                for (let i=0;i<this.pointData.length;i++){
                    this.pointData[i].x=parseFloat(this.pointData[i].x)
                    this.pointData[i].y=parseFloat(this.pointData[i].y)
                    this.pointData[i].id=i
                    this.pointData[i].cat=this.pointData[i].cat.toString()
                    let cats=this.pointData[i].cat.split(",")
                    let catarray=[]
                    if (cats.length>1){
                        this.pointData[i].multicat=true
                        for (let c=0;c<cats.length;c++){
                            catarray.push(cats[c])
                        }
                    }
                    else{
                        this.pointData[i].multicat=false
                        catarray.push(this.pointData[i].cat)
                    }
                    this.pointData[i].catArray=catarray
                    for (let c=0;c<this.pointData[i].catArray.length;c++){
                        let nowcat=this.pointData[i].catArray[c]
                        if(!this.catPointDict.hasOwnProperty(nowcat)){
                            this.catPointDict[nowcat]=[]
                        }
                        this.catPointDict[nowcat].push(this.pointData[i])
                    }
                }

                //console.log(this.pointData)
                //console.log(this.catPointDict)
                this.centralizeData()
                this.calEPS()
                d3.select(svgid).selectAll("*").remove();
                this.drawPointData()

                this.generateTreeWithHierarchical()



                // console.log(this.edges)
                this.drawEdges()

                this.props.hasCreate();

                this.setState({
                    pointData: this.pointData
                })
                this.setState({
                    edges: this.edges
                })
                this.setState({
                    hasinit:true
                })
                //})
            }

        }
        //console.log(this.pointData)

        return [this.pointData, this.edges, colors]

    }

    createGraph(){
        var g = new jsgraphs.Graph(this.pointData.length);
        for (let i=0;i<g.V;i++){
            g.node(i).label=this.pointData[i].cat
        }
        this.graph=g
    }

    sortEdgesGlobal(){
        function sortEdgesfunc(a,b){
            return a[2]-b[2]
        }
        let edges=[]
        let disArray=[]
        let messArray=[]
        let tempedges=[]
        let maxDis=Number.MIN_VALUE
        for (let k in this.catPointDict){
            for(let i=0;i<this.catPointDict[k].length;i++){
                for (let j=i+1;j<this.catPointDict[k].length;j++){
                    let dis=this.calDistance(this.catPointDict[k][i],this.catPointDict[k][j])
                    let mess=this.calEdgeMess(this.catPointDict[k][i],this.catPointDict[k][j])
                    disArray.push(dis)
                    messArray.push(mess)
                    if(dis>maxDis){
                        maxDis=dis
                    }
                    tempedges.push([this.catPointDict[k][i].id,this.catPointDict[k][j].id,dis,mess])
                }
            }
        }
        this.maxDistance=maxDis
        for (let i=0;i<tempedges.length;i++){
            let start=tempedges[i][0]
            let end=tempedges[i][1]
            let dis=tempedges[i][2]/maxDis
            let mess=tempedges[i][3]
            let weight=dis*(mess+1)
            // let weight=dis
            edges.push([start,end,weight,dis,mess])
        }

        edges.sort(sortEdgesfunc)
        return edges
    }

    sortEdgesGlobalWithMinDis(){
        function sortEdgesfunc(a,b){
            return a[2]-b[2]
        }
        let edges=[]
        let disArray=[]
        let messArray=[]
        let tempedges=[]
        let maxDis=Number.MIN_VALUE
        for (let k in this.catPointDict){
            for(let i=0;i<this.catPointDict[k].length;i++){
                for (let j=i+1;j<this.catPointDict[k].length;j++){
                    let dis=this.calDistance(this.catPointDict[k][i],this.catPointDict[k][j])
                    let mess=this.calEdgeMess(this.catPointDict[k][i],this.catPointDict[k][j])
                    disArray.push(dis)
                    messArray.push(mess)
                    if(dis>maxDis){
                        maxDis=dis
                    }
                    tempedges.push([this.catPointDict[k][i].id,this.catPointDict[k][j].id,dis,mess])
                }
            }
        }
        this.maxDistance=maxDis
        for (let i=0;i<tempedges.length;i++){
            let start=tempedges[i][0]
            let end=tempedges[i][1]
            let dis=tempedges[i][2]/maxDis
            let mess=tempedges[i][3]
            let weight=dis
            edges.push([start,end,weight,dis,mess])
        }

        edges.sort(sortEdgesfunc)
        return edges
    }

    sortEdgesInCategory(cat){
        function sortEdgesfunc(a,b){
            return a[2]-b[2]
        }
        let edges=[]
        for (let i=0;i<this.catPointDict[cat].length;i++){
            for (let j=i+1;j<this.catPointDict[cat].length;j++){
                let score=this.calEdgeWeight(this.catPointDict[cat][i],this.catPointDict[cat][j])
                edges.push([this.catPointDict[cat][i].id,this.catPointDict[cat][j].id,score])
            }
        }
        edges.sort(sortEdgesfunc)
        return edges
    }

    checkEdgeCrossing(P1,P2,Q1,Q2){
        if(Math.min(P1.x,P2.x) <= Math.max(Q1.x,Q2.x) &&
            Math.min(Q1.x,Q2.x) <= Math.max(P1.x,P2.x) &&
            Math.min(P1.y,P2.y) <= Math.max(Q1.y,Q2.y) &&
            Math.min(Q1.y,Q2.y) <= Math.max(P1.y,P2.y)){
            if(
                ((Q1.x-P1.x)*(Q1.y-Q2.y)-(Q1.y-P1.y)*( Q1.x-Q2.x)) * ((Q1.x-P2.x)*(Q1.y-Q2.y)-(Q1.y-P2.y)*(Q1.x-Q2.x)) < 0 &&
                ((P1.x-Q1.x)*(P1.y-P2.y)-(P1.y-Q1.y)*(P1.x-P2.x)) * ((P1.x-Q2.x)*(P1.y-P2.y)-(P1.y-Q2.y)*( P1.x-P2.x)) < 0
            ){
                return true;
            }
            else{
                return false;
            }
        }
        else{
            return false
        }
    }

    calEdgeWeightWithCrossing(node1,node2){
        let dis=this.calDistance(node1,node2)
        let mess=this.calEdgeMess(node1,node2)

        let crossnum=0
        for (let i=0;i<this.edges.length;i++){
            let start=this.edges[i].start
            let end=this.edges[i].end
            let edgecat=this.pointData[start].cat
            if(node1.cat!=edgecat&&this.checkEdgeCrossing(node1,node2,this.pointData[start],this.pointData[end])){
                crossnum+=1
            }
        }

        return [dis*(mess+1)*(crossnum+1)/this.maxDistance,dis/this.maxDistance,mess,crossnum]

    }

    calEdgeWeightWithCrossing2(node1,node2){
        let dis=this.calDistance(node1,node2)
        let mess=this.calEdgeMess(node1,node2)

        let crossnum=0
        for (let i=0;i<this.edges.length;i++){
            let start=this.edges[i].start
            let end=this.edges[i].end
            let edgecat=this.pointData[start].cat
            if(node1.cat!=edgecat&&this.checkEdgeCrossing(node1,node2,this.pointData[start],this.pointData[end])){
                crossnum+=1
            }
        }

        return [dis*(mess+1)*(crossnum+1)/this.maxDistance,dis/this.maxDistance,mess,crossnum]

    }
    checkNewEdge(node1,node2){
        if(node1.cat!=node2.cat)
            return true
        for (let i=0;i<this.edges.length;i++){
            let start=this.pointData[this.edges[i].start]
            let end=this.pointData[this.edges[i].end]
            if(start.cat!=node1.cat&&start.cat!=node2.cat&&end.cat!=node1.cat&&end.cat!=node2.cat&&this.checkEdgeCrossing(start,end,node1,node2)){
                // d3.selectAll("line").remove()
                // this.drawLine(start.x,start.y,end.x,end.y,"red")
                // this.drawLine(node1.x,node1.y,node2.x,node2.y,"red")
                return true
            }
        }
        return false
    }

    calBackbone(){
        let sortEdgeDict={}
        let sortedEdges=[]
        let removeEdggeList=[]

        sortedEdges=this.sortEdgesGlobal()

        for (let i=0;i<sortedEdges.length;i++){
            let start=sortedEdges[i][0]
            let end=sortedEdges[i][1]
            let weight=sortedEdges[i][2]
            let dis=sortedEdges[i][3]
            let mess=sortedEdges[i][4]

            if(this.pointData[start].cat!=this.pointData[end].cat)
                continue

            var dfs = new jsgraphs.DepthFirstSearch(this.graph, start);

            if(!dfs.hasPathTo(end)){
                if(!this.checkNewEdge(this.pointData[start],this.pointData[end])){
                    this.graph.addEdge(start,end)
                    // this.graph.edge(start,end).label=sortedEdges[i][2]
                    this.edges.push({
                        start:start,
                        end:end,
                        weight:weight,
                        dis:dis,
                        mess:mess
                    })
                    // this.graph.node(start).label=true
                    // this.graph.node(end).label=true
                }
                else{
                    removeEdggeList.push({
                        start:start,
                        end:end,
                        weight:weight,
                        dis:dis,
                        crossnum:-1,
                        mess:mess
                    })
                }
                // this.graph.addEdge(new jsgraphs.Edge(start, end, sortedEdges[i][2]))

                // console.log(this.graph.adj(start))
                // this.drawLine(this.pointData)
            }
        }

        while(!this.checkConnect()){
            let tempEdgeList=[]
            for(let i=0;i<removeEdggeList.length;i++){
                let start=removeEdggeList[i].start
                let end=removeEdggeList[i].end
                let cat=this.pointData[start].cat

                var dfs = new jsgraphs.DepthFirstSearch(this.graph, start);
                if(!dfs.hasPathTo(end)){
                    let scores=this.calEdgeWeightWithCrossing(this.pointData[start],this.pointData[end])
                    removeEdggeList[i].weight=scores[0]
                    removeEdggeList[i].crossnum=scores[3]
                    tempEdgeList.push(removeEdggeList[i])
                    // filteredRemoveList.push(removeEdggeList[i])
                }
            }
            let minCost=Number.MAX_VALUE
            let maxindex=-1
            for (let i=0;i<tempEdgeList.length;i++){
                if(minCost>tempEdgeList[i].weight){
                    minCost=tempEdgeList[i].weight
                    maxindex=i
                }
            }

            let start=tempEdgeList[maxindex].start
            let end=tempEdgeList[maxindex].end
            this.graph.addEdge(start,end)
            this.edges.push({
                start:start,
                end:end,
                weight:tempEdgeList[maxindex].weight,
                dis:tempEdgeList[maxindex].dis,
                mess:tempEdgeList[maxindex].mess,
                crossnum:tempEdgeList[maxindex].crossnum
            })

            // tempEdgeList.splice(maxindex,1)

        }

        // filteredRemoveList=this.sortRemoveEdges(filteredRemoveList)
        // console.log(filteredRemoveList)
    }

    calBackboneWithMinDis(){
        let sortEdgeDict={}
        let sortedEdges=[]
        let removeEdggeList=[]

        sortedEdges=this.sortEdgesGlobalWithMinDis()

        for (let i=0;i<sortedEdges.length;i++){
            let start=sortedEdges[i][0]
            let end=sortedEdges[i][1]
            let weight=sortedEdges[i][2]
            let dis=sortedEdges[i][3]
            let mess=sortedEdges[i][4]

            if(this.pointData[start].cat!=this.pointData[end].cat)
                continue

            var dfs = new jsgraphs.DepthFirstSearch(this.graph, start);

            if(!dfs.hasPathTo(end)){
                if(true){
                    this.graph.addEdge(start,end)
                    // this.graph.edge(start,end).label=sortedEdges[i][2]
                    this.edges.push({
                        start:start,
                        end:end,
                        weight:weight,
                        dis:dis,
                        mess:mess
                    })
                    // this.graph.node(start).label=true
                    // this.graph.node(end).label=true
                }
                else{
                    removeEdggeList.push({
                        start:start,
                        end:end,
                        weight:weight,
                        dis:dis,
                        crossnum:-1,
                        mess:mess
                    })
                }
                // this.graph.addEdge(new jsgraphs.Edge(start, end, sortedEdges[i][2]))

                // console.log(this.graph.adj(start))
                // this.drawLine(this.pointData)
            }
        }

        /*        while(!this.checkConnect()){
                    let tempEdgeList=[]
                    for(let i=0;i<removeEdggeList.length;i++){
                        let start=removeEdggeList[i].start
                        let end=removeEdggeList[i].end
                        let cat=this.pointData[start].cat

                        var dfs = new jsgraphs.DepthFirstSearch(this.graph, start);
                        if(!dfs.hasPathTo(end)){
                            let scores=this.calEdgeWeightWithCrossing(this.pointData[start],this.pointData[end])
                            removeEdggeList[i].weight=scores[0]
                            removeEdggeList[i].crossnum=scores[3]
                            tempEdgeList.push(removeEdggeList[i])
                            // filteredRemoveList.push(removeEdggeList[i])
                        }
                    }
                    let minCost=Number.MAX_VALUE
                    let maxindex=-1
                    for (let i=0;i<tempEdgeList.length;i++){
                        if(minCost>tempEdgeList[i].weight){
                            minCost=tempEdgeList[i].weight
                            maxindex=i
                        }
                    }

                    let start=tempEdgeList[maxindex].start
                    let end=tempEdgeList[maxindex].end
                    this.graph.addEdge(start,end)
                    this.edges.push({
                        start:start,
                        end:end,
                        weight:tempEdgeList[maxindex].weight,
                        dis:tempEdgeList[maxindex].dis,
                        mess:tempEdgeList[maxindex].mess,
                        crossnum:tempEdgeList[maxindex].crossnum
                    })

                    // tempEdgeList.splice(maxindex,1)

                }*/

        // filteredRemoveList=this.sortRemoveEdges(filteredRemoveList)
        // console.log(filteredRemoveList)


//TODO: dynamic calculate the cost of each removelist

    }

    checkConnectBetweenAllClusterV2(){
        for(let k in this.clusterDict){
            let m = this.clustergraphInfo[k].edgesnum;
            let n = this.clustergraphInfo[k].nodesnum;
            if (m != n - 1){
                return false;
            }
        }
        return true
    }

    checkConnectBetweenAllCluster(){
        for(let k in this.clusterDict){
            let start=this.clusterDict[k][0].id
            var dfs = new jsgraphs.DepthFirstSearch(this.clustergraph, start);
            for (let i=1;i<this.clusterDict[k].length;i++){
                if (!dfs.hasPathTo(this.clusterDict[k][i].id)){
                    return false
                }
            }
        }
        return true
    }


    checkConnectBetweenTwoClusterV2(id1,id2){
        return (this.searchFather(id1)==this.searchFather(id2));
    }

    checkConnectBetweenTwoCluster(id1,id2){
        var dfs = new jsgraphs.DepthFirstSearch(this.clustergraph, id1);
        if (!dfs.hasPathTo(id2)){
            return false
        }
        else{
            return true
        }
    }
    checkConnect(){
        // this.drawPointData()
        // this.drawEdges()
        for(let k in this.catPointDict){
            let start=this.catPointDict[k][0].id
            var dfs = new jsgraphs.DepthFirstSearch(this.graph, start);
            for (let i=1;i<this.catPointDict[k].length;i++){
                if (!dfs.hasPathTo(this.catPointDict[k][i].id)){
                    return false
                }
            }
        }
        return true
    }

    sortRemoveEdges(removelist){
        function sortRemove(a,b){
            return a.weight-b.weight
        }

        removelist.sort(sortRemove())
        return removelist
    }

    calEdgeWeightWithCrossing(node1,node2){
        let dis=this.calDistance(node1,node2)
        let mess=this.calEdgeMess(node1,node2)

        let crossnum=0
        for (let i=0;i<this.edges.length;i++){
            let start=this.edges[i].start
            let end=this.edges[i].end
            let edgecat=this.pointData[start].cat
            if(node1.cat!=edgecat&&this.checkEdgeCrossing(node1,node2,this.pointData[start],this.pointData[end])){
                crossnum+=1
            }
        }

        return [dis*(mess+1)*(crossnum+1)/this.maxDistance,dis/this.maxDistance,mess,crossnum]

    }

    calEdgeWeightWithCrossing2(node1,node2){
        let dis=this.calDistance(node1,node2)
        let mess=this.calEdgeMess(node1,node2)

        let crossnum=0
        for (let i=0;i<this.edges.length;i++){
            let start=this.edges[i].start
            let end=this.edges[i].end
            let edgecat=this.pointData[start].cat
            if(node1.cat!=edgecat&&this.checkEdgeCrossing(node1,node2,this.pointData[start],this.pointData[end])){
                crossnum+=1
            }
        }

        return [dis*(mess+1)*(crossnum+1)/this.maxDistance,dis/this.maxDistance,mess,crossnum]

    }

    calDistance(node1,node2){
        return Math.sqrt(Math.pow(node1.x-node2.x,2)+Math.pow(node1.y-node2.y,2))
    }

    calEdgeMess(node1,node2){
        let num=0
        for (let i=0;i<this.pointData.length;i++){
            if(this.pointData[i].cat!=node1.cat&&this.pointData[i].cat!=node2.cat){
                if(this.isPointInEdgeRange(node1,node2,this.pointData[i])){
                    let pointedgedis=this.calPointEdgeDistance(node1,node2,this.pointData[i])
                    // console.log(pointedgedis)
                    if(pointedgedis<POINT_EDGE_EPS){
                        num+=1
                    }
                }
            }
        }
        // console.log(num)
        return num
    }

    calEdgeWeight(node1,node2){
        let dis=this.calDistance(node1,node2)
        let mess=this.calEdgeMess(node1,node2)
        return [dis,mess]
    }

    getVecNorm(vec){
        return Math.sqrt(Math.pow(vec[0],2)+Math.pow(vec[1],2))
    }

    calVecCosine(vec1,vec2){
        let dot=vec1[0]*vec2[0]+vec1[1]*vec2[1]
        let norm1=this.getVecNorm(vec1)
        let norm2=this.getVecNorm(vec2)
        return dot/(norm1*norm2)

    }
    isPointInEdgeRange(start,end,point){
        let vec1=[point.x-start.x,point.y-start.y]
        let vec2=[end.x-start.x,end.y-start.y]
        let cos1=this.calVecCosine(vec1,vec2)
        if(cos1<0){
            return false
        }

        let vec3=[point.x-end.x,point.y-end.y]
        let vec4=[start.x-end.x,start.y-end.y]
        let cos2=this.calVecCosine(vec3,vec4)

        if(cos2<0){
            return false
        }

        return true
    }

    calPointEdgeDistance(start,end,point){
        //must check if the point is in the range of the edge before calling this function
        let vec1=[end.x-start.x,end.y-start.y]
        let vec2=[point.x-start.x,point.y-start.y]

        let dot=vec1[0]*vec2[0]+vec1[1]*vec2[1]
        let seg1=dot/this.getVecNorm(vec1)
        let norm=this.getVecNorm(vec2)

        return Math.sqrt(Math.pow(norm,2)-Math.pow(seg1,2))
    }

    calCrossingCost(){

    }

    drawLine(x1,y1,x2,y2,color){
        d3.select(svgid).append("line")
            .attr("x1",x1)
            .attr("y1",y1)
            .attr("x2",x2)
            .attr("y2",y2)
            .attr("stroke-width",2)
            .attr("stroke",color)
    }
    drawEdges(){
        let that=this
        for(let i=0;i<that.edges.length;i++){
            that.edges[i].id=i
            that.edges[i].SVGElement=[]
        }

        if(d3.select(svgid).select("#edgeGroup").empty()){
            d3.select(svgid)
                .insert("g","#pointGroup")
                .attr("id","edgeGroup")
        }

        if(d3.select(opsvgid).select("#edgeGroup").empty()){
            d3.select(opsvgid)
                .insert("g","#pointGroup")
                .attr("id","edgeGroup")
        }

        /*        function dragstartControlpoint(){
                }
                function draggedControlPoint(event){
                    let edgeindex=parseInt(d3.select(this).attr("edgeindex"))
                    let segindex=parseInt(d3.select(this).attr("segindex"))
                    that.edges[edgeindex].virtrualNodes[segindex][0]=event.x
                    that.edges[edgeindex].virtrualNodes[segindex][1]=event.y
                    d3.select(this)
                        .attr("cx",event.x)
                        .attr("cy",event.y)
                    d3.select(svgid).select("#edgeGroup").selectAll("line")
                        .filter(function(){
                            return parseInt(d3.select(this).attr("index"))==edgeindex&&parseInt(d3.select(this).attr("segindex"))==segindex
                        })
                        .attr("x2",event.x)
                        .attr("y2",event.y)
                    d3.select(svgid).select("#edgeGroup").selectAll("line")
                        .filter(function(){
                            return parseInt(d3.select(this).attr("index"))==edgeindex&&parseInt(d3.select(this).attr("segindex"))==segindex+1
                        })
                        .attr("x1",event.x)
                        .attr("y1",event.y)
                }

                var dragControlPoint = d3.drag()
                    .on("start",dragstartControlpoint)
                    .on("drag",draggedControlPoint)

                function dragstartEdge(event){
                    // console.log("start!")
                    let index=parseInt(d3.select(this).attr("index"))
                    let start=that.pointData[that.edges[index].start]
                    let end=that.pointData[that.edges[index].end]

                    d3.selectAll("line")
                        .filter(function(){
                            return parseInt(d3.select(this).attr("index"))==index
                        })
                        .attr("stroke","red")

                    if(d3.select(this).attr("isvirtrual")=="true"){
                        let segindex=parseInt(d3.select(this).attr("segindex"))
                        that.edges[index].virtrualNodes.splice(segindex,0,[event.x,event.y])
                        that.draggedEdgeIndex=index
                        that.draggedEdgeSeg=segindex
                    }
                    else{
                        that.edges[index].virtrual=true
                        that.edges[index].virtrualNodes.push([event.x,event.y])
                        that.draggedEdgeIndex=index
                        that.draggedEdgeSeg=0
                    }

                    d3.select(svgid).selectAll("line")
                        .filter(function(){
                            return parseInt(d3.select(this).attr("index"))==index
                        })
                        .remove()

                    let vpoints=that.edges[index].virtrualNodes
                    let nowp=[start.x,start.y]
                    let nextp=[]
                    for(let i=0;i<vpoints.length;i++){
                        nextp=vpoints[i]
                        d3.select(svgid).select("#edgeGroup")
                            .append("line")
                            .attr("x1",nowp[0])
                            .attr("y1",nowp[1])
                            .attr("x2",nextp[0])
                            .attr("y2",nextp[1])
                            .attr("stroke-width",2)
                            .attr("stroke","black")
                            .attr("index",index)
                            .attr("isvirtrual",true)
                            .attr("segindex",i)
                            .on("mouseover",function(d,i){
                                let thisindex=d3.select(this).attr("index")
                                d3.selectAll("line")
                                    .filter(function(){
                                        return d3.select(this).attr("index")==thisindex
                                    })
                                    .attr("stroke","red")
                                console.log(that.edges[thisindex])
                            })
                            .on("mouseout",function(){
                                let thisindex=d3.select(this).attr("index")
                                d3.selectAll("line")
                                    .filter(function(){
                                        return d3.select(this).attr("index")==thisindex
                                    })
                                    .attr("stroke","black")
                                console.log(that.edges[thisindex])
                            })
                            .on("mousedown",handleMouseDown)
                            .call(dragEdge)

                        nowp=nextp
                    }
                    d3.select(svgid).select("#edgeGroup")
                        .append("line")
                        .attr("x1",nowp[0])
                        .attr("y1",nowp[1])
                        .attr("x2",end.x)
                        .attr("y2",end.y)
                        .attr("stroke-width",2)
                        .attr("stroke","black")
                        .attr("index",index)
                        .attr("isvirtrual",true)
                        .attr("segindex",vpoints.length)
                        .on("mouseover",function(d,i){
                            let thisindex=d3.select(this).attr("index")
                            d3.selectAll("line")
                                .filter(function(){
                                    return d3.select(this).attr("index")==thisindex
                                })
                                .attr("stroke","red")
                            console.log(that.edges[thisindex])
                        })
                        .on("mouseout",function(){
                            let thisindex=d3.select(this).attr("index")
                            d3.selectAll("line")
                                .filter(function(){
                                    return d3.select(this).attr("index")==thisindex
                                })
                                .attr("stroke","black")
                            console.log(that.edges[thisindex])
                        })
                        .on("mousedown",handleMouseDown)

                        .call(dragEdge)

                    for (let v=0;v<vpoints.length;v++){
                        d3.select(svgid)
                            .select("#edgeGroup")
                            .append("circle")
                            .attr("class","controlPoints")
                            .attr("cx",vpoints[v][0])
                            .attr("cy",vpoints[v][1])
                            .attr("r",5)
                            .attr("fill","red")
                            .attr("opacity",0)
                            .attr("edgeindex",index)
                            .attr("segindex",v)
                            // .attr("display","none")
                            .on("mouseover",function(){
                                d3.select(this).attr("opacity",1)
                            })
                            .on("mouseout",function(){
                                d3.select(this).attr("opacity",0)
                            })
                            .call(dragControlPoint)

                    }

                }


                function draggedEdge(event){
                    // console.log("drag!")
                    if(that.draggedEdgeIndex==-1)
                        return
                    event.sourceEvent.stopPropagation();
                    let edgeIndex=that.draggedEdgeIndex
                    let segIndex=that.draggedEdgeSeg

                    that.edges[edgeIndex].virtrualNodes[segIndex][0]=event.x
                    that.edges[edgeIndex].virtrualNodes[segIndex][1]=event.y

                    d3.select(svgid).selectAll("line")
                        .filter(function(){
                            let thisedgeindex=parseInt(d3.select(this).attr("index"))
                            let thissegindex=parseInt(d3.select(this).attr("segindex"))

                            return thisedgeindex==that.draggedEdgeIndex&&thissegindex==that.draggedEdgeSeg
                        })
                        // .attr("stroke","blue")
                        .attr("x2",event.x)
                        .attr("y2",event.y)

                    d3.select(svgid).selectAll("line")
                        .filter(function(){
                            let thisedgeindex=parseInt(d3.select(this).attr("index"))
                            let thissegindex=parseInt(d3.select(this).attr("segindex"))
                            return thisedgeindex==that.draggedEdgeIndex&&thissegindex==that.draggedEdgeSeg+1
                        })
                        // .attr("stroke","blue")
                        .attr("x1",event.x)
                        .attr("y1",event.y)

                    d3.select(svgid).selectAll(".controlPoints")
                        .filter(function(){
                            let thisedgeindex=parseInt(d3.select(this).attr("edgeindex"))
                            let thissegindex=parseInt(d3.select(this).attr("segindex"))
                            return thisedgeindex==that.draggedEdgeIndex&&thissegindex==that.draggedEdgeSeg
                        })
                        // .attr("stroke","blue")
                        .attr("cx",event.x)
                        .attr("cy",event.y)

                }

                function dragendEdge(event){
                    // console.log("end!")
                    that.draggedEdgeSeg=-1
                    that.draggedEdgeIndex=-1
                }

                var dragEdge = d3.drag()
                    .on("start",dragstartEdge)
                    .on("drag",draggedEdge)
                    .on("end",dragendEdge)

                function handleMouseDown(event){
                    if(event.button==2){
                        let deleteindex=parseInt(d3.select(this).attr("index"))
                        d3.select(svgid).select("#edgeGroup")
                            .selectAll("line")
                            .filter(function(){
                                return parseInt(d3.select(this).attr("index"))==deleteindex
                            })
                            .remove()
                        d3.select(svgid).select("#edgeGroup")
                            .selectAll(".controlPoints")
                            .filter(function(){
                                return parseInt(d3.select(this).attr("edgeindex"))==deleteindex
                            })
                            .remove()

                        d3.select(svgid)
                            .select("#edgeGroup")
                            .selectAll(".controlPoints")
                            .filter(function(){
                                return parseInt(d3.select(this).attr("edgeindex"))>deleteindex
                            })
                            .attr("edgeindex",function(){
                                return parseInt(d3.select(this).attr("edgeindex"))-1
                            })

                        d3.select(svgid)
                            .select("#edgeGroup")
                            .selectAll("line")
                            .filter(function(){
                                return parseInt(d3.select(this).attr("index"))>deleteindex
                            })
                            .attr("index",function(){
                                return parseInt(d3.select(this).attr("index"))-1
                            })
                        that.edges.splice(deleteindex,1)

                        for (let i=0;i<that.edges.length;i++){
                            that.edges[i].id=i
                        }
                    }
                }*/

        d3.selectAll("line").remove()

        d3.selectAll(".controlPoints").remove()


        for (let i=0;i<this.edges.length;i++){
            /*            let start=this.edges[i].start
                        let end=this.edges[i].end

                        // this.nodeStartDict[start].push(i)
                        // this.nodeEndDict[end].push(i)
                        // this.nodeStartDict[start].push(i)
                        // this.nodeEndDict[end].push(i)
                        let index=i
                        if(this.edges[i].virtrual){
                            let vpoints=this.edges[i].virtrualNodes
                            let vstart=[this.pointData[start].x,this.pointData[start].y]
                            let vend
                            for (let v=0;v<vpoints.length;v++){
                                vend=vpoints[v]
                                let newline=d3.select(svgid)
                                    .select("#edgeGroup")
                                    .append("line")
                                    .attr("x1",vstart[0])
                                    .attr("y1",vstart[1])
                                    .attr("x2",vend[0])
                                    .attr("y2",vend[1])
                                    .attr("stroke-width",2)
                                    .attr("stroke","black")
                                    .attr("index",i)
                                    .attr("isvirtrual",true)
                                    .attr("segindex",v)
                                    .on("mouseover",function(d,i){
                                        let thisindex=d3.select(this).attr("index")
                                        d3.selectAll("line")
                                            .filter(function(){
                                                return d3.select(this).attr("index")==thisindex
                                            })
                                            .attr("stroke","red")
                                        console.log(that.edges[thisindex])
                                    })
                                    .on("mouseout",function(){
                                        let thisindex=d3.select(this).attr("index")
                                        d3.selectAll("line")
                                            .filter(function(){
                                                return d3.select(this).attr("index")==thisindex
                                            })
                                            .attr("stroke","black")
                                        console.log(that.edges[thisindex])
                                    })
                                    .on("mousedown",handleMouseDown)

                                    .call(dragEdge)
                                vstart=vend
                                if(v==0){
                                    this.nodeStartDict[start].push(newline)
                                }
                            }
                            vend=[this.pointData[end].x,this.pointData[end].y]
                            let newline=d3.select(svgid)
                                .select("#edgeGroup")
                                .append("line")
                                .attr("x1",vstart[0])
                                .attr("y1",vstart[1])
                                .attr("x2",vend[0])
                                .attr("y2",vend[1])
                                .attr("stroke-width",2)
                                .attr("stroke","black")
                                .attr("index",i)
                                .attr("isvirtrual",true)
                                .attr("segindex",vpoints.length)
                                .on("mouseover",function(d,i){
                                    let thisindex=d3.select(this).attr("index")
                                    d3.selectAll("line")
                                        .filter(function(){
                                            return d3.select(this).attr("index")==thisindex
                                        })
                                        .attr("stroke","red")
                                    console.log(that.edges[thisindex])
                                })
                                .on("mouseout",function(){
                                    let thisindex=d3.select(this).attr("index")
                                    d3.selectAll("line")
                                        .filter(function(){
                                            return d3.select(this).attr("index")==thisindex
                                        })
                                        .attr("stroke","black")
                                    console.log(that.edges[thisindex])
                                })
                                .on("mousedown",handleMouseDown)
                                .call(dragEdge)

                            this.nodeEndDict[end].push(newline)
                            // console.log()
                            for (let v=0;v<vpoints.length;v++){
                                d3.select(svgid)
                                    .select("#edgeGroup")
                                    .append("circle")
                                    .attr("class","controlPoints")
                                    .attr("cx",vpoints[v][0])
                                    .attr("cy",vpoints[v][1])
                                    .attr("r",5)
                                    .attr("edgeindex",i)
                                    .attr("segindex",v)
                                    .attr("fill","red")
                                    .attr("opacity",0)
                                    // .attr("display","none")
                                    .on("mouseover",function(){
                                        d3.select(this).attr("opacity",1)
                                    })
                                    .on("mouseout",function(){
                                        d3.select(this).attr("opacity",0)
                                    })
                                    .call(dragControlPoint)

                            }
                        }
                        else{
                            let newline=d3.select(svgid)
                                .select("#edgeGroup")
                                .append("line")
                                .attr("x1",this.pointData[start].x)
                                .attr("y1",this.pointData[start].y)
                                .attr("x2",this.pointData[end].x)
                                .attr("y2",this.pointData[end].y)
                                .attr("stroke-width",2)
                                .attr("stroke","black")
                                .attr("index",i)
                                .attr("isvirtrual",false)
                                .on("mouseover",function(d,i){
                                    let thisindex=d3.select(this).attr("index")
                                    d3.selectAll("line")
                                        .filter(function(){
                                            return d3.select(this).attr("index")==thisindex
                                        })
                                        .attr("stroke","red")
                                    console.log(that.edges[thisindex])
                                })
                                .on("mouseout",function(){
                                    let thisindex=d3.select(this).attr("index")
                                    d3.selectAll("line")
                                        .filter(function(){
                                            return d3.select(this).attr("index")==thisindex
                                        })
                                        .attr("stroke","black")
                                    console.log(that.edges[thisindex])
                                })
                                .on("mousedown",handleMouseDown)
                                .call(dragEdge)

                            this.nodeStartDict[start].push(newline)
                            this.nodeEndDict[end].push(newline)
                        }*/

            this.drawOneEdge(i)

        }
        // console.log(JSON.stringify(this.edges))




    }

    savePointData(){
        let that=this
        d3.selectAll("circle")
            .each(function(){
                let x=d3.select(this).attr("cx")
                let y=d3.select(this).attr("cy")
                let index=d3.select(this).attr("index")
                that.pointData[index].x=parseFloat(x)
                that.pointData[index].y=parseFloat(y)
                that.pointData[index].cat=that.pointData[index].cat.toString()
            })
    }

    saveEdgeData(){
        let savedData=[]
        for (let i=0;i<this.edges.length;i++){
            if(!this.edges[i].isdelete){
                this.edges[i].index=savedData.length
                savedData.push(this.edges[i])
            }
        }
        this.edges=savedData
        // console.log(this.edges)
        // d3.selectAll("line").remove()
        // let that=this
        // for(let i=0;i<this.edges.length;i++){
        //     let node1=this.edges[i].start
        //     let node2=this.edges[i].end
        //
        //     d3.select(svgid).append("line")
        //         .attr("x1",this.pointData[node1].x)
        //         .attr("y1",this.pointData[node1].y)
        //         .attr("x2",this.pointData[node2].x)
        //         .attr("y2",this.pointData[node2].y)
        //         .attr("stroke-width",2)
        //         .attr("stroke","black")
        //         .attr("index",i)
        //         .on("click",function(){
        //             let removeindex=d3.select(this).attr("index")
        //             that.edges[removeindex].isdelete=true
        //             d3.select(this).remove()
        //             console.log(that.edges)
        //         })
        // }
    }
    loadEdgeData(){
        let that=this
        fetch('/data/manuallyDataEdge.txt',{
            method:'GET',
            headers:{
                'Content-Type':'application/json;charset=UTF-8'
            },
            mode:'cors',
            cache:'default'
        })
            .then(res=>res.json())
            .then(data=>{
                console.log(data)
                this.edges=data
                let that=this
                for(let i=0;i<this.edges.length;i++){
                    let node1=this.edges[i].start
                    let node2=this.edges[i].end

                    d3.select(svgid).append("line")
                        .attr("x1",this.pointData[node1].x)
                        .attr("y1",this.pointData[node1].y)
                        .attr("x2",this.pointData[node2].x)
                        .attr("y2",this.pointData[node2].y)
                        .attr("stroke-width",2)
                        .attr("stroke","black")
                        .attr("index",i)
                        .on("click",function(){
                            let removeindex=d3.select(this).attr("index")
                            that.edges[removeindex].isdelete=true
                            d3.select(this).remove()
                        })
                }

            })
    }

    clickItem(event){
        if(!this.isSelect){
            this.isSelect=true
            this.selectItem=d3.select(event.target).attr("index")
        }
        else{
            if(d3.select(event.target).attr("index")!=this.selectItem){
                let node1=this.selectItem
                let node2=d3.select(event.target).attr("index")
                if(this.pointData[node1].cat==this.pointData[node2].cat){
                    this.isSelect=false
                    this.selectItem=null
                    this.edges.push({
                        start:node1,
                        end:node2,
                        index:this.edges.length,
                        isdelete:false
                    })
                    let that=this
                    d3.select(svgid).append("line")
                        .attr("x1",this.pointData[node1].x)
                        .attr("y1",this.pointData[node1].y)
                        .attr("x2",this.pointData[node2].x)
                        .attr("y2",this.pointData[node2].y)
                        .attr("stroke-width",2)
                        .attr("stroke","black")
                        .attr("index",this.edges.length-1)
                        .on("click",function(){
                            let removeindex=d3.select(this).attr("index")
                            that.edges[removeindex].isdelete=true
                            d3.select(this).remove()
                        })
                }

            }
        }
    }

    deleteEdge(index){
        let deleteindex=index
        let that=this
        d3.selectAll("line")
            .filter(function(){
                return parseInt(d3.select(this).attr("index"))==deleteindex
            })
            .remove()
        d3.selectAll(".controlPoints")
            .filter(function(){
                return parseInt(d3.select(this).attr("edgeindex"))==deleteindex
            })
            .remove()

        d3.selectAll(".controlPoints")
            .filter(function(){
                return parseInt(d3.select(this).attr("edgeindex"))>deleteindex
            })
            .attr("edgeindex",function(){
                return parseInt(d3.select(this).attr("edgeindex"))-1
            })

        d3.selectAll("line")
            .filter(function(){
                return parseInt(d3.select(this).attr("index"))>deleteindex
            })
            .attr("index",function(){
                return parseInt(d3.select(this).attr("index"))-1
            })
        that.edges.splice(deleteindex,1)

        for (let i=0;i<that.edges.length;i++){
            that.edges[i].id=i
        }


    }


    optimizeMST(isedit){

        this.clustergraphInfo={}
        let newGraph=new jsgraphs.Graph(this.pointData.length);
        for (let i=0;i<newGraph.V;i++){
            newGraph.node(i).label=this.pointData[i].cat
        }
        for(let i=0;i<this.edges.length;i++){
            let start=this.edges[i].start
            let end=this.edges[i].end
            let cat=this.edges[i].cat
            newGraph.addEdge(start,end)
            // this.clustergraphInfo[cat].edgesnum+=1
        }

        this.graph=newGraph
        //find Connected Components
        var cc = new jsgraphs.ConnectedComponents(newGraph);

        //create new clusterDict with connected components
        let newClusterDict={}
        for (let k in this.catPointDict){
            newClusterDict[k]=[]
        }
        let clusterArr=[]
        for (let i=0;i<cc.componentCount();i++){
            clusterArr.push([])
        }
        for (var v = 0; v < newGraph.V; v++) {
            let point=this.pointData[v]
            let comid=cc.componentId(v)
            clusterArr[comid].push(point)
        }
        for(let i=0;i<clusterArr.length;i++){
            let cat=clusterArr[i][0].cat
            newClusterDict[cat].push(clusterArr[i])
        }
        this.clusterDict=newClusterDict
        // console.log(newClusterDict)

        for (let k in this.clusterDict){
            this.clustergraphInfo[k] = {edgesnum:0,nodesnum:this.clusterDict[k].length};
        }

        clusterArr=[]
        let idnum=0
        for (var k in this.clusterDict){
            for (let i=0;i<this.clusterDict[k].length;i++){
                clusterArr.push({
                    points:this.clusterDict[k][i],
                    cat:k,
                    id:idnum
                })
                this.clusterDict[k][i].id=idnum
                idnum+=1
            }

        }

        this.clusterArr=clusterArr
        // console.log(this.clusterArr)
        let g = new jsgraphs.Graph(this.clusterArr.length);
        for (let i=0;i<g.V;i++){
            g.node(i).label=this.clusterArr[i].cat
        }
        // console.log(g.V,this.clusterArr.length)

        this.clustergraph=g

        //update boundingbox of points
        this.itemBBox=[]

        let items=document.getElementsByClassName("dataPoint")

        // console.log(items)
        for (let i=0;i<items.length;i++){
            this.itemBBox.push({
                "id":items[i].getAttribute("index"),
                "bbox":items[i].getBBox()
            })
        }

        if(!isedit){
            let newEdges=this.recalculateSpanningTree()
            // this.hierarchicalMergeV2()
            // console.log(this.clustergraphInfo)

            // this.drawEdges()
            for(let i=0;i<newEdges.length;i++){
                this.drawOneEdge(newEdges[i])
                this.edges[newEdges[i]].new = true
                //let tmpe = clone(this.edges[newEdges[i]])
                //tmpe.id = newEdges[i]
                //tmpe.flag = true
                //editEdges.push(tmpe)
                //addNewEdges.push(tmpe)

            }

            this.draggedIndex=-1
            this.deletedEdge=[]
            this.addedEdge=[]
            this.setState({
                pointData:this.pointData,
                edges:this.edges
            })
        }
        else{
            let tempedges=[]
            for (let i=0;i<this.edges.length;i++){
                /*                tempedges.push(
                                    {
                                        start:this.edges[i].start,
                                        end:this.edges[i].end,
                                        weight:this.edges[i].weight,
                                        cat:this.edges[i].cat,
                                        dis:this.edges[i].dis,
                                        virtrual:this.edges[i].virtrual,
                                        virtrualNodes:this.edges[i].virtrualNodes,
                                        isLocalTree:this.edges[i].isLocalTree
                                    }
                                )*/
                tempedges.push(this.edges[i])
            }

            let newEdges=this.recalculateSpanningTreeAfterEdit(tempedges)
            // this.hierarchicalMergeV2()
            // console.log(this.clustergraphInfo)
            // this.drawEdges()
            d3.selectAll(".deleteOpEdge")
                .remove()

            tmpEditEdges = []
            for(let i=0;i<newEdges.length;i++){
                this.drawOneEdgeAfterEdit(tempedges,newEdges[i])
                //console.log("newEdges:")
                //console.log(this.edges)
                //console.log(tempedges)
                //console.log(newEdges[i])
                let tmpe = clone(tempedges[newEdges[i]])
                tmpe.id = newEdges[i]
                tmpe.flag = true
                tmpEditEdges.push(tmpe)
            }
            this.tempEdges=tempedges
            // console.log(this.edges.length,this.tempEdges.length)

        }

    }

    sufaceRoutingAll(){
        for (let ei=0;ei<this.edges.length;ei++){
            let thisedge=this.edges[ei]
            let startp=this.pointData[thisedge.start.id]
            let endp=this.pointData[thisedge.end.id]
            let pcat=this.pointData[thisedge.start.id].cat
            let virtrualNodes=[]
            virtrualNodes.push([startp.x,startp.y])
            virtrualNodes.push([endp.x,endp.y])
            let linesToCheck=[{
                start:[startp.x,startp.y],
                end:[endp.x,endp.y],
                ids:[0,1]
            }]

            while(linesToCheck.length>0){

                let buffer=5
                let swap=false
                let checkline=linesToCheck.pop()

                startp=checkline.start
                endp=checkline.end
                let ids=checkline.ids

                d3.selectAll("line")
                    .remove()
                // .attr("stroke","black")
                d3.select(svgid).append("line")
                    .attr("x1",startp[0])
                    .attr("y1",startp[1])
                    .attr("x2",endp[0])
                    .attr("y2",endp[1])
                    .attr("stroke-width",2)
                    .attr("stroke","red")

                let intersecInfo=this.findCrossingBetweenEdgeRect(startp,endp,pcat)

                if(intersecInfo.length==0){
                    continue
                }
                this.edges[ei].virtrual=true
                // handle crossing between edge and rect
                let points=intersecInfo[0].points
                let rec=intersecInfo[0].rect

                let line1=[[rec.x,rec.y],[rec.x+rec.width,rec.y]]
                let line3=[[rec.x,rec.y+rec.height],[rec.x+rec.width,rec.y+rec.height]]

                let line2=[[rec.x,rec.y],[rec.x,rec.y+rec.height]]
                let line4=[[rec.x+rec.width,rec.y],[rec.x+rec.width,rec.y+rec.height]]

                let point1=points[0]
                let point2=points[1]

                let vnode

                if(line1[1][1]==point1.y&&line3[1][1]==point2.y||line3[1][1]==point1.y&&line1[1][1]==point2.y||line2[0][0]==point1.x&&line4[0][0]==point2.x||line2[0][0]==point2.x&&line4[0][0]==point1.x){
                    //parallel edges
                    let cornerpointindex=-1
                    if(line1[1][1]==point1.y&&line3[1][1]==point2.y){
                        let x1=point1.x-rec.x
                        let y1=point2.x-rec.x
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=2
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=4
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    else if(line3[1][1]==point1.y&&line1[1][1]==point2.y){
                        let x1=point2.x-rec.x
                        let y1=point1.x-rec.x
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=2
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=4
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    else if(line2[0][0]==point1.x&&line4[0][0]==point2.x){
                        let x1=point1.y-rec.y
                        let y1=point2.y-rec.y
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=4
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=2
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }
                    else if(line2[0][0]==point2.x&&line4[0][0]==point1.x){
                        let x1=point2.y-rec.y
                        let y1=point1.y-rec.y
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=4
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=2
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    let cornerpoint=[]


                    let iternum=0
                    let vnode1=-1
                    let vnode2=-1
                    while(true) {
                        if (cornerpointindex == 1) {
                            if (!swap) {
                                cornerpoint = [rec.x, rec.y]
                            } else {
                                cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                            }
                        } else if (cornerpointindex == 2) {
                            if (!swap) {
                                cornerpoint = [rec.x + rec.width, rec.y]
                            } else {
                                cornerpoint = [rec.x, rec.y + rec.height]
                            }
                        } else if (cornerpointindex == 3) {
                            if (!swap) {
                                cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                            } else {
                                cornerpoint = [rec.x, rec.y]
                            }
                        } else if (cornerpointindex == 4) {
                            if (!swap) {
                                cornerpoint = [rec.x, rec.y + rec.height]
                            } else {
                                cornerpoint = [rec.x + rec.width, rec.y]
                            }
                        }

                        let centerpoint = [rec.x + rec.width / 2, rec.y + rec.height / 2]
                        let movevec = [cornerpoint[0] - centerpoint[0], cornerpoint[1] - centerpoint[1]]
                        let movenorm = this.getVecNorm(movevec)
                        movevec[0] = movevec[0] / movenorm
                        movevec[1] = movevec[1] / movenorm

                        vnode = [cornerpoint[0] + buffer * movevec[0], cornerpoint[1] + buffer * movevec[1]]

                        // d3.selectAll("line")
                        //     .remove()
                        // // .attr("stroke","black")
                        // d3.select(svgid).append("line")
                        //     .attr("x1",startp[0])
                        //     .attr("y1",startp[1])
                        //     .attr("x2",vnode[0])
                        //     .attr("y2",vnode[1])
                        //     .attr("stroke-width",2)
                        //     .attr("stroke","red")
                        //
                        // d3.select(svgid).append("line")
                        //     .attr("x1",endp[0])
                        //     .attr("y1",endp[1])
                        //     .attr("x2",vnode[0])
                        //     .attr("y2",vnode[1])
                        //     .attr("stroke-width",2)
                        //     .attr("stroke","red")

                        if(this.checkVNodeInBound(vnode,pcat)){
                            if(!swap){
                                buffer=buffer/1.5
                            }
                            swap=!swap
                            iternum+=1
                            if(iternum>10){
                                break
                            }
                        }
                        else{
                            //not in obstacle, check if this virtrual edge corssing with other edges
                            if(swap){
                                vnode1=vnode
                            }
                            else{
                                vnode2=vnode
                            }
                            swap=!swap
                            if(vnode1!=-1&&vnode2!=-1){
                                break
                            }
                            // iternum+=1
                        }

                    }

                    if(vnode1==-1&&vnode2==-1){
                        //fail to route the edge
                        this.edges[ei].virtrual=false
                        continue
                    }
                    else if(vnode1!=-1&&vnode2!=-1){
                        //use the one with least crossing
                        let minCross=Number.MAX_VALUE
                        let bestVnode=null
                        let potentialNode=[vnode1,vnode2]
                        for (let n=0;n<potentialNode.length;n++){
                            let pnode=potentialNode[n]
                            let count=0
                            for(let i=0;i<this.edges.length;i++){
                                let start1=this.pointData[this.edges[i].start]
                                let end1=this.pointData[this.edges[i].end]
                                if(start1.cat!=pcat){
                                    let node1={
                                        x:startp[0],
                                        y:startp[1],
                                        cat:pcat
                                    }
                                    let node2={
                                        x:pnode[0],
                                        y:pnode[1],
                                        cat:pcat
                                    }
                                    let node3={
                                        x:endp[0],
                                        y:endp[1],
                                        cat:pcat
                                    }
                                    if(this.checkEdgeCrossing(start1,end1,node1,node2)){
                                        count+=1
                                    }
                                    if(this.checkEdgeCrossing(start1,end1,node2,node3)){
                                        count+=1
                                    }
                                }
                            }
                            if(count<minCross){
                                minCross=count
                                bestVnode=potentialNode[n]
                            }

                        }
                        vnode=bestVnode

                    }
                    else{
                        if(vnode1!=-1){
                            vnode=vnode1
                        }
                        else{
                            vnode=vnode2
                        }
                    }

                }
                else{
                    //neighbouring edges
                    //find the corner point on the rectangle
                    let temppoint=[point1.x,point2.y]
                    let cornerpoint=[]
                    if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x+rec.width,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                    }
                    else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x,rec.y+rec.height]
                    }
                    else{
                        temppoint=[point2.x,point1.y]
                        if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                            cornerpoint=[rec.x,rec.y]
                        }
                        else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                            cornerpoint=[rec.x+rec.width,rec.y]
                        }
                        else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                            cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                        }
                        else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                            cornerpoint=[rec.x,rec.y+rec.height]
                        }
                    }

                    let centerpoint=[rec.x+rec.width/2,rec.y+rec.height/2]
                    let movevec=[cornerpoint[0]-centerpoint[0],cornerpoint[1]-centerpoint[1]]
                    let movenorm=this.getVecNorm(movevec)
                    movevec[0]=movevec[0]/movenorm
                    movevec[1]=movevec[1]/movenorm

                    vnode=[cornerpoint[0]+buffer*movevec[0],cornerpoint[1]+buffer*movevec[1]]
                }


                // d3.selectAll("line")
                //     .remove()
                // // .attr("stroke","black")
                // d3.select(svgid).append("line")
                //     .attr("x1",startp[0])
                //     .attr("y1",startp[1])
                //     .attr("x2",vnode[0])
                //     .attr("y2",vnode[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")
                //
                // d3.select(svgid).append("line")
                //     .attr("x1",endp[0])
                //     .attr("y1",endp[1])
                //     .attr("x2",vnode[0])
                //     .attr("y2",vnode[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")


                let samepoiint=false
                for (let m=0;m<virtrualNodes.length;m++){
                    if(vnode[0]==virtrualNodes[m][0]&&vnode[1]==virtrualNodes[m][1]){
                        samepoiint=true
                        break
                    }
                }
                if(samepoiint){
                    continue
                }

                let newid


                newid=ids[0]+1


                virtrualNodes.splice(newid,0,vnode)

                for (let n=0;n<linesToCheck.length;n++){
                    if(linesToCheck[n].ids[0]>=newid){
                        linesToCheck[n].ids[0]=linesToCheck[n].ids[0]+1
                    }
                    if(linesToCheck[n].ids[1]>=newid){
                        linesToCheck[n].ids[1]=linesToCheck[n].ids[1]+1
                    }
                }
                // virtrualNodes.push(vnode)
                linesToCheck.push({
                    start:startp,
                    end:vnode,
                    ids:[ids[0],newid]
                })
                linesToCheck.push({
                    start:vnode,
                    end:endp,
                    ids:[newid,ids[1]+1]
                })

                // console.log(linesToCheck)

            }

            virtrualNodes.pop()
            virtrualNodes.splice(0,1)
            this.edges[ei].virtrualNodes=virtrualNodes
        }

    }

    surfaceRoutingEdge(edge){

        let startp=this.pointData[edge.start]
        let endp=this.pointData[edge.end]
        let pcat=this.pointData[edge.start].cat
        let virtrualNodes=[]
        virtrualNodes.push([startp.x,startp.y])
        virtrualNodes.push([endp.x,endp.y])
        let linesToCheck=[{
            start:[startp.x,startp.y],
            end:[endp.x,endp.y],
            ids:[0,1]
        }]

        while(linesToCheck.length>0){

            let buffer=5
            let swap=false
            let checkline=linesToCheck.pop()

            startp=checkline.start
            endp=checkline.end
            let ids=checkline.ids

            // d3.selectAll("line")
            //     .remove()
            // // .attr("stroke","black")
            // d3.select(svgid).append("line")
            //     .attr("x1",startp[0])
            //     .attr("y1",startp[1])
            //     .attr("x2",endp[0])
            //     .attr("y2",endp[1])
            //     .attr("stroke-width",2)
            //     .attr("stroke","red")

            let intersecInfo=this.findCrossingBetweenEdgeRect(startp,endp,pcat)

            if(intersecInfo.length==0){
                continue
            }
            edge.virtrual=true
            // handle crossing between edge and rect
            let points=intersecInfo[0].points
            let rec=intersecInfo[0].rect

            let line1=[[rec.x,rec.y],[rec.x+rec.width,rec.y]]
            let line3=[[rec.x,rec.y+rec.height],[rec.x+rec.width,rec.y+rec.height]]

            let line2=[[rec.x,rec.y],[rec.x,rec.y+rec.height]]
            let line4=[[rec.x+rec.width,rec.y],[rec.x+rec.width,rec.y+rec.height]]

            let point1=points[0]
            let point2=points[1]

            let vnode

            if(line1[1][1]==point1.y&&line3[1][1]==point2.y||line3[1][1]==point1.y&&line1[1][1]==point2.y||line2[0][0]==point1.x&&line4[0][0]==point2.x||line2[0][0]==point2.x&&line4[0][0]==point1.x){
                //parallel edges
                let cornerpointindex=-1
                if(line1[1][1]==point1.y&&line3[1][1]==point2.y){
                    let x1=point1.x-rec.x
                    let y1=point2.x-rec.x
                    if(x1+y1<rec.width){
                        if(x1>y1){
                            cornerpointindex=3
                        }
                        else{
                            cornerpointindex=2
                        }
                    }
                    else{
                        if(x1<y1){
                            cornerpointindex=4
                        }
                        else{
                            cornerpointindex=1
                        }
                    }
                }

                else if(line3[1][1]==point1.y&&line1[1][1]==point2.y){
                    let x1=point2.x-rec.x
                    let y1=point1.x-rec.x
                    if(x1+y1<rec.width){
                        if(x1>y1){
                            cornerpointindex=3
                        }
                        else{
                            cornerpointindex=2
                        }
                    }
                    else{
                        if(x1<y1){
                            cornerpointindex=4
                        }
                        else{
                            cornerpointindex=1
                        }
                    }
                }

                else if(line2[0][0]==point1.x&&line4[0][0]==point2.x){
                    let x1=point1.y-rec.y
                    let y1=point2.y-rec.y
                    if(x1+y1<rec.width){
                        if(x1>y1){
                            cornerpointindex=3
                        }
                        else{
                            cornerpointindex=4
                        }
                    }
                    else{
                        if(x1<y1){
                            cornerpointindex=2
                        }
                        else{
                            cornerpointindex=1
                        }
                    }
                }
                else if(line2[0][0]==point2.x&&line4[0][0]==point1.x){
                    let x1=point2.y-rec.y
                    let y1=point1.y-rec.y
                    if(x1+y1<rec.width){
                        if(x1>y1){
                            cornerpointindex=3
                        }
                        else{
                            cornerpointindex=4
                        }
                    }
                    else{
                        if(x1<y1){
                            cornerpointindex=2
                        }
                        else{
                            cornerpointindex=1
                        }
                    }
                }

                let cornerpoint=[]


                let iternum=0
                let vnode1=-1
                let vnode2=-1
                while(true) {
                    if (cornerpointindex == 1) {
                        if (!swap) {
                            cornerpoint = [rec.x, rec.y]
                        } else {
                            cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                        }
                    } else if (cornerpointindex == 2) {
                        if (!swap) {
                            cornerpoint = [rec.x + rec.width, rec.y]
                        } else {
                            cornerpoint = [rec.x, rec.y + rec.height]
                        }
                    } else if (cornerpointindex == 3) {
                        if (!swap) {
                            cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                        } else {
                            cornerpoint = [rec.x, rec.y]
                        }
                    } else if (cornerpointindex == 4) {
                        if (!swap) {
                            cornerpoint = [rec.x, rec.y + rec.height]
                        } else {
                            cornerpoint = [rec.x + rec.width, rec.y]
                        }
                    }

                    let centerpoint = [rec.x + rec.width / 2, rec.y + rec.height / 2]
                    let movevec = [cornerpoint[0] - centerpoint[0], cornerpoint[1] - centerpoint[1]]
                    let movenorm = this.getVecNorm(movevec)
                    movevec[0] = movevec[0] / movenorm
                    movevec[1] = movevec[1] / movenorm

                    vnode = [cornerpoint[0] + buffer * movevec[0], cornerpoint[1] + buffer * movevec[1]]

                    // d3.selectAll("line")
                    //     .remove()
                    // // .attr("stroke","black")
                    // d3.select(svgid).append("line")
                    //     .attr("x1",startp[0])
                    //     .attr("y1",startp[1])
                    //     .attr("x2",vnode[0])
                    //     .attr("y2",vnode[1])
                    //     .attr("stroke-width",2)
                    //     .attr("stroke","red")
                    //
                    // d3.select(svgid).append("line")
                    //     .attr("x1",endp[0])
                    //     .attr("y1",endp[1])
                    //     .attr("x2",vnode[0])
                    //     .attr("y2",vnode[1])
                    //     .attr("stroke-width",2)
                    //     .attr("stroke","red")

                    if(this.checkVNodeInBound(vnode,pcat)){
                        if(!swap){
                            buffer=buffer/1.5
                        }
                        swap=!swap
                        iternum+=1
                        if(iternum>10){
                            break
                        }
                    }
                    else{
                        //not in obstacle, check if this virtrual edge corssing with other edges
                        if(swap){
                            vnode1=vnode
                        }
                        else{
                            vnode2=vnode
                        }
                        swap=!swap
                        if(vnode1!=-1&&vnode2!=-1){
                            break
                        }
                        // iternum+=1
                    }

                }

                if(vnode1==-1&&vnode2==-1){
                    //fail to route the edge
                    edge.virtrual=false
                    continue
                }
                else if(vnode1!=-1&&vnode2!=-1){
                    //use the one with least crossing
                    let minCross=Number.MAX_VALUE
                    let bestVnode=null
                    let potentialNode=[vnode1,vnode2]
                    for (let n=0;n<potentialNode.length;n++){
                        let pnode=potentialNode[n]
                        let count=0
                        for(let i=0;i<this.edges.length;i++){
                            let start1=this.pointData[this.edges[i].start]
                            let end1=this.pointData[this.edges[i].end]
                            if(start1.cat!=pcat){
                                let node1={
                                    x:startp[0],
                                    y:startp[1],
                                    cat:pcat
                                }
                                let node2={
                                    x:pnode[0],
                                    y:pnode[1],
                                    cat:pcat
                                }
                                let node3={
                                    x:endp[0],
                                    y:endp[1],
                                    cat:pcat
                                }
                                if(this.checkEdgeCrossing(start1,end1,node1,node2)){
                                    count+=1
                                }
                                if(this.checkEdgeCrossing(start1,end1,node2,node3)){
                                    count+=1
                                }
                            }
                        }
                        if(count<minCross){
                            minCross=count
                            bestVnode=potentialNode[n]
                        }

                    }
                    vnode=bestVnode

                }
                else{
                    if(vnode1!=-1){
                        vnode=vnode1
                    }
                    else{
                        vnode=vnode2
                    }
                }

            }
            else{
                //neighbouring edges
                //find the corner point on the rectangle
                let temppoint=[point1.x,point2.y]
                let cornerpoint=[]
                if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                    cornerpoint=[rec.x,rec.y]
                }
                else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                    cornerpoint=[rec.x+rec.width,rec.y]
                }
                else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                    cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                }
                else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                    cornerpoint=[rec.x,rec.y+rec.height]
                }
                else{
                    temppoint=[point2.x,point1.y]
                    if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x+rec.width,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                    }
                    else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x,rec.y+rec.height]
                    }
                }

                let centerpoint=[rec.x+rec.width/2,rec.y+rec.height/2]
                let movevec=[cornerpoint[0]-centerpoint[0],cornerpoint[1]-centerpoint[1]]
                let movenorm=this.getVecNorm(movevec)
                movevec[0]=movevec[0]/movenorm
                movevec[1]=movevec[1]/movenorm

                vnode=[cornerpoint[0]+buffer*movevec[0],cornerpoint[1]+buffer*movevec[1]]
            }


            // d3.selectAll("line")
            //     .remove()
            // // .attr("stroke","black")
            // d3.select(svgid).append("line")
            //     .attr("x1",startp[0])
            //     .attr("y1",startp[1])
            //     .attr("x2",vnode[0])
            //     .attr("y2",vnode[1])
            //     .attr("stroke-width",2)
            //     .attr("stroke","red")
            //
            // d3.select(svgid).append("line")
            //     .attr("x1",endp[0])
            //     .attr("y1",endp[1])
            //     .attr("x2",vnode[0])
            //     .attr("y2",vnode[1])
            //     .attr("stroke-width",2)
            //     .attr("stroke","red")


            let samepoiint=false
            for (let m=0;m<virtrualNodes.length;m++){
                if(vnode[0]==virtrualNodes[m][0]&&vnode[1]==virtrualNodes[m][1]){
                    samepoiint=true
                    break
                }
            }
            if(samepoiint){
                continue
            }

            let newid


            newid=ids[0]+1


            virtrualNodes.splice(newid,0,vnode)

            for (let n=0;n<linesToCheck.length;n++){
                if(linesToCheck[n].ids[0]>=newid){
                    linesToCheck[n].ids[0]=linesToCheck[n].ids[0]+1
                }
                if(linesToCheck[n].ids[1]>=newid){
                    linesToCheck[n].ids[1]=linesToCheck[n].ids[1]+1
                }
            }
            // virtrualNodes.push(vnode)
            linesToCheck.push({
                start:startp,
                end:vnode,
                ids:[ids[0],newid]
            })
            linesToCheck.push({
                start:vnode,
                end:endp,
                ids:[newid,ids[1]+1]
            })

            // console.log(linesToCheck)

        }

        virtrualNodes.pop()
        virtrualNodes.splice(0,1)
        edge.virtrualNodes=virtrualNodes
        if(virtrualNodes.length==0){
            edge.virtrual=false
        }
        return edge
    }

    hasLinked(index1,index2){
        for(let i=0;i<this.edges.length;i++){
            let edge=this.edges[i]
            if(edge.start==index1&&edge.end==index2){
                return true
            }
            if(edge.start==index2&&edge.end==index1){
                return true
            }
        }
        return false
    }
    addEdge(index1,index2,cat){
        let that=this
        let newedge={
            start:index1,
            end:index2,
            weight:-1,
            cat:cat,
            dis:-1,
            virtrual:false,
            virtrualNodes:[],
            id:this.edges.length,
            isLocalTree:false
        }
        newedge=this.surfaceRoutingEdge(newedge)

        let crossnum=0
        let start = this.pointData[index1]
        let end = this.pointData[index2]
        for(let e=0;e<this.edges.length;e++){
            let e1=this.pointData[this.edges[e].start]
            let e2=this.pointData[this.edges[e].end]
            if(e1.cat!=start.cat&&e1.cat!=end.cat&&this.checkEdgeCrossing(start,end,e1,e2)){
                crossnum+=1
            }
        }
        //cal distance
        let distance=this.calDistance(start, end)
        //cal num of other points
        let mess=this.calEdgeMess(start, end)
        let score=weightCross*crossnum+weightDistance*distance/this.maxDis+weightMess*mess
        newedge.score = score

        this.edges.push(newedge)

        this.drawOneEdge(newedge.id)
    }

    drawOneEdge(index){

        this.edges[index].SVGElement=[]
        let oneEdge=this.edges[index]
        let that=this

        function dragstartControlpoint(){
            let index=parseInt(d3.select(this).attr("edgeindex"))
            //console.log("drag start control point!")
            //console.log(index)
            editEdges = []
            let tmpe = clone(that.edges[index])
            tmpe.startpoint = clone(that.pointData[that.edges[index].start])
            tmpe.endpoint = clone(that.pointData[that.edges[index].end])
            tmpe.flag = false
            editEdges.push(tmpe)
        }
        function draggedControlPoint(event){
            let edgeindex=parseInt(d3.select(this).attr("edgeindex"))
            let segindex=parseInt(d3.select(this).attr("segindex"))
            that.edges[edgeindex].virtrualNodes[segindex][0]=event.x
            that.edges[edgeindex].virtrualNodes[segindex][1]=event.y
            let idx = "#" + d3.select(this).attr("id")
            //console.log("dragged control point")
            //console.log(idx)
            d3.selectAll(idx)
                .attr("cx",event.x)
                .attr("cy",event.y)
            d3.selectAll("line")
                .filter(function(){
                    return parseInt(d3.select(this).attr("index"))==edgeindex&&parseInt(d3.select(this).attr("segindex"))==segindex
                })
                .attr("x2",event.x)
                .attr("y2",event.y)
            d3.selectAll("line")
                .filter(function(){
                    return parseInt(d3.select(this).attr("index"))==edgeindex&&parseInt(d3.select(this).attr("segindex"))==segindex+1
                })
                .attr("x1",event.x)
                .attr("y1",event.y)
        }
        function dragendControlPoint(){
            let index=parseInt(d3.select(this).attr("edgeindex"))
            //console.log("drag end control point!")
            //console.log(index)
            let tmpe = clone(that.edges[index])
            tmpe.id = index
            tmpe.flag = true
            editEdges.push(tmpe)

            that.setState({
                pointData: that.pointData
            })

            that.setState({
                edges: that.edges
            })

            if(that.child.bubbleState()){
                that.child.editReDraw(editPoints, editEdges, that.pointData, that.edges)
            }

            editPoints = []
            editEdges = []
        }

        var dragControlPoint = d3.drag()
            .on("start",dragstartControlpoint)
            .on("drag",draggedControlPoint)
            .on("end",dragendControlPoint)

        function dragstartEdge(event){
            // console.log("start!")
            let index=parseInt(d3.select(this).attr("index"))

            let start=that.pointData[that.edges[index].start]
            let end=that.pointData[that.edges[index].end]

            editEdges = []
//
            let tmpe = clone(that.edges[index])
            tmpe.startpoint = clone(start)
            tmpe.endpoint = clone(end)
            tmpe.flag = false
            editEdges.push(tmpe)

            d3.selectAll("line")
                .filter(function(){
                    return parseInt(d3.select(this).attr("index"))==index
                })
                .attr("stroke","red")

            if(d3.select(this).attr("isvirtrual")=="true"){
                let segindex=parseInt(d3.select(this).attr("segindex"))
                that.edges[index].virtrualNodes.splice(segindex,0,[event.x,event.y])
                that.draggedEdgeIndex=index
                that.draggedEdgeSeg=segindex
            }
            else{
                that.edges[index].virtrual=true
                that.edges[index].virtrualNodes.push([event.x,event.y])
                that.draggedEdgeIndex=index
                that.draggedEdgeSeg=0
            }

            d3.selectAll("line")
                .filter(function(){
                    return parseInt(d3.select(this).attr("index"))==index
                })
                .remove()

            /*            for (let j=0;j<that.edges[index].SVGElement.length;j++){
                            that.edges[index].SVGElement[j].remove()
                        }*/

            that.edges[index].SVGElement=[]

            let vpoints=that.edges[index].virtrualNodes
            let nowp=[start.x,start.y]
            let nextp=[]
            for(let i=0;i<vpoints.length;i++){
                nextp=vpoints[i]
                let newedge=d3.select(svgid).select("#edgeGroup")
                    .append("line")
                    .attr("x1",nowp[0])
                    .attr("y1",nowp[1])
                    .attr("x2",nextp[0])
                    .attr("y2",nextp[1])
                    .attr("stroke-width",2)
                    .attr("stroke","black")
                    .attr("index",index)
                    .attr("isvirtrual",true)
                    .attr("segindex",i)
                    .on("mouseover",function(d,i){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("stroke","red")
                    })
                    .on("mouseout",function(){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("stroke","black")
                    })
                    .on("mousedown",handleMouseDown)
                    .call(dragEdge)


                d3.select(opsvgid).select("#edgeGroup")
                    .append("line")
                    .attr("x1",nowp[0])
                    .attr("y1",nowp[1])
                    .attr("x2",nextp[0])
                    .attr("y2",nextp[1])
                    .attr("stroke-width",2)
                    .attr("stroke","black")
                    .attr("index",index)
                    .attr("isvirtrual",true)
                    .attr("segindex",i)
                    .on("mouseover",function(d,i){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("stroke","red")
                    })
                    .on("mouseout",function(){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("stroke","black")
                    })
                    .on("mousedown",handleMouseDown)
                    .call(dragEdge)

                that.edges[index].SVGElement.push(newedge)
                nowp=nextp
            }
            let newline=d3.select(svgid).select("#edgeGroup")
                .append("line")
                .attr("x1",nowp[0])
                .attr("y1",nowp[1])
                .attr("x2",end.x)
                .attr("y2",end.y)
                .attr("stroke-width",2)
                .attr("stroke","black")
                .attr("index",index)
                .attr("isvirtrual",true)
                .attr("segindex",vpoints.length)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","red")
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","black")
                })
                .on("mousedown",handleMouseDown)

                .call(dragEdge)

            d3.select(opsvgid).select("#edgeGroup")
                .append("line")
                .attr("x1",nowp[0])
                .attr("y1",nowp[1])
                .attr("x2",end.x)
                .attr("y2",end.y)
                .attr("stroke-width",2)
                .attr("stroke","black")
                .attr("index",index)
                .attr("isvirtrual",true)
                .attr("segindex",vpoints.length)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","red")
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","black")
                })
                .on("mousedown",handleMouseDown)

                .call(dragEdge)


            that.edges[index].SVGElement.push(newline)


            for (let v=0;v<vpoints.length;v++){
                d3.select(svgid)
                    .select("#edgeGroup")
                    .append("circle")
                    .attr("class","controlPoints")
                    .attr("cx",vpoints[v][0])
                    .attr("cy",vpoints[v][1])
                    .attr("r",5)
                    .attr("fill","red")
                    .attr("opacity",0)
                    .attr("edgeindex",index)
                    .attr("segindex",v)
                    .attr("id","e"+index.toString()+"s"+v.toString())
                    // .attr("display","none")
                    .on("mouseover",function(){
                        let idx = "#" + d3.select(this).attr("id")
                        d3.selectAll(idx).attr("opacity",1)
                    })
                    .on("mouseout",function(){
                        let idx = "#" + d3.select(this).attr("id")
                        d3.selectAll(idx).attr("opacity",0)
                    })
                    .call(dragControlPoint)

                d3.select(opsvgid)
                    .select("#edgeGroup")
                    .append("circle")
                    .attr("class","controlPoints")
                    .attr("cx",vpoints[v][0])
                    .attr("cy",vpoints[v][1])
                    .attr("r",5)
                    .attr("fill","red")
                    .attr("opacity",0)
                    .attr("edgeindex",index)
                    .attr("segindex",v)
                    .attr("id","e"+index.toString()+"s"+v.toString())
                    // .attr("display","none")
                    .on("mouseover",function(){
                        let idx = "#" + d3.select(this).attr("id")
                        d3.selectAll(idx).attr("opacity",1)
                    })
                    .on("mouseout",function(){
                        let idx = "#" + d3.select(this).attr("id")
                        d3.selectAll(idx).attr("opacity",0)
                    })
                    .call(dragControlPoint)

            }

        }


        function draggedEdge(event){
            // console.log("drag!")
            if(that.draggedEdgeIndex==-1)
                return
            event.sourceEvent.stopPropagation();
            let edgeIndex=that.draggedEdgeIndex
            let segIndex=that.draggedEdgeSeg

            that.edges[edgeIndex].virtrualNodes[segIndex][0]=event.x
            that.edges[edgeIndex].virtrualNodes[segIndex][1]=event.y

            d3.selectAll("line")
                .filter(function(){
                    let thisedgeindex=parseInt(d3.select(this).attr("index"))
                    let thissegindex=parseInt(d3.select(this).attr("segindex"))

                    return thisedgeindex==that.draggedEdgeIndex&&thissegindex==that.draggedEdgeSeg
                })
                // .attr("stroke","blue")
                .attr("x2",event.x)
                .attr("y2",event.y)

            d3.selectAll("line")
                .filter(function(){
                    let thisedgeindex=parseInt(d3.select(this).attr("index"))
                    let thissegindex=parseInt(d3.select(this).attr("segindex"))
                    return thisedgeindex==that.draggedEdgeIndex&&thissegindex==that.draggedEdgeSeg+1
                })
                // .attr("stroke","blue")
                .attr("x1",event.x)
                .attr("y1",event.y)

            d3.selectAll(".controlPoints")
                .filter(function(){
                    let thisedgeindex=parseInt(d3.select(this).attr("edgeindex"))
                    let thissegindex=parseInt(d3.select(this).attr("segindex"))
                    return thisedgeindex==that.draggedEdgeIndex&&thissegindex==that.draggedEdgeSeg
                })
                // .attr("stroke","blue")
                .attr("cx",event.x)
                .attr("cy",event.y)

        }

        function dragendEdge(event){
            // console.log("end!")
            let i = that.draggedEdgeIndex
            let tmpe = clone(that.edges[i])
            tmpe.id = i
            tmpe.flag = true
            editEdges.push(tmpe)

            that.setState({
                pointData: that.pointData
            })

            that.setState({
                edges: that.edges
            })

            if(that.child.bubbleState()){
                that.child.editReDraw(editPoints, editEdges, that.pointData, that.edges)
            }
//
//
            editPoints = []
            editEdges = []


            that.draggedEdgeSeg=-1
            that.draggedEdgeIndex=-1
            //that.child.getData()
        }

        var dragEdge = d3.drag()
            .on("start",dragstartEdge)
            .on("drag",draggedEdge)
            .on("end",dragendEdge)

        function handleMouseDown(event){
            if(event.button==2){
                that.setState({
                    hasEdit:true
                })
                let deleteindex=parseInt(d3.select(this).attr("index"))
                let start=that.edges[deleteindex].start
                let end=that.edges[deleteindex].end

                let tmpe = clone(that.edges[deleteindex])
                tmpe.startpoint = clone(that.pointData[start])
                tmpe.endpoint = clone(that.pointData[end])
                tmpe.flag = false
                editEdges.push(tmpe)

                that.setState({
                    pointData: that.pointData
                })

                that.setState({
                    edges: that.edges
                })

                if(that.child.bubbleState()){
                    //console.log("delete one edge")
                    //console.log(editEdges)
                    that.child.editReDraw(editPoints, editEdges, that.pointData, that.edges)
                }


                editPoints = []
                editEdges = []

                that.deletedEdge.push([start,end])
                that.deleteEdge(deleteindex)

                that.optimizeMST(true)

                for (var k in that.catPointDict){
                    that.findCircle(k)
                }
                // console.log(that.edges.length)
                /*                d3.select(svgid).select("#edgeGroup")
                                    .selectAll("line")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("index"))==deleteindex
                                    })
                                    .remove()
                                d3.select(svgid).select("#edgeGroup")
                                    .selectAll(".controlPoints")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("edgeindex"))==deleteindex
                                    })
                                    .remove()

                                d3.select(svgid)
                                    .select("#edgeGroup")
                                    .selectAll(".controlPoints")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("edgeindex"))>deleteindex
                                    })
                                    .attr("edgeindex",function(){
                                        return parseInt(d3.select(this).attr("edgeindex"))-1
                                    })

                                d3.select(svgid)
                                    .select("#edgeGroup")
                                    .selectAll("line")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("index"))>deleteindex
                                    })
                                    .attr("index",function(){
                                        return parseInt(d3.select(this).attr("index"))-1
                                    })
                                that.edges.splice(deleteindex,1)

                                for (let i=0;i<that.edges.length;i++){
                                    that.edges[i].id=i
                                }*/
            }
            //else if(event.button == 1){
            //    that.child.handleEdgeWidth(event, this)
            //}
        }

        let start=oneEdge.start
        let end=oneEdge.end

        // this.nodeStartDict[start].push(i)
        // this.nodeEndDict[end].push(i)
        // this.nodeStartDict[start].push(i)
        // this.nodeEndDict[end].push(i)

        if(oneEdge.virtrual){
            let vpoints=oneEdge.virtrualNodes
            let vstart=[this.pointData[start].x,this.pointData[start].y]
            let vend
            for (let v=0;v<vpoints.length;v++){
                vend=vpoints[v]
                let newline=d3.select(svgid)
                    .select("#edgeGroup")
                    .append("line")
                    .attr("x1",vstart[0])
                    .attr("y1",vstart[1])
                    .attr("x2",vend[0])
                    .attr("y2",vend[1])
                    .attr("stroke-width",2)
                    .attr("stroke","black")
                    .attr("index",index)
                    .attr("isvirtrual",true)
                    .attr("segindex",v)
                    .on("mouseover",function(d,i){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("stroke","red")
                    })
                    .on("mouseout",function(){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("stroke","black")
                            .attr("stroke-width",2)
                    })
                    .on("mousedown",handleMouseDown)

                    .call(dragEdge)

                d3.select(opsvgid)
                    .select("#edgeGroup")
                    .append("line")
                    .attr("x1",vstart[0])
                    .attr("y1",vstart[1])
                    .attr("x2",vend[0])
                    .attr("y2",vend[1])
                    .attr("stroke-width",2)
                    .attr("stroke","black")
                    .attr("index",index)
                    .attr("isvirtrual",true)
                    .attr("segindex",v)
                    .on("mouseover",function(d,i){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("stroke","red")
                    })
                    .on("mouseout",function(){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("stroke","black")
                            .attr("stroke-width",2)
                    })
                    .on("mousedown",handleMouseDown)

                    .call(dragEdge)
                vstart=vend
                this.edges[index].SVGElement.push(newline)
            }
            vend=[this.pointData[end].x,this.pointData[end].y]
            let newline=d3.select(svgid)
                .select("#edgeGroup")
                .append("line")
                .attr("x1",vstart[0])
                .attr("y1",vstart[1])
                .attr("x2",vend[0])
                .attr("y2",vend[1])
                .attr("stroke-width",2)
                .attr("stroke","black")
                .attr("index",index)
                .attr("isvirtrual",true)
                .attr("segindex",vpoints.length)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","red")
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","black")
                        .attr("stroke-width",2)
                })
                .on("mousedown",handleMouseDown)
                .call(dragEdge)

            d3.select(opsvgid)
                .select("#edgeGroup")
                .append("line")
                .attr("x1",vstart[0])
                .attr("y1",vstart[1])
                .attr("x2",vend[0])
                .attr("y2",vend[1])
                .attr("stroke-width",2)
                .attr("stroke","black")
                .attr("index",index)
                .attr("isvirtrual",true)
                .attr("segindex",vpoints.length)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","red")
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","black")
                        .attr("stroke-width",2)
                })
                .on("mousedown",handleMouseDown)
                .call(dragEdge)

            this.edges[index].SVGElement.push(newline)
            // console.log()
            for (let v=0;v<vpoints.length;v++){
                d3.select(svgid)
                    .select("#edgeGroup")
                    .append("circle")
                    .attr("class","controlPoints")
                    .attr("cx",vpoints[v][0])
                    .attr("cy",vpoints[v][1])
                    .attr("r",5)
                    .attr("edgeindex",index)
                    .attr("segindex",v)
                    .attr("fill","red")
                    .attr("opacity",0)
                    .attr("id","e" + index.toString() + "s" + v.toString())
                    // .attr("display","none")
                    .on("mouseover",function(){
                        let idx = "#" + d3.select(this).attr("id")
                        d3.selectAll(idx).attr("opacity",1)
                    })
                    .on("mouseout",function(){
                        let idx = "#" + d3.select(this).attr("id")
                        d3.selectAll(idx).attr("opacity",0)
                    })
                    .call(dragControlPoint)

                d3.select(opsvgid)
                    .select("#edgeGroup")
                    .append("circle")
                    .attr("class","controlPoints")
                    .attr("cx",vpoints[v][0])
                    .attr("cy",vpoints[v][1])
                    .attr("r",5)
                    .attr("edgeindex",index)
                    .attr("segindex",v)
                    .attr("fill","red")
                    .attr("opacity",0)
                    .attr("id","e" + index.toString() + "s" + v.toString())
                    // .attr("display","none")
                    .on("mouseover",function(){
                        let idx = "#" + d3.select(this).attr("id")
                        d3.selectAll(idx).attr("opacity",1)
                    })
                    .on("mouseout",function(){
                        let idx = "#" + d3.select(this).attr("id")
                        d3.selectAll(idx).attr("opacity",0)
                    })
                    .call(dragControlPoint)

            }
        }
        else{
            let newline=d3.select(svgid)
                .select("#edgeGroup")
                .append("line")
                .attr("x1",this.pointData[start].x)
                .attr("y1",this.pointData[start].y)
                .attr("x2",this.pointData[end].x)
                .attr("y2",this.pointData[end].y)
                .attr("stroke-width",2)
                .attr("stroke","black")
                .attr("index",index)
                .attr("isvirtrual",false)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","red")
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","black")
                        .attr("stroke-width",2)
                })
                .on("mousedown",handleMouseDown)
                .call(dragEdge)


            d3.select(opsvgid)
                .select("#edgeGroup")
                .append("line")
                .attr("x1",this.pointData[start].x)
                .attr("y1",this.pointData[start].y)
                .attr("x2",this.pointData[end].x)
                .attr("y2",this.pointData[end].y)
                .attr("stroke-width",2)
                .attr("stroke","black")
                .attr("index",index)
                .attr("isvirtrual",false)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","red")
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","black")
                        .attr("stroke-width",2)
                })
                .on("mousedown",handleMouseDown)
                .call(dragEdge)

            this.edges[index].SVGElement.push(newline)
        }

    }

    applyEdit(){
        this.edges=this.tempEdges
        this.deletedEdge=[]
        this.addedEdge=[]

        this.drawEdges()
        this.setState({
            hasEdit:false,
            edges:this.edges,
            pointData:this.pointData
        })

        //console.log("applyEdit")
        //console.log(tmpEditEdges)
        //console.log(this.edges)

        //let tmprealEditEdges = []
//
        //for(let i = 0; i < this.edges.length;i ++){
        //    for(let j = 0; j < tmpEditEdges.length; j ++){
        //        if(this.edges[i].start == tmpEditEdges[j].start && this.edges[i].end == tmpEditEdges[j].end){
        //            let tmpe = clone(this.edges[i])
        //            tmpe.flag = true
        //            tmpe.id = i
        //            tmprealEditEdges.push(tmpe)
        //            break;
        //        }
        //    }
        //}

        if(this.child.bubbleState()){
            this.child.editReDraw([], tmpEditEdges, this.pointData, this.edges)
        }

        tmpEditEdges = []
    }

    drawOneEdgeAfterEdit(edges,index){

        edges[index].SVGElement=[]
        let oneEdge=edges[index]
        let that=this

        let start=oneEdge.start
        let end=oneEdge.end
        function handleMouseDown(event){
            if(event.button==2){
                let deleteindex=parseInt(d3.select(this).attr("index"))
                d3.selectAll(".deleteOpEdge")
                    .filter(function(){
                        return parseInt(d3.select(this).attr("index"))==deleteindex
                    })
                    .remove()
                let start=edges[deleteindex].start
                let end=edges[deleteindex].end
                that.deletedEdge.push([start,end])

                // that.deleteEdge(deleteindex)
                that.optimizeMST(true)
                // console.log(that.edges.length)
                /*                d3.select(svgid).select("#edgeGroup")
                                    .selectAll("line")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("index"))==deleteindex
                                    })
                                    .remove()
                                d3.select(svgid).select("#edgeGroup")
                                    .selectAll(".controlPoints")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("edgeindex"))==deleteindex
                                    })
                                    .remove()

                                d3.select(svgid)
                                    .select("#edgeGroup")
                                    .selectAll(".controlPoints")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("edgeindex"))>deleteindex
                                    })
                                    .attr("edgeindex",function(){
                                        return parseInt(d3.select(this).attr("edgeindex"))-1
                                    })

                                d3.select(svgid)
                                    .select("#edgeGroup")
                                    .selectAll("line")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("index"))>deleteindex
                                    })
                                    .attr("index",function(){
                                        return parseInt(d3.select(this).attr("index"))-1
                                    })
                                that.edges.splice(deleteindex,1)

                                for (let i=0;i<that.edges.length;i++){
                                    that.edges[i].id=i
                                }*/
            }
        }

        // this.nodeStartDict[start].push(i)
        // this.nodeEndDict[end].push(i)
        // this.nodeStartDict[start].push(i)
        // this.nodeEndDict[end].push(i)

        if(oneEdge.virtrual){
            let vpoints=oneEdge.virtrualNodes
            let vstart=[this.pointData[start].x,this.pointData[start].y]
            let vend
            for (let v=0;v<vpoints.length;v++){
                vend=vpoints[v]
                let newline=d3.select(svgid)
                    .select("#edgeGroup")
                    .append("line")
                    .attr("class","deleteOpEdge")
                    .attr("x1",vstart[0])
                    .attr("y1",vstart[1])
                    .attr("x2",vend[0])
                    .attr("y2",vend[1])
                    .attr("stroke-width",5)
                    .attr("stroke","red")
                    .attr("stroke-dasharray","5,3")
                    .attr("opacity",0.5)
                    .attr("index",index)
                    .attr("isvirtrual",true)
                    .attr("segindex",v)
                    .on("mouseover",function(d,i){
                        let thisindex=d3.select(this).attr("index")
                        d3.select(svgid).select("#edgeGroup").selectAll(".deleteOpEdge")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("opacity",1)
                    })
                    .on("mouseout",function(){
                        let thisindex=d3.select(this).attr("index")
                        d3.select(svgid).select("#edgeGroup").selectAll(".deleteOpEdge")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("opacity",0.5)
                    })
                    .on("mousedown",handleMouseDown)

                d3.select(opsvgid)
                    .select("#edgeGroup")
                    .append("line")
                    .attr("class","deleteOpEdge")
                    .attr("x1",vstart[0])
                    .attr("y1",vstart[1])
                    .attr("x2",vend[0])
                    .attr("y2",vend[1])
                    .attr("stroke-width",5)
                    .attr("stroke","red")
                    .attr("stroke-dasharray","5,3")
                    .attr("opacity",0.5)
                    .attr("index",index)
                    .attr("isvirtrual",true)
                    .attr("segindex",v)
                    .on("mouseover",function(d,i){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll(".deleteOpEdge")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("opacity",1)
                    })
                    .on("mouseout",function(){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll(".deleteOpEdge")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("opacity",0.5)
                    })
                    .on("mousedown",handleMouseDown)

                vstart=vend
            }
            vend=[this.pointData[end].x,this.pointData[end].y]
            let newline=d3.select(svgid)
                .select("#edgeGroup")
                .append("line")
                .attr("class","deleteOpEdge")
                .attr("x1",vstart[0])
                .attr("y1",vstart[1])
                .attr("x2",vend[0])
                .attr("y2",vend[1])
                .attr("stroke-width",5)
                .attr("stroke","red")
                .attr("stroke-dasharray","5,3")
                .attr("opacity",0.5)
                .attr("index",index)
                .attr("isvirtrual",true)
                .attr("segindex",vpoints.length)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll(".deleteOpEdge")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("opacity",1)
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll(".deleteOpEdge")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("opacity",0.5)
                })
                .on("mousedown",handleMouseDown)

            d3.select(opsvgid)
                .select("#edgeGroup")
                .append("line")
                .attr("class","deleteOpEdge")
                .attr("x1",vstart[0])
                .attr("y1",vstart[1])
                .attr("x2",vend[0])
                .attr("y2",vend[1])
                .attr("stroke-width",5)
                .attr("stroke","red")
                .attr("stroke-dasharray","5,3")
                .attr("opacity",0.5)
                .attr("index",index)
                .attr("isvirtrual",true)
                .attr("segindex",vpoints.length)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll(".deleteOpEdge")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("opacity",1)
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll(".deleteOpEdge")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("opacity",0.5)
                })
                .on("mousedown",handleMouseDown)

            // console.log()
        }
        else{
            let newline=d3.select(svgid)
                .select("#edgeGroup")
                .append("line")
                .attr("class","deleteOpEdge")
                .attr("x1",this.pointData[start].x)
                .attr("y1",this.pointData[start].y)
                .attr("x2",this.pointData[end].x)
                .attr("y2",this.pointData[end].y)
                .attr("stroke-width",5)
                .attr("stroke","red")
                .attr("stroke-dasharray","5,2")
                .attr("opacity",0.5)
                .attr("index",index)
                .attr("isvirtrual",false)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll(".deleteOpEdge")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("opacity",1)
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll(".deleteOpEdge")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("opacity",0.5)
                })
                .on("mousedown",handleMouseDown)


            d3.select(opsvgid)
                .select("#edgeGroup")
                .append("line")
                .attr("class","deleteOpEdge")
                .attr("x1",this.pointData[start].x)
                .attr("y1",this.pointData[start].y)
                .attr("x2",this.pointData[end].x)
                .attr("y2",this.pointData[end].y)
                .attr("stroke-width",5)
                .attr("stroke","red")
                .attr("stroke-dasharray","5,2")
                .attr("opacity",0.5)
                .attr("index",index)
                .attr("isvirtrual",false)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll(".deleteOpEdge")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("opacity",1)
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll(".deleteOpEdge")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("opacity",0.5)
                })
                .on("mousedown",handleMouseDown)
        }


    }

    checkCircle(k){
        let catEdges=[]
        let nodeDegree={}
        for (let i=0;i<this.edges.length;i++){
            if(this.edges[i].cat==k){
                catEdges.push(this.edges[i])
                let start=this.edges[i].start
                let end=this.edges[i].end
                if(!nodeDegree.hasOwnProperty(start)){
                    nodeDegree[start]=[]
                }
                nodeDegree[start].push(i)
                if(!nodeDegree.hasOwnProperty(end)){
                    nodeDegree[end]=[]
                }
                nodeDegree[end].push(i)
            }
        }
        let finish=false
        while(!finish){
            finish=true
            for(var p in nodeDegree){
                if(nodeDegree[p].length==1){
                    finish=false
                    let index=nodeDegree[p][0]
                    let start=this.edges[index].start
                    let end=this.edges[index].end
                    for (let i=0;i<nodeDegree[start].length;i++){
                        if(nodeDegree[start][i]==index){
                            nodeDegree[start].splice(i,1)
                            break
                        }
                    }
                    for (let i=0;i<nodeDegree[end].length;i++){
                        if(nodeDegree[end][i]==index){
                            nodeDegree[end].splice(i,1)
                            break
                        }
                    }
                }
            }
        }
        let circleEdges=[]
        for (var p in nodeDegree){
            if(nodeDegree[p].length>0){
                for (let i=0;i<nodeDegree[p].length;i++){
                    let edgeindex=nodeDegree[p][i]
                    let has=false
                    for (let j=0;j<circleEdges.length;j++){
                        if(circleEdges[j]==edgeindex){
                            has=true
                            break
                        }
                    }
                    if(!has){
                        circleEdges.push(edgeindex)
                    }
                }
            }

        }
        // console.log(nodeDegree,circleEdges)
        return circleEdges
    }

    findCircle(lastcat){
        let that=this
        let circleEdges=that.checkCircle(lastcat)
        if(circleEdges.length>0){
            let scores=[]
            for (let i=0;i<circleEdges.length;i++){
                let index=circleEdges[i]

                let start=that.pointData[that.edges[index].start]
                let end=that.pointData[that.edges[index].end]
                let crossnum=0
                if(that.isAdded(that.edges[index].start,that.edges[index].end)){
                    scores.push(-1)
                }
                else{
                    for (let e=0;e<that.edges.length;e++){
                        let e1=that.pointData[that.edges[e].start]
                        let e2=that.pointData[that.edges[e].end]
                        if(e1.cat!=start.cat&&e1.cat!=end.cat&&that.checkEdgeCrossing(start,end,e1,e2)){
                            crossnum+=1
                        }
                    }
                    //cal distance
                    let distance=that.calDistance(start,end)
                    //cal num of other points
                    let mess=that.calEdgeMess(start,end)
                    let score=weightCross*crossnum+weightDistance*distance/that.maxDis+weightMess*mess
                    scores.push(score)
                }

                /*                                    d3.select(svgid)
                                                        .select("#edgeGroup")
                                                        .selectAll("line")
                                                        .filter(function(){
                                                            return parseInt(d3.select(this).attr("index"))==index
                                                        })
                                                        .attr("stroke","blue")
                                                        .on("mouseover",function(){
                                                            console.log(scores[i])
                                                        })*/
            }

            let worstindex=-1
            let worstscore=-100
            for (let i=0;i<scores.length;i++){
                if(scores[i]>worstscore){
                    worstscore=scores[i]
                    worstindex=i
                }
            }
            let worstEdge=that.edges[circleEdges[worstindex]]

            //let tmpe = clone(worstEdge)
            //tmpe.startpoint = clone(worstEdge.start)
            //tmpe.endpoint = clone(worstEdge.end)
            //tmpe.flag = false
            //tmpEditEdges.push(tmpe)


            //console.log("WorstEdge: ")
            //console.log(circleEdges)
            //console.log(worstEdge)
            //console.log(that.edges)

            d3.selectAll("line")
                .filter(function(){
                    return parseInt(d3.select(this).attr("index"))==worstEdge.id
                })
                .attr("stroke","red")
                .attr("stroke-width",5)
            // console.log(weightMess)

        }
    }

    drawPointData(){
        colors = this.props.colorArray
        this.setState({
            colorArray:colors
        })

        d3.selectAll("circle").remove();
        d3.selectAll("rect").remove();
        svg = d3.select(svgid);
        svg.call(d3.zoom()
            .extent([[offsetX, offsetY], [viewWidth, viewHeight]])
            .scaleExtent([1, 8])
            .on("zoom", zoomed));

        var reroutingEPS=80

        function zoomed({transform}) {
            d3.selectAll('g').attr("transform", transform);
        }

        let that=this

        function dragged(event) {
            let svg=d3.select(svgid)
            let nodeindex=parseInt(d3.select(this).attr("index"))

            // console.log(POINT_EDGE_EPS,DBSCAN_EPS)
            if(that.itemShape=="circle"){
                let id = "#" + d3.select(this).attr("id")
                d3.selectAll(id)
                    .attr("cx",event.x)
                    .attr("cy",event.y)
            }
            else{
                let w=that.pointData[nodeindex].width
                let h=that.pointData[nodeindex].height
                let id = "#" + d3.select(this).attr("id")
                d3.selectAll(id)
                    .attr("x",event.x-0.5*w)
                    .attr("y",event.y-0.5*h)
            }

            //let tmpp1 = clone(that.pointData[nodeindex])
            //tmpp1.flag = false;
            //editPoints.push(tmpp1)
            //subOldPoints.push(tmpp1)

            that.pointData[nodeindex].x=event.x
            that.pointData[nodeindex].y=event.y

            //let tmpp = clone(that.pointData[nodeindex])
            //tmpp.id = nodeindex
            //tmpp.flag = true
            //editPoints.push(tmpp)
            //addNewPoints.push(tmpp)

            let deleteEdges=[]
            let reroutingEdges=[]
            let thiscat=that.pointData[nodeindex].cat
            for(let i=0;i<that.edges.length;i++){
                let startpoint=that.pointData[that.edges[i].start]
                let endpoint=that.pointData[that.edges[i].end]
                let pointedgedis=PointToSegDist(event.x,event.y,startpoint.x,startpoint.y,endpoint.x,endpoint.y)
                if(that.edges[i].start==nodeindex){
                    deleteEdges.push(i)

                    //let tmpe = clone(that.edges[i])
                    //tmpe.startpoint = clone(tmpp1)
                    //tmpe.endpoint = clone(that.pointData[tmpe.end])
                    //tmpe.flag = false;
                    //editEdges.push(tmpe)
                    //subOldEdges.push(tmpe)

                }
                else if(that.edges[i].end==nodeindex){
                    deleteEdges.push(i)

                    //let tmpe = clone(that.edges[i])
                    //tmpe.startpoint = clone(that.pointData[tmpe.start]);
                    //tmpe.endpoint = clone(tmpp1)
                    //tmpe.flag = false;
                    ////subOldEdges.push(tmpe)
                    //editEdges.push(tmpe)
                }
                else if((thiscat==that.edges[i].cat&&pointedgedis>=0&&pointedgedis<POINT_EDGE_EPS*2)){
                    deleteEdges.push(i)

                    //let tmpe = clone(that.edges[i])
                    //tmpe.startpoint = clone(that.pointData[tmpe.start]);
                    //tmpe.endpoint = clone(that.pointData[tmpe.end]);
                    //tmpe.flag = false;
                    //editEdges.push(tmpe)
                    ////subOldEdges.push(tmpe)
                }
                else if(thiscat!=that.edges[i].cat&&pointedgedis>=0&&pointedgedis<POINT_EDGE_EPS*2){
                    reroutingEdges.push(i)

                    //let tmpe = clone(that.edges[i])
                    //tmpe.startpoint = clone(that.pointData[tmpe.start]);
                    //tmpe.endpoint = clone(that.pointData[tmpe.end]);
                    //tmpe.flag = false;
                    //editEdges.push(tmpe)
                    ////subOldEdges.push(tmpe)
                }
            }

            // console.log(deleteEdges)

            for(let i=0;i<deleteEdges.length;i++){
                that.deleteEdge(deleteEdges[i])
                for(let j=i+1;j<deleteEdges.length;j++){
                    if(deleteEdges[i]<deleteEdges[j]){
                        deleteEdges[j]=deleteEdges[j]-1
                    }
                }
                for(let j=i+1;j<reroutingEdges.length;j++){
                    if(deleteEdges[i]<reroutingEdges[j]){
                        reroutingEdges[j]=reroutingEdges[j]-1
                    }
                }
            }

            that.optimizeMST(false)

            for (let i=0;i<reroutingEdges.length;i++){


                let tmpe = clone(that.edges[reroutingEdges[i]])
                tmpe.startpoint = clone(that.pointData[tmpe.start])
                tmpe.endpoint = clone(that.pointData[tmpe.end])
                tmpe.flag = false
                that.edges[reroutingEdges[i]].preEdge = clone(tmpe)
                that.edges[reroutingEdges[i]].new = true
                that.edges[reroutingEdges[i]].rerouting = true


                that.surfaceRoutingEdge(that.edges[reroutingEdges[i]])
                d3.selectAll("line")
                    .filter(function(){
                        return parseInt(d3.select(this).attr("index"))==reroutingEdges[i]
                    })
                    .remove()
                d3.selectAll(".controlPoints")
                    .filter(function(){
                        return parseInt(d3.select(this).attr("edgeindex"))==reroutingEdges[i]
                    })
                    .remove()

                that.drawOneEdge(reroutingEdges[i])



                //let tmpe = clone(that.edges[reroutingEdges[i]])
                //tmpe.id = reroutingEdges[i]
                //tmpe.flag = true
                //editEdges.push(tmpe)
                // addNewEdges.push(tmpe)

            }

            //that.child.getData()
            //for(let idx1 = 0; idx1 < addNewPoints.length; idx1 ++){
            //    for(let idx2 = 0; idx2 < that.edges.length; idx2 ++){
            //        if(that.edges[idx2].start == addNewPoints[idx1].id || that.edges[idx2].end == addNewPoints[idx1].id){
            //            let tmpe = clone(that.edges[idx2])
            //            tmpe.id = idx2
            //            addNewEdges.push(tmpe)
            //            //console.log("flagflagflag")
            //        }
            //    }
            //}





            // d3.select(this).attr("stroke","none")

        }

        function dragstart() {
            // d3.select(this).classed("fixed", true);
            // that.draggedIndex=parseInt(d3.select(this).attr("index"))
            let nodeindex=parseInt(d3.select(this).attr("index"))
            that.draggedIndex=nodeindex

            preEdgeDict = {}
            preEdges = []
            for(let i = 0; i < that.edges.length; i ++){

                let st = that.edges[i].start
                let en = that.edges[i].end
                that.edges[i].new = false;
                that.edges[i].rerouting = false;
                that.edges[i].startpoint = clone(that.pointData[st])
                that.edges[i].endpoint = clone(that.pointData[en])

                if(!preEdgeDict.hasOwnProperty(st)){
                    preEdgeDict[st] = {}
                }
                preEdgeDict[st][en] = i

                preEdges.push(clone(that.edges[i]))
            }

            // add old point
            let tmpp1 = clone(that.pointData[nodeindex])
            prePoint = tmpp1
            tmpp1.flag = false
            editPoints.push(tmpp1)

            //preEdges = clone(that.edges)

            //delete linked edges
            /*            let newedges=[]
            let deleteindex=[]
            for(let i=0;i<that.edges.length;i++){
                let start=that.edges[i].start
                let end=that.edges[i].end
                if(start==nodeindex||end==nodeindex){
                    console.log(i)
                    d3.select(svgid)
                        .select("#edgeGroup")
                        .selectAll("line")
                        .filter(function(){
                            return parseInt(d3.select(this).attr("index"))==i
                        })
                        // .attr("stroke","red")
                        .remove()
                    deleteindex.push(i)
                    d3.select(svgid).select("#edgeGroup")
                        .selectAll(".controlPoints")
                        .filter(function(){
                            return parseInt(d3.select(this).attr("edgeindex"))==i
                        })
                        // .attr("opacity",1)
                        .remove()
                }
                else{
                    newedges.push(that.edges[i])
                }
            }
            let influencedEdges=[]
            let influencedControlPoints=[]
            for (let i=0;i<deleteindex.length;i++) {
                let idx=deleteindex[i]
                let inflines=d3.select(svgid)
                    .select("#edgeGroup")
                    .selectAll("line")
                    .filter(function(){
                        return parseInt(d3.select(this).attr("index"))>idx
                    })
                influencedEdges.push(inflines)

                let infpoints=d3.select(svgid)
                    .select("#edgeGroup")
                    .selectAll(".controlPoints")
                    .filter(function(){
                        return parseInt(d3.select(this).attr("edgeindex"))>idx
                    })
                influencedControlPoints.push(infpoints)
            }
                for (let i=0;i<influencedEdges.length;i++){
                    let infedges=influencedEdges[i]
                    infedges.attr("index",function(){
                        return parseInt(d3.select(this).attr("index"))-1
                    })
            }
                for(let i=0;i<influencedControlPoints.length;i++){
                    let infcpoints=influencedControlPoints[i]
                    infcpoints.attr("edgeindex",function(){
                            return parseInt(d3.select(this).attr("edgeindex"))-1
                        })
                }

            that.edges=newedges
            for(let i=0;i<that.edges.length;i++){
                that.edges[i].id=i
            }*/
            let id = "#" + d3.select(this).attr("id")
            d3.selectAll(id).attr("stroke","red")
        }

        function dragend(){
            let nodeindex = parseInt(d3.select(this).attr("index"))
            let id = "#" + d3.select(this).attr("id")
            d3.selectAll(id).attr("stroke","none")

            // add new point
            let tmpp = clone(that.pointData[nodeindex])
            tmpp.id = nodeindex
            tmpp.flag = true
            editPoints.push(tmpp)

            /*
            // delete old edges
            let thiscat = that.pointData[nodeindex].cat
            let ex = that.pointData[nodeindex].x
            let ey = that.pointData[nodeindex].y
            //let updateidx = {}
            for(let i = 0;i < preEdges.length; i ++){
                let startpoint=that.pointData[preEdges[i].start]
                let endpoint=that.pointData[preEdges[i].end]
                let pointedgedis=PointToSegDist(ex, ey, startpoint.x, startpoint.y, endpoint.x, endpoint.y)
                if(preEdges[i].start==nodeindex){

                    let tmpe = clone(preEdges[i])
                    tmpe.startpoint = clone(prePoint)
                    tmpe.endpoint = that.pointData[tmpe.end]
                    tmpe.flag = false
                    editEdges.push(tmpe)
                    //subOldEdges.push(tmpe)

                }
                else if(preEdges[i].end==nodeindex){

                    let tmpe = clone(preEdges[i])
                    tmpe.startpoint = that.pointData[tmpe.start]
                    tmpe.endpoint = clone(prePoint)
                    tmpe.flag = false
                    editEdges.push(tmpe)
                    //subOldEdges.push(tmpe)

                }
                else if((thiscat == preEdges[i].cat && pointedgedis >= 0 && pointedgedis < POINT_EDGE_EPS * 2)){

                    let tmpe = clone(preEdges[i])
                    tmpe.startpoint = that.pointData[tmpe.start]
                    tmpe.endpoint = that.pointData[tmpe.end]
                    tmpe.flag = false;
                    editEdges.push(tmpe)
                    //subOldEdges.push(tmpe)

                    //if(!updateidx.hasOwnProperty(preEdges[i].start)){
                    //    updateidx[preEdges[i].start] = {}
                    //}
//
                    //updateidx[preEdges[i].start][preEdges[i].end] = 2

                }

                //else if(thiscat != preEdges[i].cat && pointedgedis >= 0 && pointedgedis < POINT_EDGE_EPS * 2){
//
                //    let tmpe = clone(preEdges[i])
                //    tmpe.startpoint = that.pointData[tmpe.start]
                //    tmpe.endpoint = that.pointData[tmpe.end]
                //    tmpe.flag = false;
                //    editEdges.push(tmpe)
                //    //subOldEdges.push(tmpe)
//
                //    //if(!updateidx.hasOwnProperty(preEdges[i].start)){
                //    //    updateidx[preEdges[i].start] = {}
                //    //}
////
                //    //updateidx[preEdges[i].start][preEdges[i].end] = 2
//
                //}


            }

            // add new edges and rerouting edges
            for(let i = 0;i < that.edges.length; i ++){

                //if(that.edges[i].hasOwnProperty("new")){
                if(that.edges[i].new == true){
                    let tmpe = clone(that.edges[i])
                    tmpe.id = i
                    tmpe.flag = true
                    editEdges.push(tmpe)
                    if(that.edges[i].rerouting == true){
                        let tmpe = clone(that.edges[i].preEdge)
                        tmpe.flag = false
                        editEdges.push(tmpe)
                    }
                }
                //}


                //let s = that.edges[i].start
                //let e = that.edges[i].end
                //let flag = false;
                //if(s == nodeindex || e == nodeindex){
                //    flag = true
                //}
//
                //for(let st in updateidx){
                //    for(let en in updateidx[st]){
                //        if(s == st && e == en){
                //            flag = true
                //            break
                //        }
                //    }
                //}
//
                //if(flag){
                //    let tmpe = clone(that.edges[i])
                //    tmpe.id = i
                //    tmpe.flag = true
                //    editEdges.push(tmpe)
                //}


            }

             */

            editEdges = []
            curEdgeDict = {}

            // Add New Edges
            for(let i = 0; i < that.edges.length; i ++){
                let st = that.edges[i].start
                let en = that.edges[i].end
                if(!curEdgeDict.hasOwnProperty(st)){
                    curEdgeDict[st] = {}
                }
                curEdgeDict[st][en] = i
                let vnodes1 = clone(that.edges[i].virtrualNodes)
                if(vnodes1.length > 0){
                    vnodes1.sort(function (a,b){
                        return a[0] - b[0]
                    })
                }
                // same flag
                let flag = true
                // exist flag
                let flag1 = true
                // judge st --> en
                if(preEdgeDict.hasOwnProperty(st)){
                    if(preEdgeDict[st].hasOwnProperty(en)){
                        flag1 = false
                        // has same edge,
                        // then judge has re-routing or drag point?
                        // startpoint\endpoint\control points
                        let idx = preEdgeDict[st][en]
                        let st1_p = that.pointData[st]
                        let en1_p = that.pointData[en]
                        let st2_p = preEdges[idx].startpoint
                        let en2_p = preEdges[idx].endpoint
                        if( (parseInt(st1_p.x)==parseInt(st2_p.x)) && (parseInt(st1_p.y)==parseInt(st2_p.y)) && (parseInt(en1_p.x)==parseInt(en2_p.x)) && (parseInt(en1_p.y)==parseInt(en2_p.y)) ){

                            // then judge re-routing
                            let vnodes2 = clone(preEdges[idx].virtrualNodes)
                            if(vnodes1.length == vnodes2.length){
                                if(vnodes2.length > 0){
                                    vnodes2.sort(function (a,b){
                                        return a[0] - b[0]
                                    })
                                }
                                for(let j = 0; j < vnodes2.length; j ++){
                                    if((parseInt(vnodes1[j][0])==parseInt(vnodes2[j][0])) && (parseInt(vnodes1[j][1])==parseInt(vnodes2[j][1]))){
                                        continue;
                                    }
                                    else{
                                        flag = false
                                        break
                                    }
                                }
                            }
                            else{
                                flag = false
                            }

                        }
                        else{
                            flag = false
                        }
                    }
                }
                if(!flag){
                    let tmpe = clone(that.edges[i])
                    tmpe.id = i
                    tmpe.flag = true
                    editEdges.push(tmpe)
                    continue
                }
                //judge en --> st
                if(preEdgeDict.hasOwnProperty(en)){
                    if(preEdgeDict[en].hasOwnProperty(st)){
                        // has same edge,
                        // then judge has re-routing or drag poing?
                        flag1 = false
                        let idx = preEdgeDict[en][st]
                        let st1_p = that.pointData[st]
                        let en1_p = that.pointData[en]
                        let st2_p = preEdges[idx].endpoint
                        let en2_p = preEdges[idx].startpoint
                        if( (parseInt(st1_p.x)==parseInt(st2_p.x)) && (parseInt(st1_p.y)==parseInt(st2_p.y)) && (parseInt(en1_p.x)==parseInt(en2_p.x)) && (parseInt(en1_p.y)==parseInt(en2_p.y)) ){
                            // then judge re-routing
                            let vnodes2 = clone(preEdges[idx].virtrualNodes)
                            if(vnodes1.length == vnodes2.length){
                                if(vnodes2.length > 0){
                                    vnodes2.sort(function (a,b){
                                        return a[0] - b[0]
                                    })
                                }
                                for(let j = 0; j < vnodes2.length; j ++){
                                    if((parseInt(vnodes1[j][0])==parseInt(vnodes2[j][0])) && (parseInt(vnodes1[j][1])==parseInt(vnodes2[j][1]))){
                                        continue;
                                    }
                                    else{
                                        flag = false
                                        break
                                    }
                                }
                            }
                            else{
                                flag = false
                            }
                        }
                        else{
                            flag = false
                        }
                    }
                }
                if(!flag || flag1){
                    let tmpe = clone(that.edges[i])
                    tmpe.id = i
                    tmpe.flag = true
                    editEdges.push(tmpe)
                }
            }

            // Delete Old Edges
            for(let i = 0; i < preEdges.length; i ++){
                let st = preEdges[i].start
                let en = preEdges[i].end
                let vnodes1 = clone(preEdges[i].virtrualNodes)
                if(vnodes1.length > 0){
                    vnodes1.sort(function (a,b){
                        return a[0] - b[0]
                    })
                }
                let flag = true
                let flag1 = true
                if(curEdgeDict.hasOwnProperty(st)){
                    if(curEdgeDict[st].hasOwnProperty(en)){
                        flag1 = false
                        let idx = curEdgeDict[st][en]
                        let st1_p = preEdges[i].startpoint
                        let en1_p = preEdges[i].endpoint
                        let st2_p = that.pointData[st]
                        let en2_p = that.pointData[en]
                        if( (parseInt(st1_p.x)==parseInt(st2_p.x)) && (parseInt(st1_p.y)==parseInt(st2_p.y)) && (parseInt(en1_p.x)==parseInt(en2_p.x)) && (parseInt(en1_p.y)==parseInt(en2_p.y)) ){
                            // then judge re-routing
                            let vnodes2 = clone(that.edges[idx].virtrualNodes)
                            if(vnodes1.length == vnodes2.length){
                                if(vnodes2.length > 0){
                                    vnodes2.sort(function (a,b){
                                        return a[0] - b[0]
                                    })
                                }
                                for(let j = 0; j < vnodes2.length; j ++){
                                    if((parseInt(vnodes1[j][0])==parseInt(vnodes2[j][0])) && (parseInt(vnodes1[j][1])==parseInt(vnodes2[j][1]))){
                                        continue;
                                    }
                                    else{
                                        flag = false
                                        break
                                    }
                                }
                            }
                            else{
                                flag = false
                            }
                        }
                        else{
                            flag = false
                        }
                    }
                }
                if(!flag){
                    let tmpe = clone(preEdges[i])
                    tmpe.flag = false
                    editEdges.push(tmpe)
                    continue
                }
                if(curEdgeDict.hasOwnProperty(en)){
                    if(curEdgeDict[en].hasOwnProperty(st)){
                        flag1 = false
                        let idx = curEdgeDict[en][st]
                        let st1_p = preEdges[i].startpoint
                        let en1_p = preEdges[i].endpoint
                        let st2_p = that.pointData[st]
                        let en2_p = that.pointData[en]
                        if( (parseInt(st1_p.x)==parseInt(st2_p.x)) && (parseInt(st1_p.y)==parseInt(st2_p.y)) && (parseInt(en1_p.x)==parseInt(en2_p.x)) && (parseInt(en1_p.y)==parseInt(en2_p.y)) ){
                            // then judge re-routing
                            let vnodes2 = clone(that.edges[idx].virtrualNodes)
                            if(vnodes1.length == vnodes2.length){
                                if(vnodes2.length > 0){
                                    vnodes2.sort(function (a,b){
                                        return a[0] - b[0]
                                    })
                                }
                                for(let j = 0; j < vnodes2.length; j ++){
                                    if((parseInt(vnodes1[j][0])==parseInt(vnodes2[j][0])) && (parseInt(vnodes1[j][1])==parseInt(vnodes2[j][1]))){
                                        continue;
                                    }
                                    else{
                                        flag = false
                                        break
                                    }
                                }
                            }
                            else{
                                flag = false
                            }
                        }
                        else{
                            flag = false
                        }
                    }
                }
                if(!flag || flag1){
                    let tmpe = clone(preEdges[i])
                    tmpe.flag = false
                    editEdges.push(tmpe)
                }
            }


            that.setState({
                pointData: that.pointData
            })

            that.setState({
                edges: that.edges
            })

            if(that.child.bubbleState()){
                that.child.editReDraw(editPoints, editEdges, that.pointData, that.edges)
            }


            editPoints = []
            editEdges = []
        }

        var drag = d3.drag()
            .on("start",dragstart)
            .on("drag",dragged)
            .on("end",dragend)



        function handleMouseDown(event){
            if(event.button==2 && !that.props.isedit){
                let clickIndex=parseInt(d3.select(this).attr("index"))
                if(that.lastClickIndex==-1){
                    that.lastClickIndex=clickIndex

                    that.lastClickItem=d3.select(this).attr("stroke","red")
                        .attr("stroke-width",5)
                        .attr("selected",true)
                    let idx ="#" + d3.select(this).attr("id")
                    d3.selectAll(idx).attr("stroke","red")
                        .attr("stroke-width",5)
                        .attr("selected",true)
                }
                else{
                    if(clickIndex==that.lastClickIndex){
                        that.lastClickIndex=-1
                        that.lastClickItem=null
                        d3.select(this).attr("stroke","red")
                            .attr("stroke-width",1)
                            .attr("selected",false)
                        let idx ="#" + d3.select(this).attr("id")
                        d3.selectAll(idx).attr("stroke","red")
                            .attr("stroke-width",1)
                            .attr("selected",false)
                    }
                    else{
                        let lastcat=that.lastClickItem.attr("category")
                        if(lastcat==d3.select(this).attr("category")){
                            if(!that.hasLinked(that.lastClickIndex,clickIndex)){
                                that.addEdge(that.lastClickIndex,clickIndex,lastcat)
                                that.addedEdge.push([that.lastClickIndex,clickIndex])

                                let tmpe = clone(that.edges[that.edges.length - 1])
                                tmpe.id = that.edges.length - 1
                                tmpe.flag = true
                                editEdges.push(tmpe)
                                that.setState({
                                    pointData: that.pointData
                                })

                                that.setState({
                                    edges: that.edges
                                })

                                //console.log(that.edges)

                                if(that.child.bubbleState()){
                                    that.child.editReDraw(editPoints, editEdges, that.pointData, that.edges)
                                }

                                editPoints = []
                                editEdges = []


                                //recommand an  edge to delete
                                //check circle
                                that.findCircle(lastcat)
                            }

                            that.lastClickItem
                                .attr("stroke-width",1)
                                .attr("stroke","none")
                                .attr("selected",false)

                            let idx = "#" + that.lastClickItem.attr("id")
                            d3.selectAll(idx)
                                .attr("stroke-width",1)
                                .attr("stroke","none")
                                .attr("selected",false)

                            that.lastClickItem=null
                            that.lastClickIndex=-1
                            that.optimizeMST(true)
                        }
                        else{
                            that.lastClickItem
                                .attr("stroke-width",1)
                                .attr("stroke","none")
                                .attr("selected",false)

                            let idx = "#" + that.lastClickItem.attr("id")
                            d3.selectAll(idx)
                                .attr("stroke-width",1)
                                .attr("stroke","none")
                                .attr("selected",false)


                            idx = "#" + d3.select(this).attr("id")

                            that.lastClickItem=d3.select(this)
                                .attr("stroke","red")
                                .attr("stroke-width",5)
                                .attr("selected",true)
                                .attr("id",d3.select(this).attr("id"))


                            d3.selectAll(idx)
                                .attr("stroke","red")
                                .attr("stroke-width",5)
                                .attr("selected",true)

                            that.lastClickIndex=clickIndex

                        }
                    }
                }
            }
            else if(event.button==2 && that.props.isedit){

                let idx = parseInt(d3.select(event.path[0]).attr("index"))

                // delete node and edges
                let catarray = that.pointData[idx].catArray
                for(let c = 0; c < catarray.length; c ++){
                    let nowcat = catarray[c]
                    for(let j = 0; j < that.catPointDict[nowcat].length; j ++){
                        if(that.catPointDict[nowcat][j].id == idx){
                            that.catPointDict[nowcat].splice(j, 1)
                            break
                        }
                    }
                }

                for(let i = that.edges.length - 1; i >= 0; i --){
                    let st = that.edges[i].start
                    let en = that.edges[i].end
                    if(st == idx){
                        that.edges.splice(i, 1)
                    }
                    else if(en == idx){
                        that.edges.splice(i, 1)
                    }
                }

                that.pointData.splice(idx, 1);

                // modify svg index and data index
                d3.selectAll("#edgeGroup").remove()
                d3.selectAll("#pointGroup").remove()

                for(let i = 0; i < that.pointData.length; i ++){
                    if(that.pointData[i].id > idx){
                        that.pointData[i].id -= 1
                    }
                }

                for(let i = 0; i < that.edges.length; i ++){
                    if(that.edges[i].start > idx){
                        that.edges[i].start -= 1
                    }
                    if(that.edges[i].end > idx){
                        that.edges[i].end -= 1
                    }
                }

                that.drawPointData()
                that.drawEdges()

                that.setState({
                    pointData: that.pointData
                })

                that.setState({
                    edges: that.edges
                })

            }
        }

        let items=[]
        d3.select(svgid)
            .append("g")
            .attr("id","pointGroup")
        d3.select(opsvgid)
            .append("g")
            .attr("id","pointGroup")
        // this.itemShape="circle"
        if(this.itemShape=="circle"){
            for (let i=0;i<this.pointData.length;i++){
                let index=i
                d3.select(svgid)
                    .select("#pointGroup")
                    .append("circle")
                    .attr("class","dataPoint")
                    .attr("id","point"+index)
                    .attr("cx",this.pointData[i].x)
                    .attr("cy",this.pointData[i].y)
                    .attr("r",this.pointData[i].radius)
                    .attr("fill",function(d,i){
                        return colors[that.pointData[index].catArray[that.pointData[index].catArray.length-1]]
                    })
                    .attr("category",this.pointData[i].cat)
                    .attr("index",index)
                    .on("mouseover",function(d,i){
                        d3.select(this).attr("stroke","red")
                    })
                    .on("mouseout",function(){
                        if(d3.select(this).attr("selected")!="true"){
                            d3.select(this).attr("stroke","none")
                        }
                    })
                    .on("mousedown",handleMouseDown)
                    // .on("click",that.clickItem.bind(that))
                    // .on("drag",function(){
                    //     console.log("drag!")
                    // })
                    .call(drag)

                d3.select(opsvgid)
                    .select("#pointGroup")
                    .append("circle")
                    .attr("class","dataPoint")
                    .attr("id","point"+index)
                    .attr("cx",this.pointData[i].x)
                    .attr("cy",this.pointData[i].y)
                    .attr("r",this.pointData[i].radius)
                    .attr("fill",function(d,i){
                        return colors[that.pointData[index].catArray[that.pointData[index].catArray.length-1]]
                    })
                    .attr("category",this.pointData[i].cat)
                    .attr("index",index)
                    .on("mouseover",function(d,i){
                        d3.select(this).attr("stroke","red")
                    })
                    .on("mouseout",function(){
                        if(d3.select(this).attr("selected")!="true"){
                            d3.select(this).attr("stroke","none")
                        }
                    })
                    .on("mousedown",handleMouseDown)
                    // .on("click",that.clickItem.bind(that))
                    // .on("drag",function(){
                    //     console.log("drag!")
                    // })
                    .call(drag)
            }
            items=document.getElementsByClassName("dataPoint")
            // console.log(items)
            for (let i=0;i<items.length;i++){
                this.itemBBox.push({
                    id:items[i].getAttribute("index"),
                    bbox:items[i].getBBox()
                })
            }
        }
        else if(this.itemShape=="rectangle"){
            for (let i=0;i<this.pointData.length;i++){
                let index=i
                d3.select(svgid)
                    .select("#pointGroup")
                    .append("rect")
                    .attr("class","dataPoint")
                    .attr("id","point"+index)
                    .attr("x",this.pointData[i].x-this.pointData[i].width/2)
                    .attr("y",this.pointData[i].y-this.pointData[i].height/2)
                    .attr("width",this.pointData[i].width)
                    .attr("height",this.pointData[i].height)
                    .attr("fill",function(){
                        return colors[that.pointData[index].catArray[that.pointData[index].catArray.length-1]]
                    })
                    .attr("category",this.pointData[i].cat)
                    .attr("index",index)
                    .on("mouseover",function(d,i){
                        d3.select(this).attr("stroke","red")
                    })
                    .on("mouseout",function(){
                        if(d3.select(this).attr("selected")!="true"){
                            d3.select(this).attr("stroke","none")
                        }
                    })
                    .on("mousedown",handleMouseDown)

                    // .on("click",that.clickItem.bind(that))
                    // .on("drag",function(){
                    //     console.log("drag!")
                    // })
                    .call(drag)

                d3.select(opsvgid)
                    .select("#pointGroup")
                    .append("rect")
                    .attr("class","dataPoint")
                    .attr("id","point"+index)
                    .attr("x",this.pointData[i].x-this.pointData[i].width/2)
                    .attr("y",this.pointData[i].y-this.pointData[i].height/2)
                    .attr("width",this.pointData[i].width)
                    .attr("height",this.pointData[i].height)
                    .attr("fill",function(){
                        return colors[that.pointData[index].catArray[that.pointData[index].catArray.length-1]]
                    })
                    .attr("category",this.pointData[i].cat)
                    .attr("index",index)
                    .on("mouseover",function(d,i){
                        d3.select(this).attr("stroke","red")
                    })
                    .on("mouseout",function(){
                        if(d3.select(this).attr("selected")!="true"){
                            d3.select(this).attr("stroke","none")
                        }
                    })
                    .on("mousedown",handleMouseDown)

                    // .on("click",that.clickItem.bind(that))
                    // .on("drag",function(){
                    //     console.log("drag!")
                    // })
                    .call(drag)
            }
            items=document.getElementsByClassName("dataPoint")
            // console.log(items)
            for (let i=0;i<items.length;i++){
                this.itemBBox.push({
                    id:items[i].getAttribute("index"),
                    bbox:items[i].getBBox()
                })
            }
        }
    }

    countEdgeCrossingWithRouting(){
        let count=0
        for(let i=0;i<this.edges.length;i++){
            let lines1=[]
            let start1=this.pointData[this.edges[i].start]
            let end1=this.pointData[this.edges[i].end]
            if(this.edges[i].virtrual){
                let vnodes=this.edges[i].virtrualNodes
                lines1.push([start1.x,start1.y])
                for (let p=0;p<vnodes.length;p++){
                    lines1.push(vnodes[p])
                }
                lines1.push([end1.x,end1.y])
            }
            else{
                lines1.push([start1.x,start1.y])
                lines1.push([end1.x,end1.y])
            }
            for (let j=i+1;j<this.edges.length;j++){
                let lines2=[]
                let start2=this.pointData[this.edges[j].start]
                let end2=this.pointData[this.edges[j].end]
                if(start1.cat==start2.cat){
                    continue
                }
                if(this.edges[j].virtrual){
                    let vnodes=this.edges[j].virtrualNodes
                    lines2.push([start2.x,start2.y])
                    for (let p=0;p<vnodes.length;p++){
                        lines2.push(vnodes[p])
                    }
                    lines2.push([end2.x,end2.y])
                }
                else{
                    lines2.push([start2.x,start2.y])
                    lines2.push([end2.x,end2.y])
                }
                for (let l1=0;l1<lines1.length-1;l1++){
                    let p1={x:lines1[l1][0],y:lines1[l1][1]}
                    let p2={x:lines1[l1+1][0],y:lines1[l1+1][1]}
                    for (let l2=0;l2<lines2.length-1;l2++){
                        let p3={x:lines2[l2][0],y:lines2[l2][1]}
                        let p4={x:lines2[l2+1][0],y:lines2[l2+1][1]}
                        if(this.checkEdgeCrossing(p1,p2,p3,p4)){
                            count+=1
                        }
                    }
                }


            }



        }

    }

    countEdgeCrossing(){
        let count=0
        for(let i=0;i<this.edges.length;i++){
            let start1=this.pointData[this.edges[i].start]
            let end1=this.pointData[this.edges[i].end]
            for (let j=i+1;j<this.edges.length;j++){
                let start2=this.pointData[this.edges[j].start]
                let end2=this.pointData[this.edges[j].end]
                if(start1.cat!=start2.cat){
                    if(this.checkEdgeCrossing(start1,end1,start2,end2)){
                        count+=1
                    }
                }
            }
        }
    }

    createLocalTree(points){

        //1. find center point
        //2. generate tree
        let midx=0
        let midy=0
        for (let i=0;i<points.length;i++){
            midx+=points[i].x
            midy+=points[i].y
        }
        midx=midx/points.length
        midy=midy/points.length
        let midnode={
            x:midx,
            y:midy
        }
        let minDis=Number.MAX_VALUE
        let minindex=-1
        for (let i=0;i<points.length;i++){
            let dis=this.calDistance(midnode,points[i])
            if(dis<minDis){
                minDis=dis
                minindex=i
            }
        }



        for (let i=0;i<points.length;i++){
            if(i!=minindex){
                this.edges.push({
                    start:points[minindex].id,
                    end:points[i].id,
                    virtrual:false,
                    virtrualNodes:[],
                    cat:points[i].cat,
                    isLocalTree:true
                })
                this.graph.addEdge(points[minindex].id,points[i].id)
            }
        }



        // console.log(this.edges)
        /*        var g = new jsgraphs.Graph(this.pointData.length);
                for (let i=0;i<g.V;i++){
                    g.node(i).label=this.pointData[i].cat
                }*/

    }

    initWithNoCluster(){
        for(var k in this.catPointDict){
            this.clusterDict[k]=[]
            for (let i=0;i<this.catPointDict[k].length;i++){
                this.clusterDict[k].push([this.catPointDict[k][i]])
            }
        }

    }

    generateTreeWithHierarchical(){
        // this.findCluster()
        this.initWithNoCluster()
        //merging clusters according to this.edges

        let preAddedClusters=[]
        for (let i=0;i<this.edges.length;i++){
            let start=this.pointData[this.edges[i].start]
            let end=this.pointData[this.edges[i].end]
            let cat=start.cat
            let catclusters=this.clusterDict[cat]
            let startclusterid=-1
            let endclusterid=-1
            for(let c=0;c<catclusters.length;c++){
                for (let p=0;p<catclusters[c].length;p++){
                    if(catclusters[c][p].id==start.id){
                        startclusterid=c
                    }
                    if(catclusters[c][p].id==end.id){
                        endclusterid=c
                    }
                    if(startclusterid!=-1&&endclusterid!=-1){
                        break
                    }
                }
                if(startclusterid!=-1&&endclusterid!=-1){
                    break
                }

            }
            if(startclusterid!=-1&&endclusterid!=-1&&startclusterid!=endclusterid){
                // console.log(this.clusterDict[cat].length)

                //merge two cluster
                let merged=catclusters[startclusterid]
                for(let p=0;p<catclusters[endclusterid].length;p++){
                    merged.push(catclusters[endclusterid][p])
                }
                let newclusterdict=[]
                for (let c=0;c<catclusters.length;c++){
                    if(c!=startclusterid&&c!=endclusterid){
                        newclusterdict.push(catclusters[c])
                    }
                }
                newclusterdict.push(merged)
                this.clusterDict[cat]=newclusterdict
                preAddedClusters.push([cat,newclusterdict.length-1])
            }

        }

        this.createGraphWithCluster()

        for (var k in this.clusterDict){
            this.clustergraphInfo[k] = {edgesnum:0,nodesnum:this.clusterDict[k].length};
            for (let i=0;i<this.clusterDict[k].length;i++){
                let iscontinue=false
                for (let c=0;c<preAddedClusters.length;c++){
                    let cat=preAddedClusters[c][0]
                    let id=preAddedClusters[c][1]
                    if(k==cat&&id==i){
                        iscontinue=true
                    }
                }
                if(iscontinue){
                    continue
                }
                else{
                    this.createLocalTree(this.clusterDict[k][i])
                }
            }
        }
        // console.log(this.clusterDict)
        // console.log(this.edges.length)

        this.drawEdges()
        this.hierarchicalMergeV2()
        // console.log(this.edges.length)
    }

    findCluster(){

        for (var k in this.catPointDict){
            // console.log(k)

            var dbscan = new clustering.DBSCAN();
            let dataset=[]
            let pointDataSet=[]
// parameters: 5 - neighborhood radius, 2 - number of points in neighborhood to form a cluster

            for(let i=0;i<this.catPointDict[k].length;i++){
                // if(this.pointData[this.catPointDict[k][i].id].multicat){
                //     let catarr=this.pointData[this.catPointDict[k][i].id].catArray
                //     catarr=catarr.map((val)=> parseInt(val) )
                //     let minCatIndex=Math.min.apply(null,catarr)
                //     if(parseInt(k)==minCatIndex){
                //         dataset.push([this.catPointDict[k][i].x,this.catPointDict[k][i].y])
                //         pointDataSet.push(this.pointData[this.catPointDict[k][i].id])
                //     }
                // }
                // else{
                dataset.push([this.catPointDict[k][i].x,this.catPointDict[k][i].y])
                pointDataSet.push(this.pointData[this.catPointDict[k][i].id])
                // }

            }
            // console.log(dataset)
            // console.log(pointDataSet)

            if(dataset.length>0){
                this.clusterDict[k]=[]
                this.noiseDict[k]=[]
                var clusters = dbscan.run(dataset, DBSCAN_EPS, 2);
                // console.log(clusters, dbscan.noise);
                let point
                for(let i=0;i<clusters.length;i++){
                    let clusterPoints=[]
                    for (let j=0;j<clusters[i].length;j++){
                        clusterPoints.push(pointDataSet[clusters[i][j]])
                        // console.log(point)
                        /*                    let point=dataset[clusters[i][j]]
                                            d3.select(svgid)
                                                .append("circle")
                                                .attr("cx",point[0])
                                                .attr("cy",point[1])
                                                .attr("r",10)
                                                .attr("fill","none")
                                                .attr("stroke","red")
                                                .attr("stroke-width",2)*/
                    }
                    // this.createLocalTree(clusterPoints)
                    this.clusterDict[k].push(clusterPoints)
                }
                for (let i=0;i<dbscan.noise.length;i++){
                    this.clusterDict[k].push([pointDataSet[dbscan.noise[i]]])
                }
            }

        }
        //console.log(this.clusterDict)
        // console.log(this.noiseDict)
    }

    createGraph(){

    }

    createGraphWithCluster(){
        let clusterArr=[]
        let idnum=0
        for (var k in this.clusterDict){
            for (let i=0;i<this.clusterDict[k].length;i++){
                clusterArr.push({
                    points:this.clusterDict[k][i],
                    cat:k,
                    id:idnum
                })
                this.clusterDict[k][i].id=idnum
                idnum+=1


            }

        }
        this.clusterArr=clusterArr
        //console.log(this.clusterDict)
        var g = new jsgraphs.Graph(this.clusterArr.length);
        for (let i=0;i<g.V;i++){
            g.node(i).label=this.clusterArr[i].cat
        }
        // console.log(g.V,this.clusterArr.length)

        this.clustergraph=g

        var g2 = new jsgraphs.Graph(this.pointData.length);
        for (let i=0;i<g2.V;i++){
            g2.node(i).label=this.pointData[i].cat
        }
        this.graph=g2
        //console.log(g,g2)
        for (let i=0;i<this.edges.length;i++){
            this.graph.addEdge(this.edges[i].start,this.edges[i].end)
        }

    }

    calClusterDistance(cluster1,cluster2){
        let dissum=0
        let num=0
        let mindis=Number.MAX_VALUE
        for(let i=0;i<cluster1.length;i++){
            for (let j=0;j<cluster2.length;j++){
                // dissum+=this.calDistance(cluster1[i],cluster2[j])
                // num+=1
                let dis=this.calDistance(cluster1[i],cluster2[j])
                if(dis<mindis){
                    mindis=dis
                }
            }
        }
        return mindis
    }

    sortEdgesGlobalWithCluster(){
        function sortEdgesfunc(a,b){
            return a[2]-b[2]
        }

        let edges=[]
        let disArray=[]
        let messArray=[]
        let tempedges=[]
        let maxDis=Number.MIN_VALUE
        for (let k in this.clusterDict){
            for(let i=0;i<this.clusterDict[k].length;i++){
                for (let j=i+1;j<this.clusterDict[k].length;j++){
                    let dis=this.calClusterDistance(this.clusterDict[k][i],this.clusterDict[k][j])
                    // let mess=this.calEdgeMess(this.clusterDict[k][i],this.clusterDict[k][j])
                    disArray.push(dis)
                    // messArray.push(mess)
                    if(dis>maxDis){
                        maxDis=dis
                    }
                    // tempedges.push([this.catPointDict[k][i].id,this.catPointDict[k][j].id,dis,mess])
                    tempedges.push([this.clusterDict[k][i].id,this.clusterDict[k][j].id,dis])
                }
            }
        }
        this.maxDistance=maxDis
        for (let i=0;i<tempedges.length;i++){
            let start=tempedges[i][0]
            let end=tempedges[i][1]
            let dis=tempedges[i][2]/maxDis
            // let mess=tempedges[i][3]
            // let weight=dis*(mess+1)
            let weight=dis
            // edges.push([start,end,weight,dis,mess])
            edges.push([start,end,weight,dis])
        }

        edges.sort(sortEdgesfunc)
        return edges
    }

    findLinkBetweenCluster(cluster1,cluster2){
        let mindis=Number.MAX_VALUE
        let minstart=null
        let minend=null
        let flag=false
        for (let i=0;i<cluster1.length;i++){
            let start=cluster1[i]
            for(let j=0;j<cluster2.length;j++){
                let end=cluster2[j]
                if(!this.checkNewEdge(start,end)){
                    flag=true
                    let dis=this.calDistance(start,end)
                    if(dis<mindis){
                        mindis=dis
                        minstart=start
                        minend=end
                    }
                }
            }
        }

        return [flag,minstart,minend,mindis]
    }

    /*    findOptimalLink(cluster1,cluster2){
            //let crossedge = []
            let minScore=Number.MAX_VALUE
            let bestStart=null
            let bestEnd=null

            let minScoreWithDis=Number.MAX_VALUE
            let bestStartWithDis=null
            let bestEndWithDis=null

            let hasBest=false
            for (let i=0;i<cluster1.length;i++){
                let start=cluster1[i]
                for(let j=0;j<cluster2.length;j++){
                    let end=cluster2[j]
                    //cal cross num
                    let crossnum=0
                    for (let e=0;e<this.edges.length;e++){
                        let e1=this.pointData[this.edges[e].start]
                        let e2=this.pointData[this.edges[e].end]
                        if(e1.cat!=start.cat&&e1.cat!=end.cat&&this.checkEdgeCrossing(start,end,e1,e2)){
                            crossnum+=1
                        }
                    }
                    //let tmpcross = [];

                    //let elements = this.QTree.retrieve({
                    //    x: Math.min(start.x,end.x),
                    //    y: Math.min(start.y,end.y),
                    //    width: Math.abs(start.x-end.x),
                    //    height: Math.abs(start.y-end.y)
                    //});

                    //for (let e = 0;e < elements.length;e ++){
                    //    let e1 = this.pointData[elements[e].start];
                    //    let e2 = this.pointData[elements[e].end];
                    //    if(e1.cat != start.cat && e1.cat != end.cat && this.checkEdgeCrossing(start,end,e1,e2)){
                    //        crossnum += 1
                    //        //tmpcross.push({start:this.edges[e].start,end:this.edges[e].end})
                    //        //tmpcross.push({start:this.edges[e].end,end:this.edges[e].start})
                    //    }
                    //}
                    //crossnum = 5;

                    //cal distance
                    let distance=this.calDistance(start,end)


                    //cal num of other points
                    let mess=this.calEdgeMess(start,end)

                    if(crossnum>maxCross){
                        maxCross=crossnum
                    }

                    let score=weightCross*crossnum+weightDistance*distance/this.maxDis+weightMess*mess
                    if(score<minScore){
                        bestStart=start
                        bestEnd=end
                        minScore=score
                        //crossedge = tmpcross
                    }
                    if(distance<DISTANCE_THRESHHOLD){
                        if(score<minScoreWithDis){
                            bestStartWithDis=start
                            bestEndWithDis=end
                            minScoreWithDis=score
                            hasBest=true
                            //crossedge = tmpcross
                        }
                    }

                }
            }

            /!*      if(hasBest){
                        // console.log("edge under threshhold")
                        return [bestStartWithDis,bestEndWithDis,minScoreWithDis,this.calDistance(bestStartWithDis,bestEndWithDis)]
                    }
                    else{
                        // console.log("no edge under threshhold")
                        return [bestStart,bestEnd,minScore,this.calDistance(bestStart,bestEnd)]
                    }*!/
            return [bestStart,bestEnd,minScore,this.calDistance(bestStart,bestEnd)]
        }*/

    findOptimalLink(cluster1,cluster2){
        let minScore=Number.MAX_VALUE
        let bestStart=null
        let bestEnd=null

        let minScoreWithDis=Number.MAX_VALUE
        let bestStartWithDis=null
        let bestEndWithDis=null

        let hasBest=false
        for (let i=0;i<cluster1.length;i++){
            let start=cluster1[i]
            for(let j=0;j<cluster2.length;j++){
                let end=cluster2[j]

                //cal cross num
                let crossnum=0
                for (let e=0;e<this.edges.length;e++){
                    let e1=this.pointData[this.edges[e].start]
                    let e2=this.pointData[this.edges[e].end]
                    if(e1.cat!=start.cat&&e1.cat!=end.cat&&this.checkEdgeCrossing(start,end,e1,e2)){
                        crossnum+=1
                    }
                }

                //cal distance
                let distance=this.calDistance(start,end)


                //cal num of other points
                let mess=this.calEdgeMess(start,end)

                if(crossnum>maxCross){
                    maxCross=crossnum
                }

                let score=weightCross*crossnum+weightDistance*distance/this.maxDis+weightMess*mess
                if(score<minScore){
                    bestStart=start
                    bestEnd=end
                    minScore=score
                }
                if(distance<DISTANCE_THRESHHOLD){
                    if(score<minScoreWithDis){
                        bestStartWithDis=start
                        bestEndWithDis=end
                        minScoreWithDis=score
                        hasBest=true
                    }
                }

            }
        }

        /*        if(hasBest){
                    // console.log("edge under threshhold")
                    return [bestStartWithDis,bestEndWithDis,minScoreWithDis,this.calDistance(bestStartWithDis,bestEndWithDis)]
                }
                else{
                    // console.log("no edge under threshhold")
                    return [bestStart,bestEnd,minScore,this.calDistance(bestStart,bestEnd)]
                }*/
        return [bestStart,bestEnd,minScore,this.calDistance(bestStart,bestEnd)]
    }

    /*    findMinScore(links){
            let minScore=Number.MAX_VALUE
            let minIndex=-1

            let minScoreWithDistance=Number.MAX_VALUE
            let minIndexWithDistance=-1
            let hasBest=false
            for(let i=0;i<links.length;i++){
                if(links[i].score<minScore){
                    minScore=links[i].score
                    minIndex=i
                }
                if(links[i].distance<DISTANCE_THRESHHOLD&&links[i].score<minScoreWithDistance){
                    minScoreWithDistance=links[i].score
                    minIndexWithDistance=i
                    hasBest=true
                }
            }
            if(hasBest){
                // console.log("yes")
                return links[minIndexWithDistance]
            }
            else{
                // console.log("no")
                return links[minIndex]

            }

            // return links[minIndex]

        }*/

    findMinScoreTest(links){
        let minScore=Number.MAX_VALUE
        let minIndex=-1
        let minScoreWithDistance=Number.MAX_VALUE
        let minIndexWithDistance=-1
        let hasBest=false
        for(let i=links.length-1;i>=0;i--) {
            let id1 = links[i].clusterid1
            let id2 = links[i].clusterid2
            if(this.checkConnectBetweenTwoCluster(id1,id2)){
                continue;
            }
            if(links[i].score<minScore){
                minScore=links[i].score
                minIndex=i
            }
            if(links[i].distance<DISTANCE_THRESHHOLD&&links[i].score<minScoreWithDistance){
                minScoreWithDistance=links[i].score
                minIndexWithDistance=i
                hasBest=true
            }
        }

        if(hasBest){
            // console.log("yes")
            return links[minIndexWithDistance]
        }
        else{
            // console.log("no")
            return links[minIndex]

        }

        // return links[minIndex]

    }

    findMinScore(links){
        let minScore=Number.MAX_VALUE
        let minIndex=-1

        let minScoreWithDistance=Number.MAX_VALUE
        let minIndexWithDistance=-1
        let hasBest=false
        for(let i=0;i<links.length;i++){
            if(links[i].score<minScore){
                minScore=links[i].score
                minIndex=i
            }
            if(links[i].distance<DISTANCE_THRESHHOLD&&links[i].score<minScoreWithDistance){
                minScoreWithDistance=links[i].score
                minIndexWithDistance=i
                hasBest=true
            }
        }
        if(hasBest){
            // console.log("yes")
            return links[minIndexWithDistance]
        }
        else{
            // console.log("no")
            return links[minIndex]

        }

        // return links[minIndex]

    }

    findCrossingBetweenEdgeRect(start,end,cat){
        let intersecInfo=[]
        //check the crossing of a line and rectangle

        // let cat=this.pointData[start].cat

        let startp={x:start[0],y:start[1]}
        let endp={x:end[0],y:end[1]}

        for(let i=0;i<this.itemBBox.length;i++){
            let index=parseInt(this.itemBBox[i].id)
            if(cat==this.pointData[index].cat){
                continue
            }
            const rect=ShapeInfo.rectangle({top: this.itemBBox[i].bbox.y, left: this.itemBBox[i].bbox.x, width: this.itemBBox[i].bbox.width, height: this.itemBBox[i].bbox.height})
            const line = ShapeInfo.line([startp.x, startp.y], [endp.x, endp.y]);
            const intersections = Intersection.intersect(rect, line);
            if(intersections.status=="Intersection" && intersections.points.length>1){
                // console.log([startp.x, startp.y], [endp.x, endp.y])
                // console.log({top: this.itemBBox[i].bbox.x, left: this.itemBBox[i].bbox.y, width: this.itemBBox[i].bbox.width, height: this.itemBBox[i].bbox.height})
                // console.log(intersections.points.length)
//                 for (let j=0;j<intersections.points.length;j++){
//                     let ipoint=intersections.points[j]
// /*                    d3.select(svgid)
//                         .append("circle")
//                         .attr("cx",ipoint.x)
//                         .attr("cy",ipoint.y)
//                         .attr("r",2)
//                         .attr("fill","red")
//                     console.log()*/
//
//                 }
                intersecInfo.push({
                    rect:this.itemBBox[i].bbox,
                    points:intersections.points
                })
                break
            }
        }
        return intersecInfo
    }

    checkVNodeInBound(vnode,cat){

        for(let i=0;i<this.itemBBox.length;i++){
            let index=parseInt(this.itemBBox[i].id)
            if(cat==this.pointData[index].cat){
                continue
            }
            const intersections = IntersectionQuery.pointInRectangle(  {x:vnode[0],y:vnode[1]}, {x:this.itemBBox[i].bbox.x,y:this.itemBBox[i].bbox.y},  {x:this.itemBBox[i].bbox.x+this.itemBBox[i].bbox.width,y:this.itemBBox[i].bbox.y+this.itemBBox[i].bbox.height})
            if(intersections){
                return true
            }
        }
        return false
    }

    isAdded(start,end){
        for (let i=0;i<this.addedEdge.length;i++){
            if(this.addedEdge[i][0]==start&&this.addedEdge[i][1]==end||this.addedEdge[i][0]==end&&this.addedEdge[i][1]==start){
                return true
            }
        }
        return false
    }

    isDeleted(start,end){
        for (let i=0;i<this.deletedEdge.length;i++){
            if(this.deletedEdge[i][0]==start&&this.deletedEdge[i][1]==end||this.deletedEdge[i][0]==end&&this.deletedEdge[i][1]==start){
                return true
            }
        }
        return false
    }

    addLinksTest(id1,id2,k,cluster1,cluster2,e){
        for (let i=0;i<cluster1.length;i++){
            let start=cluster1[i]
            for(let j=0;j<cluster2.length;j++){
                let end=cluster2[j]
                let crossnum=0
                let distance=this.calDistance(start,end)
                let mess=this.calEdgeMess(start,end)
                let score=weightCross*crossnum+weightDistance*distance/this.maxDis+weightMess*mess
                let tmp = {
                    clusterid1:id1,
                    clusterid2:id2,
                    start:start,
                    end:end,
                    score:score,
                    distance:distance,
                    cat:k,
                    idx:this.idx,
                    pid:-1
                }
                e.push(tmp)
                this.idx++;
            }
        }
    }

    addLinks(id1,id2,k,cluster1,cluster2,e1,e2){
        for (let i=0;i<cluster1.length;i++){
            let start=cluster1[i]
            for(let j=0;j<cluster2.length;j++){
                let end=cluster2[j]
                //cal cross num
                let crossnum=0
                for (let e=0;e<this.edges.length;e++){
                    let e1=this.pointData[this.edges[e].start]
                    let e2=this.pointData[this.edges[e].end]
                    if(e1.cat!=start.cat&&e1.cat!=end.cat&&this.checkEdgeCrossing(start,end,e1,e2)){
                        crossnum+=1
                    }
                }
                //cal distance
                let distance=this.calDistance(start,end)
                //cal num of other points
                let mess=this.calEdgeMess(start,end)
                let score=weightCross*crossnum+weightDistance*distance/this.maxDis+weightMess*mess
                let tmp = {
                    clusterid1:id1,
                    clusterid2:id2,
                    start:start,
                    end:end,
                    score:score,
                    distance:distance,
                    cat:k,
                    idx:this.idx,
                    pid:-1
                }

                if(this.isDeleted(start.id,end.id)){
                    tmp.score=Number.MAX_VALUE
                    e2._d[this.idx] = tmp;
                    e2.enq(this.idx);
                    this.idx++;

                }
                else if(this.isAdded(start.id,end.id)){
                    tmp.score=-1
                    e1._d[this.idx] = tmp;
                    e1.enq(this.idx);
                    this.idx++;
                }
                else{
                    if(distance<DISTANCE_THRESHHOLD){
                        //V1
                        //tmp.pid = e1._elements.length;

                        e1._d[this.idx] = tmp;
                        e1.enq(this.idx);
                        this.idx++;
                    }
                    else{
                        //V1
                        //tmp.pid = e2._elements.length;

                        e2._d[this.idx] = tmp;
                        e2.enq(this.idx);
                        this.idx++;
                    }
                }
                //let nodetmp = {
                //    x:Math.min(start.x,end.x),
                //    y:Math.min(start.y,end.y),
                //    width:Math.abs(start.x - end.x),
                //    height:Math.abs(start.y - end.y),
                //    idx:this.idx
                //}
                //this.edgesdict.push(nodetmp);
                //this.QTree.insert(this.edgesdict[this.idx]);

            }
        }
    }

    findBestLink(e){
        let minScore = Number.MAX_VALUE;
        let tmp;
        for(let i = e.length - 1;i >= 0;i --){
            let id1 = e[i].clusterid1;
            let id2 = e[i].clusterid2;
            if(!this.checkConnectBetweenTwoClusterV2(id1,id2)){
                if(minScore > e[i].score){
                    tmp = e[i];
                    minScore = e[i].score;
                }
            }
            else{
                e.splice(i, 1);
            }
        }
        return tmp;
    }

    recalculateSpanningTreeAfterEdit(edges){
        let newEdges=[]
        if(this.pointData.length<150){
            weightMess=0
        }
        else{
            weightMess=1
        }

        //start kruskal test
        //init
        this.f=[]

        let totcluster = 0
        for(let k in this.clusterDict){
            totcluster += this.clusterDict[k].length;
        }
        for(let i = 0;i <= totcluster;i ++){
            this.f.push(i);
        }

        //add edge set
        let optimalLinks1=new priority_queue({});
        let optimalLinks2=new priority_queue({});

        //let optimalLinks = [];

        for (var k in this.clusterDict){
            for (let i=0;i<this.clusterDict[k].length;i++){
                let id1=this.clusterDict[k][i].id
                for (let j=i+1;j<this.clusterDict[k].length;j++){
                    let id2=this.clusterDict[k][j].id
                    //this.addLinksTest(id1,id2,k,this.clusterDict[k][i],this.clusterDict[k][j],optimalLinks)
                    //if(!this.checkConnectBetweenTwoClusterV2(id1,id2)){
                    this.addLinks(id1,id2,k,this.clusterDict[k][i],this.clusterDict[k][j],optimalLinks1,optimalLinks2)
                    //}
                }
            }
        }

        while(!this.checkConnectBetweenAllCluster()){
            //let bestLink = this.findMinScoreTest(optimalLinks);
            //for(let i = 0;i < optimalLinks.length; i ++){
            //    let s = optimalLinks[i].start
            //    let e = optimalLinks[i].end
            //    if(this.checkEdgeCrossing(s,e,bestLink.start,bestLink.end) && s.cat != bestLink.start.cat && e.cat != bestLink.end.cat){
            //        optimalLinks[i].score += weightCross
            //    }
            //}

            let bestLink;
            if(!optimalLinks1.isEmpty()){
                bestLink = optimalLinks1._d[optimalLinks1.deq()];
            }
            else if(!optimalLinks2.isEmpty()){
                bestLink = optimalLinks2._d[optimalLinks2.deq()];
            }
            else{
                break;
            }

            this.unionFather(bestLink.clusterid1,bestLink.clusterid2);
            optimalLinks1.modify_Kruskal_V2(bestLink.start,bestLink.end,this.f,weightCross)
            optimalLinks2.modify_Kruskal_V2(bestLink.start,bestLink.end,this.f,weightCross)

            this.clustergraph.addEdge(bestLink.clusterid1,bestLink.clusterid2);
            this.clustergraphInfo[bestLink.cat].edgesnum += 1;
            edges.push({
                start:bestLink.start.id,
                end:bestLink.end.id,
                weight:bestLink.score,
                cat:bestLink.cat,
                dis:bestLink.score,
                virtrual:false,
                virtrualNodes:[],
                isLocalTree:false
            })
            this.graph.addEdge(bestLink.start.id,bestLink.end.id)
            // this.drawEdges()

            //surface routing
            let startp=this.pointData[bestLink.start.id]
            let endp=this.pointData[bestLink.end.id]
            let pcat=this.pointData[bestLink.start.id].cat

            let virtrualNodes=[]
            virtrualNodes.push([startp.x,startp.y])
            virtrualNodes.push([endp.x,endp.y])
            let linesToCheck=[{
                start:[startp.x,startp.y],
                end:[endp.x,endp.y],
                ids:[0,1]
            }]

            while(linesToCheck.length>0){

                let buffer=5
                let swap=false
                let checkline=linesToCheck.pop()

                startp=checkline.start
                endp=checkline.end
                let ids=checkline.ids

                // d3.selectAll("line")
                //     .remove()
                // // .attr("stroke","black")
                // d3.select(svgid).append("line")
                //     .attr("x1",startp[0])
                //     .attr("y1",startp[1])
                //     .attr("x2",endp[0])
                //     .attr("y2",endp[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")

                let intersecInfo=this.findCrossingBetweenEdgeRect(startp,endp,pcat)

                if(intersecInfo.length==0){
                    continue
                }
                edges[edges.length-1].virtrual=true
                // handle crossing between edge and rect
                let points=intersecInfo[0].points
                let rec=intersecInfo[0].rect

                let line1=[[rec.x,rec.y],[rec.x+rec.width,rec.y]]
                let line3=[[rec.x,rec.y+rec.height],[rec.x+rec.width,rec.y+rec.height]]

                let line2=[[rec.x,rec.y],[rec.x,rec.y+rec.height]]
                let line4=[[rec.x+rec.width,rec.y],[rec.x+rec.width,rec.y+rec.height]]

                let point1=points[0]
                let point2=points[1]

                let vnode

                if(line1[1][1]==point1.y&&line3[1][1]==point2.y||line3[1][1]==point1.y&&line1[1][1]==point2.y||line2[0][0]==point1.x&&line4[0][0]==point2.x||line2[0][0]==point2.x&&line4[0][0]==point1.x){
                    //parallel edges
                    let cornerpointindex=-1
                    if(line1[1][1]==point1.y&&line3[1][1]==point2.y){
                        let x1=point1.x-rec.x
                        let y1=point2.x-rec.x
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=2
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=4
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    else if(line3[1][1]==point1.y&&line1[1][1]==point2.y){
                        let x1=point2.x-rec.x
                        let y1=point1.x-rec.x
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=2
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=4
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    else if(line2[0][0]==point1.x&&line4[0][0]==point2.x){
                        let x1=point1.y-rec.y
                        let y1=point2.y-rec.y
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=4
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=2
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }
                    else if(line2[0][0]==point2.x&&line4[0][0]==point1.x){
                        let x1=point2.y-rec.y
                        let y1=point1.y-rec.y
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=4
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=2
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    let cornerpoint=[]


                    let iternum=0
                    let vnode1=-1
                    let vnode2=-1
                    while(true) {
                        if (cornerpointindex == 1) {
                            if (!swap) {
                                cornerpoint = [rec.x, rec.y]
                            } else {
                                cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                            }
                        } else if (cornerpointindex == 2) {
                            if (!swap) {
                                cornerpoint = [rec.x + rec.width, rec.y]
                            } else {
                                cornerpoint = [rec.x, rec.y + rec.height]
                            }
                        } else if (cornerpointindex == 3) {
                            if (!swap) {
                                cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                            } else {
                                cornerpoint = [rec.x, rec.y]
                            }
                        } else if (cornerpointindex == 4) {
                            if (!swap) {
                                cornerpoint = [rec.x, rec.y + rec.height]
                            } else {
                                cornerpoint = [rec.x + rec.width, rec.y]
                            }
                        }

                        let centerpoint = [rec.x + rec.width / 2, rec.y + rec.height / 2]
                        let movevec = [cornerpoint[0] - centerpoint[0], cornerpoint[1] - centerpoint[1]]
                        let movenorm = this.getVecNorm(movevec)
                        movevec[0] = movevec[0] / movenorm
                        movevec[1] = movevec[1] / movenorm

                        vnode = [cornerpoint[0] + buffer * movevec[0], cornerpoint[1] + buffer * movevec[1]]

                        // d3.selectAll("line")
                        //     .remove()
                        // // .attr("stroke","black")
                        // d3.select(svgid).append("line")
                        //     .attr("x1",startp[0])
                        //     .attr("y1",startp[1])
                        //     .attr("x2",vnode[0])
                        //     .attr("y2",vnode[1])
                        //     .attr("stroke-width",2)
                        //     .attr("stroke","red")
                        //
                        // d3.select(svgid).append("line")
                        //     .attr("x1",endp[0])
                        //     .attr("y1",endp[1])
                        //     .attr("x2",vnode[0])
                        //     .attr("y2",vnode[1])
                        //     .attr("stroke-width",2)
                        //     .attr("stroke","red")

                        if(this.checkVNodeInBound(vnode,pcat)){
                            if(!swap){
                                buffer=buffer/1.5
                            }
                            swap=!swap
                            iternum+=1
                            if(iternum>10){
                                break
                            }
                        }
                        else{
                            //not in obstacle, check if this virtrual edge corssing with other edges
                            if(swap){
                                vnode1=vnode
                            }
                            else{
                                vnode2=vnode
                            }
                            swap=!swap
                            if(vnode1!=-1&&vnode2!=-1){
                                break
                            }
                            // iternum+=1
                        }

                    }

                    if(vnode1==-1&&vnode2==-1){
                        //fail to route the edge
                        edges[edges.length-1].virtrual=false
                        continue
                    }
                    else if(vnode1!=-1&&vnode2!=-1){
                        //use the one with least crossing
                        let minCross=Number.MAX_VALUE
                        let bestVnode=null
                        let potentialNode=[vnode1,vnode2]
                        for (let n=0;n<potentialNode.length;n++){
                            let pnode=potentialNode[n]
                            let count=0
                            for(let i=0;i<edges.length;i++){
                                let start1=this.pointData[edges[i].start]
                                let end1=this.pointData[edges[i].end]
                                if(start1.cat!=pcat){
                                    let node1={
                                        x:startp[0],
                                        y:startp[1],
                                        cat:pcat
                                    }
                                    let node2={
                                        x:pnode[0],
                                        y:pnode[1],
                                        cat:pcat
                                    }
                                    let node3={
                                        x:endp[0],
                                        y:endp[1],
                                        cat:pcat
                                    }
                                    if(this.checkEdgeCrossing(start1,end1,node1,node2)){
                                        count+=1
                                    }
                                    if(this.checkEdgeCrossing(start1,end1,node2,node3)){
                                        count+=1
                                    }
                                }
                            }
                            if(count<minCross){
                                minCross=count
                                bestVnode=potentialNode[n]
                            }

                        }
                        vnode=bestVnode

                    }
                    else{
                        if(vnode1!=-1){
                            vnode=vnode1
                        }
                        else{
                            vnode=vnode2
                        }
                    }

                }
                else{
                    //neighbouring edges
                    //find the corner point on the rectangle
                    let temppoint=[point1.x,point2.y]
                    let cornerpoint=[]
                    if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x+rec.width,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                    }
                    else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x,rec.y+rec.height]
                    }
                    else{
                        temppoint=[point2.x,point1.y]
                        if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                            cornerpoint=[rec.x,rec.y]
                        }
                        else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                            cornerpoint=[rec.x+rec.width,rec.y]
                        }
                        else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                            cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                        }
                        else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                            cornerpoint=[rec.x,rec.y+rec.height]
                        }
                    }

                    let centerpoint=[rec.x+rec.width/2,rec.y+rec.height/2]
                    let movevec=[cornerpoint[0]-centerpoint[0],cornerpoint[1]-centerpoint[1]]
                    let movenorm=this.getVecNorm(movevec)
                    movevec[0]=movevec[0]/movenorm
                    movevec[1]=movevec[1]/movenorm

                    vnode=[cornerpoint[0]+buffer*movevec[0],cornerpoint[1]+buffer*movevec[1]]
                }


                // d3.selectAll("line")
                //     .remove()
                // // .attr("stroke","black")
                // d3.select(svgid).append("line")
                //     .attr("x1",startp[0])
                //     .attr("y1",startp[1])
                //     .attr("x2",vnode[0])
                //     .attr("y2",vnode[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")
                //
                // d3.select(svgid).append("line")
                //     .attr("x1",endp[0])
                //     .attr("y1",endp[1])
                //     .attr("x2",vnode[0])
                //     .attr("y2",vnode[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")


                let samepoiint=false
                for (let m=0;m<virtrualNodes.length;m++){
                    if(vnode[0]==virtrualNodes[m][0]&&vnode[1]==virtrualNodes[m][1]){
                        samepoiint=true
                        break
                    }
                }
                if(samepoiint){
                    continue
                }

                let newid


                newid=ids[0]+1


                virtrualNodes.splice(newid,0,vnode)

                for (let n=0;n<linesToCheck.length;n++){
                    if(linesToCheck[n].ids[0]>=newid){
                        linesToCheck[n].ids[0]=linesToCheck[n].ids[0]+1
                    }
                    if(linesToCheck[n].ids[1]>=newid){
                        linesToCheck[n].ids[1]=linesToCheck[n].ids[1]+1
                    }
                }
                // virtrualNodes.push(vnode)
                linesToCheck.push({
                    start:startp,
                    end:vnode,
                    ids:[ids[0],newid]
                })
                linesToCheck.push({
                    start:vnode,
                    end:endp,
                    ids:[newid,ids[1]+1]
                })

                // console.log(linesToCheck)

            }

            virtrualNodes.pop()
            virtrualNodes.splice(0,1)
            edges[edges.length-1].virtrualNodes=virtrualNodes

            newEdges.push(edges.length-1)
        }
        //console.log(maxCross)
        return newEdges
    }

    recalculateSpanningTree(){
        let newEdges=[]
        if(this.pointData.length<150){
            weightMess=0
        }
        else{
            weightMess=1
        }

        //start kruskal test
        //init
        this.f=[]

        let totcluster = 0
        for(let k in this.clusterDict){
            totcluster += this.clusterDict[k].length;
        }
        for(let i = 0;i <= totcluster;i ++){
            this.f.push(i);
        }

        //add edge set
        let optimalLinks1=new priority_queue({});
        let optimalLinks2=new priority_queue({});

        //let optimalLinks = [];

        for (var k in this.clusterDict){
            for (let i=0;i<this.clusterDict[k].length;i++){
                let id1=this.clusterDict[k][i].id
                for (let j=i+1;j<this.clusterDict[k].length;j++){
                    let id2=this.clusterDict[k][j].id
                    //this.addLinksTest(id1,id2,k,this.clusterDict[k][i],this.clusterDict[k][j],optimalLinks)
                    //if(!this.checkConnectBetweenTwoClusterV2(id1,id2)){
                    this.addLinks(id1,id2,k,this.clusterDict[k][i],this.clusterDict[k][j],optimalLinks1,optimalLinks2)
                    //}
                }
            }
        }

        while(!this.checkConnectBetweenAllCluster()){
            //let bestLink = this.findMinScoreTest(optimalLinks);
            //for(let i = 0;i < optimalLinks.length; i ++){
            //    let s = optimalLinks[i].start
            //    let e = optimalLinks[i].end
            //    if(this.checkEdgeCrossing(s,e,bestLink.start,bestLink.end) && s.cat != bestLink.start.cat && e.cat != bestLink.end.cat){
            //        optimalLinks[i].score += weightCross
            //    }
            //}

            let bestLink;
            if(!optimalLinks1.isEmpty()){
                bestLink = optimalLinks1._d[optimalLinks1.deq()];
            }
            else if(!optimalLinks2.isEmpty()){
                bestLink = optimalLinks2._d[optimalLinks2.deq()];
            }
            else{
                break;
            }

            this.unionFather(bestLink.clusterid1,bestLink.clusterid2);
            optimalLinks1.modify_Kruskal_V2(bestLink.start,bestLink.end,this.f,weightCross)
            optimalLinks2.modify_Kruskal_V2(bestLink.start,bestLink.end,this.f,weightCross)

            this.clustergraph.addEdge(bestLink.clusterid1,bestLink.clusterid2);
            this.clustergraphInfo[bestLink.cat].edgesnum += 1;
            this.edges.push({
                start:bestLink.start.id,
                end:bestLink.end.id,
                weight:bestLink.score,
                cat:bestLink.cat,
                dis:bestLink.score,
                virtrual:false,
                virtrualNodes:[],
                isLocalTree:false
            })
            this.graph.addEdge(bestLink.start.id,bestLink.end.id)
            // this.drawEdges()

            //surface routing
            let startp=this.pointData[bestLink.start.id]
            let endp=this.pointData[bestLink.end.id]
            let pcat=this.pointData[bestLink.start.id].cat

            let virtrualNodes=[]
            virtrualNodes.push([startp.x,startp.y])
            virtrualNodes.push([endp.x,endp.y])
            let linesToCheck=[{
                start:[startp.x,startp.y],
                end:[endp.x,endp.y],
                ids:[0,1]
            }]

            while(linesToCheck.length>0){

                let buffer=5
                let swap=false
                let checkline=linesToCheck.pop()

                startp=checkline.start
                endp=checkline.end
                let ids=checkline.ids

                // d3.selectAll("line")
                //     .remove()
                // // .attr("stroke","black")
                // d3.select(svgid).append("line")
                //     .attr("x1",startp[0])
                //     .attr("y1",startp[1])
                //     .attr("x2",endp[0])
                //     .attr("y2",endp[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")

                let intersecInfo=this.findCrossingBetweenEdgeRect(startp,endp,pcat)

                if(intersecInfo.length==0){
                    continue
                }
                this.edges[this.edges.length-1].virtrual=true
                // handle crossing between edge and rect
                let points=intersecInfo[0].points
                let rec=intersecInfo[0].rect

                let line1=[[rec.x,rec.y],[rec.x+rec.width,rec.y]]
                let line3=[[rec.x,rec.y+rec.height],[rec.x+rec.width,rec.y+rec.height]]

                let line2=[[rec.x,rec.y],[rec.x,rec.y+rec.height]]
                let line4=[[rec.x+rec.width,rec.y],[rec.x+rec.width,rec.y+rec.height]]

                let point1=points[0]
                let point2=points[1]

                let vnode

                if(line1[1][1]==point1.y&&line3[1][1]==point2.y||line3[1][1]==point1.y&&line1[1][1]==point2.y||line2[0][0]==point1.x&&line4[0][0]==point2.x||line2[0][0]==point2.x&&line4[0][0]==point1.x){
                    //parallel edges
                    let cornerpointindex=-1
                    if(line1[1][1]==point1.y&&line3[1][1]==point2.y){
                        let x1=point1.x-rec.x
                        let y1=point2.x-rec.x
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=2
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=4
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    else if(line3[1][1]==point1.y&&line1[1][1]==point2.y){
                        let x1=point2.x-rec.x
                        let y1=point1.x-rec.x
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=2
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=4
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    else if(line2[0][0]==point1.x&&line4[0][0]==point2.x){
                        let x1=point1.y-rec.y
                        let y1=point2.y-rec.y
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=4
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=2
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }
                    else if(line2[0][0]==point2.x&&line4[0][0]==point1.x){
                        let x1=point2.y-rec.y
                        let y1=point1.y-rec.y
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=4
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=2
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    let cornerpoint=[]


                    let iternum=0
                    let vnode1=-1
                    let vnode2=-1
                    while(true) {
                        if (cornerpointindex == 1) {
                            if (!swap) {
                                cornerpoint = [rec.x, rec.y]
                            } else {
                                cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                            }
                        } else if (cornerpointindex == 2) {
                            if (!swap) {
                                cornerpoint = [rec.x + rec.width, rec.y]
                            } else {
                                cornerpoint = [rec.x, rec.y + rec.height]
                            }
                        } else if (cornerpointindex == 3) {
                            if (!swap) {
                                cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                            } else {
                                cornerpoint = [rec.x, rec.y]
                            }
                        } else if (cornerpointindex == 4) {
                            if (!swap) {
                                cornerpoint = [rec.x, rec.y + rec.height]
                            } else {
                                cornerpoint = [rec.x + rec.width, rec.y]
                            }
                        }

                        let centerpoint = [rec.x + rec.width / 2, rec.y + rec.height / 2]
                        let movevec = [cornerpoint[0] - centerpoint[0], cornerpoint[1] - centerpoint[1]]
                        let movenorm = this.getVecNorm(movevec)
                        movevec[0] = movevec[0] / movenorm
                        movevec[1] = movevec[1] / movenorm

                        vnode = [cornerpoint[0] + buffer * movevec[0], cornerpoint[1] + buffer * movevec[1]]

                        // d3.selectAll("line")
                        //     .remove()
                        // // .attr("stroke","black")
                        // d3.select(svgid).append("line")
                        //     .attr("x1",startp[0])
                        //     .attr("y1",startp[1])
                        //     .attr("x2",vnode[0])
                        //     .attr("y2",vnode[1])
                        //     .attr("stroke-width",2)
                        //     .attr("stroke","red")
                        //
                        // d3.select(svgid).append("line")
                        //     .attr("x1",endp[0])
                        //     .attr("y1",endp[1])
                        //     .attr("x2",vnode[0])
                        //     .attr("y2",vnode[1])
                        //     .attr("stroke-width",2)
                        //     .attr("stroke","red")

                        if(this.checkVNodeInBound(vnode,pcat)){
                            if(!swap){
                                buffer=buffer/1.5
                            }
                            swap=!swap
                            iternum+=1
                            if(iternum>10){
                                break
                            }
                        }
                        else{
                            //not in obstacle, check if this virtrual edge corssing with other edges
                            if(swap){
                                vnode1=vnode
                            }
                            else{
                                vnode2=vnode
                            }
                            swap=!swap
                            if(vnode1!=-1&&vnode2!=-1){
                                break
                            }
                            // iternum+=1
                        }

                    }

                    if(vnode1==-1&&vnode2==-1){
                        //fail to route the edge
                        this.edges[this.edges.length-1].virtrual=false
                        continue
                    }
                    else if(vnode1!=-1&&vnode2!=-1){
                        //use the one with least crossing
                        let minCross=Number.MAX_VALUE
                        let bestVnode=null
                        let potentialNode=[vnode1,vnode2]
                        for (let n=0;n<potentialNode.length;n++){
                            let pnode=potentialNode[n]
                            let count=0
                            for(let i=0;i<this.edges.length;i++){
                                let start1=this.pointData[this.edges[i].start]
                                let end1=this.pointData[this.edges[i].end]
                                if(start1.cat!=pcat){
                                    let node1={
                                        x:startp[0],
                                        y:startp[1],
                                        cat:pcat
                                    }
                                    let node2={
                                        x:pnode[0],
                                        y:pnode[1],
                                        cat:pcat
                                    }
                                    let node3={
                                        x:endp[0],
                                        y:endp[1],
                                        cat:pcat
                                    }
                                    if(this.checkEdgeCrossing(start1,end1,node1,node2)){
                                        count+=1
                                    }
                                    if(this.checkEdgeCrossing(start1,end1,node2,node3)){
                                        count+=1
                                    }
                                }
                            }
                            if(count<minCross){
                                minCross=count
                                bestVnode=potentialNode[n]
                            }

                        }
                        vnode=bestVnode

                    }
                    else{
                        if(vnode1!=-1){
                            vnode=vnode1
                        }
                        else{
                            vnode=vnode2
                        }
                    }

                }
                else{
                    //neighbouring edges
                    //find the corner point on the rectangle
                    let temppoint=[point1.x,point2.y]
                    let cornerpoint=[]
                    if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x+rec.width,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                    }
                    else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x,rec.y+rec.height]
                    }
                    else{
                        temppoint=[point2.x,point1.y]
                        if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                            cornerpoint=[rec.x,rec.y]
                        }
                        else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                            cornerpoint=[rec.x+rec.width,rec.y]
                        }
                        else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                            cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                        }
                        else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                            cornerpoint=[rec.x,rec.y+rec.height]
                        }
                    }

                    let centerpoint=[rec.x+rec.width/2,rec.y+rec.height/2]
                    let movevec=[cornerpoint[0]-centerpoint[0],cornerpoint[1]-centerpoint[1]]
                    let movenorm=this.getVecNorm(movevec)
                    movevec[0]=movevec[0]/movenorm
                    movevec[1]=movevec[1]/movenorm

                    vnode=[cornerpoint[0]+buffer*movevec[0],cornerpoint[1]+buffer*movevec[1]]
                }


                // d3.selectAll("line")
                //     .remove()
                // // .attr("stroke","black")
                // d3.select(svgid).append("line")
                //     .attr("x1",startp[0])
                //     .attr("y1",startp[1])
                //     .attr("x2",vnode[0])
                //     .attr("y2",vnode[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")
                //
                // d3.select(svgid).append("line")
                //     .attr("x1",endp[0])
                //     .attr("y1",endp[1])
                //     .attr("x2",vnode[0])
                //     .attr("y2",vnode[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")


                let samepoiint=false
                for (let m=0;m<virtrualNodes.length;m++){
                    if(vnode[0]==virtrualNodes[m][0]&&vnode[1]==virtrualNodes[m][1]){
                        samepoiint=true
                        break
                    }
                }
                if(samepoiint){
                    continue
                }

                let newid


                newid=ids[0]+1


                virtrualNodes.splice(newid,0,vnode)

                for (let n=0;n<linesToCheck.length;n++){
                    if(linesToCheck[n].ids[0]>=newid){
                        linesToCheck[n].ids[0]=linesToCheck[n].ids[0]+1
                    }
                    if(linesToCheck[n].ids[1]>=newid){
                        linesToCheck[n].ids[1]=linesToCheck[n].ids[1]+1
                    }
                }
                // virtrualNodes.push(vnode)
                linesToCheck.push({
                    start:startp,
                    end:vnode,
                    ids:[ids[0],newid]
                })
                linesToCheck.push({
                    start:vnode,
                    end:endp,
                    ids:[newid,ids[1]+1]
                })

                // console.log(linesToCheck)

            }

            virtrualNodes.pop()
            virtrualNodes.splice(0,1)
            this.edges[this.edges.length-1].virtrualNodes=virtrualNodes

            newEdges.push(this.edges.length-1)
        }
        //console.log(maxCross)
        return newEdges
    }

    hierarchicalMergeV2(){

        if(this.pointData.length<150){
            weightMess=0
        }
        else{
            weightMess=1
        }

        //start kruskal test
        //init
        this.f=[]

        let totcluster = 0
        for(let k in this.clusterDict){
            totcluster += this.clusterDict[k].length;
        }
        for(let i = 0;i <= totcluster;i ++){
            this.f.push(i);
        }

        //add edge set
        let optimalLinks1=new priority_queue({});
        let optimalLinks2=new priority_queue({});

        //let optimalLinks = [];

        for (var k in this.clusterDict){
            for (let i=0;i<this.clusterDict[k].length;i++){
                let id1=this.clusterDict[k][i].id
                for (let j=i+1;j<this.clusterDict[k].length;j++){
                    let id2=this.clusterDict[k][j].id
                    //this.addLinksTest(id1,id2,k,this.clusterDict[k][i],this.clusterDict[k][j],optimalLinks)
                    //if(!this.checkConnectBetweenTwoClusterV2(id1,id2)){
                    this.addLinks(id1,id2,k,this.clusterDict[k][i],this.clusterDict[k][j],optimalLinks1,optimalLinks2)
                    //}
                }
            }
        }

        while(!this.checkConnectBetweenAllClusterV2()){
            //let bestLink = this.findMinScoreTest(optimalLinks);
            //for(let i = 0;i < optimalLinks.length; i ++){
            //    let s = optimalLinks[i].start
            //    let e = optimalLinks[i].end
            //    if(this.checkEdgeCrossing(s,e,bestLink.start,bestLink.end) && s.cat != bestLink.start.cat && e.cat != bestLink.end.cat){
            //        optimalLinks[i].score += weightCross
            //    }
            //}

            let bestLink;
            if(!optimalLinks1.isEmpty()){
                bestLink = optimalLinks1._d[optimalLinks1.deq()];
            }
            else if(!optimalLinks2.isEmpty()){
                bestLink = optimalLinks2._d[optimalLinks2.deq()];
            }
            else{
                break;
            }

            this.unionFather(bestLink.clusterid1,bestLink.clusterid2);
            optimalLinks1.modify_Kruskal_V2(bestLink.start,bestLink.end,this.f,weightCross)
            optimalLinks2.modify_Kruskal_V2(bestLink.start,bestLink.end,this.f,weightCross)

            this.clustergraph.addEdge(bestLink.clusterid1,bestLink.clusterid2);
            this.clustergraphInfo[bestLink.cat].edgesnum += 1;
            this.edges.push({
                start:bestLink.start.id,
                end:bestLink.end.id,
                weight:bestLink.score,
                cat:bestLink.cat,
                dis:bestLink.score,
                virtrual:false,
                virtrualNodes:[],
                isLocalTree:false
            })
            this.graph.addEdge(bestLink.start.id,bestLink.end.id)
            this.drawEdges()
            console.log()
            //surface routing
            let startp=this.pointData[bestLink.start.id]
            let endp=this.pointData[bestLink.end.id]
            let pcat=this.pointData[bestLink.start.id].cat

            let virtrualNodes=[]
            virtrualNodes.push([startp.x,startp.y])
            virtrualNodes.push([endp.x,endp.y])
            let linesToCheck=[{
                start:[startp.x,startp.y],
                end:[endp.x,endp.y],
                ids:[0,1]
            }]

            while(linesToCheck.length>0){

                let buffer=5
                let swap=false
                let checkline=linesToCheck.pop()

                startp=checkline.start
                endp=checkline.end
                let ids=checkline.ids

/*                d3.selectAll("line")
                    .remove()
                // .attr("stroke","black")
                d3.select(svgid).append("line")
                    .attr("x1",startp[0])
                    .attr("y1",startp[1])
                    .attr("x2",endp[0])
                    .attr("y2",endp[1])
                    .attr("stroke-width",2)
                    .attr("stroke","red")*/

                let intersecInfo=this.findCrossingBetweenEdgeRect(startp,endp,pcat)

                if(intersecInfo.length==0){
                    continue
                }
                this.edges[this.edges.length-1].virtrual=true
                // handle crossing between edge and rect
                let points=intersecInfo[0].points
                let rec=intersecInfo[0].rect

                let line1=[[rec.x,rec.y],[rec.x+rec.width,rec.y]]
                let line3=[[rec.x,rec.y+rec.height],[rec.x+rec.width,rec.y+rec.height]]

                let line2=[[rec.x,rec.y],[rec.x,rec.y+rec.height]]
                let line4=[[rec.x+rec.width,rec.y],[rec.x+rec.width,rec.y+rec.height]]

                let point1=points[0]
                let point2=points[1]

                let vnode

                if(line1[1][1]==point1.y&&line3[1][1]==point2.y||line3[1][1]==point1.y&&line1[1][1]==point2.y||line2[0][0]==point1.x&&line4[0][0]==point2.x||line2[0][0]==point2.x&&line4[0][0]==point1.x){
                    //parallel edges
                    let cornerpointindex=-1
                    if(line1[1][1]==point1.y&&line3[1][1]==point2.y){
                        let x1=point1.x-rec.x
                        let y1=point2.x-rec.x
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=2
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=4
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    else if(line3[1][1]==point1.y&&line1[1][1]==point2.y){
                        let x1=point2.x-rec.x
                        let y1=point1.x-rec.x
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=2
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=4
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    else if(line2[0][0]==point1.x&&line4[0][0]==point2.x){
                        let x1=point1.y-rec.y
                        let y1=point2.y-rec.y
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=4
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=2
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }
                    else if(line2[0][0]==point2.x&&line4[0][0]==point1.x){
                        let x1=point2.y-rec.y
                        let y1=point1.y-rec.y
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=4
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=2
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    let cornerpoint=[]


                    let iternum=0
                    let vnode1=-1
                    let vnode2=-1
                    while(true) {
                        if (cornerpointindex == 1) {
                            if (!swap) {
                                cornerpoint = [rec.x, rec.y]
                            } else {
                                cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                            }
                        } else if (cornerpointindex == 2) {
                            if (!swap) {
                                cornerpoint = [rec.x + rec.width, rec.y]
                            } else {
                                cornerpoint = [rec.x, rec.y + rec.height]
                            }
                        } else if (cornerpointindex == 3) {
                            if (!swap) {
                                cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                            } else {
                                cornerpoint = [rec.x, rec.y]
                            }
                        } else if (cornerpointindex == 4) {
                            if (!swap) {
                                cornerpoint = [rec.x, rec.y + rec.height]
                            } else {
                                cornerpoint = [rec.x + rec.width, rec.y]
                            }
                        }

                        let centerpoint = [rec.x + rec.width / 2, rec.y + rec.height / 2]
                        let movevec = [cornerpoint[0] - centerpoint[0], cornerpoint[1] - centerpoint[1]]
                        let movenorm = this.getVecNorm(movevec)
                        movevec[0] = movevec[0] / movenorm
                        movevec[1] = movevec[1] / movenorm

                        vnode = [cornerpoint[0] + buffer * movevec[0], cornerpoint[1] + buffer * movevec[1]]

/*                        d3.selectAll("line")
                            .remove()
                        // .attr("stroke","black")
                        d3.select(svgid).append("line")
                            .attr("x1",startp[0])
                            .attr("y1",startp[1])
                            .attr("x2",vnode[0])
                            .attr("y2",vnode[1])
                            .attr("stroke-width",2)
                            .attr("stroke","red")

                        d3.select(svgid).append("line")
                            .attr("x1",endp[0])
                            .attr("y1",endp[1])
                            .attr("x2",vnode[0])
                            .attr("y2",vnode[1])
                            .attr("stroke-width",2)
                            .attr("stroke","red")*/

                        if(this.checkVNodeInBound(vnode,pcat)){
                            if(!swap){
                                buffer=buffer/1.5
                            }
                            swap=!swap
                            iternum+=1
                            if(iternum>10){
                                break
                            }
                        }
                        else{
                            //not in obstacle, check if this virtrual edge corssing with other edges
                            if(swap){
                                vnode1=vnode
                            }
                            else{
                                vnode2=vnode
                            }
                            swap=!swap
                            if(vnode1!=-1&&vnode2!=-1){
                                break
                            }
                            // iternum+=1
                        }

                    }

                    if(vnode1==-1&&vnode2==-1){
                        //fail to route the edge
                        this.edges[this.edges.length-1].virtrual=false
                        continue
                    }
                    else if(vnode1!=-1&&vnode2!=-1){
                        //use the one with least crossing
                        let minCross=Number.MAX_VALUE
                        let bestVnode=null
                        let potentialNode=[vnode1,vnode2]
                        for (let n=0;n<potentialNode.length;n++){
                            let pnode=potentialNode[n]
                            let count=0
                            for(let i=0;i<this.edges.length;i++){
                                let start1=this.pointData[this.edges[i].start]
                                let end1=this.pointData[this.edges[i].end]
                                if(start1.cat!=pcat){
                                    let node1={
                                        x:startp[0],
                                        y:startp[1],
                                        cat:pcat
                                    }
                                    let node2={
                                        x:pnode[0],
                                        y:pnode[1],
                                        cat:pcat
                                    }
                                    let node3={
                                        x:endp[0],
                                        y:endp[1],
                                        cat:pcat
                                    }
                                    if(this.checkEdgeCrossing(start1,end1,node1,node2)){
                                        count+=1
                                    }
                                    if(this.checkEdgeCrossing(start1,end1,node2,node3)){
                                        count+=1
                                    }
                                }
                            }
                            if(count<minCross){
                                minCross=count
                                bestVnode=potentialNode[n]
                            }

                        }
                        vnode=bestVnode

                    }
                    else{
                        if(vnode1!=-1){
                            vnode=vnode1
                        }
                        else{
                            vnode=vnode2
                        }
                    }

                }
                else{
                    //neighbouring edges
                    //find the corner point on the rectangle
                    let temppoint=[point1.x,point2.y]
                    let cornerpoint=[]
                    if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x+rec.width,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                    }
                    else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x,rec.y+rec.height]
                    }
                    else{
                        temppoint=[point2.x,point1.y]
                        if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                            cornerpoint=[rec.x,rec.y]
                        }
                        else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                            cornerpoint=[rec.x+rec.width,rec.y]
                        }
                        else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                            cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                        }
                        else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                            cornerpoint=[rec.x,rec.y+rec.height]
                        }
                    }

                    let centerpoint=[rec.x+rec.width/2,rec.y+rec.height/2]
                    let movevec=[cornerpoint[0]-centerpoint[0],cornerpoint[1]-centerpoint[1]]
                    let movenorm=this.getVecNorm(movevec)
                    movevec[0]=movevec[0]/movenorm
                    movevec[1]=movevec[1]/movenorm

                    vnode=[cornerpoint[0]+buffer*movevec[0],cornerpoint[1]+buffer*movevec[1]]
                }


/*                d3.selectAll("line")
                    .remove()
                // .attr("stroke","black")
                d3.select(svgid).append("line")
                    .attr("x1",startp[0])
                    .attr("y1",startp[1])
                    .attr("x2",vnode[0])
                    .attr("y2",vnode[1])
                    .attr("stroke-width",2)
                    .attr("stroke","red")

                d3.select(svgid).append("line")
                    .attr("x1",endp[0])
                    .attr("y1",endp[1])
                    .attr("x2",vnode[0])
                    .attr("y2",vnode[1])
                    .attr("stroke-width",2)
                    .attr("stroke","red")*/


                let samepoiint=false
                for (let m=0;m<virtrualNodes.length;m++){
                    if(vnode[0]==virtrualNodes[m][0]&&vnode[1]==virtrualNodes[m][1]){
                        samepoiint=true
                        break
                    }
                }
                if(samepoiint){
                    continue
                }

                let newid


                newid=ids[0]+1


                virtrualNodes.splice(newid,0,vnode)

                for (let n=0;n<linesToCheck.length;n++){
                    if(linesToCheck[n].ids[0]>=newid){
                        linesToCheck[n].ids[0]=linesToCheck[n].ids[0]+1
                    }
                    if(linesToCheck[n].ids[1]>=newid){
                        linesToCheck[n].ids[1]=linesToCheck[n].ids[1]+1
                    }
                }
                // virtrualNodes.push(vnode)
                linesToCheck.push({
                    start:startp,
                    end:vnode,
                    ids:[ids[0],newid]
                })
                linesToCheck.push({
                    start:vnode,
                    end:endp,
                    ids:[newid,ids[1]+1]
                })

                // console.log(linesToCheck)

            }

            virtrualNodes.pop()
            virtrualNodes.splice(0,1)
            this.edges[this.edges.length-1].virtrualNodes=virtrualNodes
            this.drawOneEdge(this.edges.length-1)
            console.log()
        }
        //console.log(maxCross)
    }

    hierarchicalMerge(){
        // console.log(this.calDistance(this.pointData[120],this.pointData[171]))
        // console.log(this.calDistance(this.pointData[47],this.pointData[188]))
        if(this.pointData.length<150){
            weightMess=0
        }
        else{
            weightMess=1
        }

        while(!this.checkConnectBetweenAllCluster()){
            let optimalLinks=[]
            for (var k in this.clusterDict){
                for (let i=0;i<this.clusterDict[k].length;i++){
                    let id1=this.clusterDict[k][i].id
                    for (let j=i+1;j<this.clusterDict[k].length;j++){
                        let id2=this.clusterDict[k][j].id
                        if(!this.checkConnectBetweenTwoCluster(id1,id2)){
                            let link=this.findOptimalLink(this.clusterDict[k][i],this.clusterDict[k][j])
                            optimalLinks.push({
                                clusterid1:id1,
                                clusterid2:id2,
                                start:link[0],
                                end:link[1],
                                score:link[2],
                                distance:link[3],
                                cat:k
                            })
                        }
                        else{
                            continue
                        }
                    }
                }
            }
            let bestLink=this.findMinScore(optimalLinks)
            this.clustergraph.addEdge(bestLink.clusterid1,bestLink.clusterid2)
            this.edges.push({
                start:bestLink.start.id,
                end:bestLink.end.id,
                weight:bestLink.score,
                cat:bestLink.cat,
                dis:bestLink.score,
                virtrual:false,
                virtrualNodes:[],
                isLocalTree:false
            })
            this.graph.addEdge(bestLink.start.id,bestLink.end.id)

            // this.drawEdges()


            //surface routing
            let startp=this.pointData[bestLink.start.id]
            let endp=this.pointData[bestLink.end.id]
            let pcat=this.pointData[bestLink.start.id].cat

            let virtrualNodes=[]
            virtrualNodes.push([startp.x,startp.y])
            virtrualNodes.push([endp.x,endp.y])
            let linesToCheck=[{
                start:[startp.x,startp.y],
                end:[endp.x,endp.y],
                ids:[0,1]
            }]

            while(linesToCheck.length>0){

                let buffer=5
                let swap=false
                let checkline=linesToCheck.pop()

                startp=checkline.start
                endp=checkline.end
                let ids=checkline.ids

                // d3.selectAll("line")
                //     .remove()
                // // .attr("stroke","black")
                // d3.select(svgid).append("line")
                //     .attr("x1",startp[0])
                //     .attr("y1",startp[1])
                //     .attr("x2",endp[0])
                //     .attr("y2",endp[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")

                let intersecInfo=this.findCrossingBetweenEdgeRect(startp,endp,pcat)

                if(intersecInfo.length==0){
                    continue
                }
                this.edges[this.edges.length-1].virtrual=true
                // handle crossing between edge and rect
                let points=intersecInfo[0].points
                let rec=intersecInfo[0].rect

                let line1=[[rec.x,rec.y],[rec.x+rec.width,rec.y]]
                let line3=[[rec.x,rec.y+rec.height],[rec.x+rec.width,rec.y+rec.height]]

                let line2=[[rec.x,rec.y],[rec.x,rec.y+rec.height]]
                let line4=[[rec.x+rec.width,rec.y],[rec.x+rec.width,rec.y+rec.height]]

                let point1=points[0]
                let point2=points[1]

                let vnode

                if(line1[1][1]==point1.y&&line3[1][1]==point2.y||line3[1][1]==point1.y&&line1[1][1]==point2.y||line2[0][0]==point1.x&&line4[0][0]==point2.x||line2[0][0]==point2.x&&line4[0][0]==point1.x){
                    //parallel edges
                    let cornerpointindex=-1
                    if(line1[1][1]==point1.y&&line3[1][1]==point2.y){
                        let x1=point1.x-rec.x
                        let y1=point2.x-rec.x
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=2
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=4
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    else if(line3[1][1]==point1.y&&line1[1][1]==point2.y){
                        let x1=point2.x-rec.x
                        let y1=point1.x-rec.x
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=2
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=4
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    else if(line2[0][0]==point1.x&&line4[0][0]==point2.x){
                        let x1=point1.y-rec.y
                        let y1=point2.y-rec.y
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=4
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=2
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }
                    else if(line2[0][0]==point2.x&&line4[0][0]==point1.x){
                        let x1=point2.y-rec.y
                        let y1=point1.y-rec.y
                        if(x1+y1<rec.width){
                            if(x1>y1){
                                cornerpointindex=3
                            }
                            else{
                                cornerpointindex=4
                            }
                        }
                        else{
                            if(x1<y1){
                                cornerpointindex=2
                            }
                            else{
                                cornerpointindex=1
                            }
                        }
                    }

                    let cornerpoint=[]


                    let iternum=0
                    let vnode1=-1
                    let vnode2=-1
                    while(true) {
                        if (cornerpointindex == 1) {
                            if (!swap) {
                                cornerpoint = [rec.x, rec.y]
                            } else {
                                cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                            }
                        } else if (cornerpointindex == 2) {
                            if (!swap) {
                                cornerpoint = [rec.x + rec.width, rec.y]
                            } else {
                                cornerpoint = [rec.x, rec.y + rec.height]
                            }
                        } else if (cornerpointindex == 3) {
                            if (!swap) {
                                cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                            } else {
                                cornerpoint = [rec.x, rec.y]
                            }
                        } else if (cornerpointindex == 4) {
                            if (!swap) {
                                cornerpoint = [rec.x, rec.y + rec.height]
                            } else {
                                cornerpoint = [rec.x + rec.width, rec.y]
                            }
                        }

                        let centerpoint = [rec.x + rec.width / 2, rec.y + rec.height / 2]
                        let movevec = [cornerpoint[0] - centerpoint[0], cornerpoint[1] - centerpoint[1]]
                        let movenorm = this.getVecNorm(movevec)
                        movevec[0] = movevec[0] / movenorm
                        movevec[1] = movevec[1] / movenorm

                        vnode = [cornerpoint[0] + buffer * movevec[0], cornerpoint[1] + buffer * movevec[1]]

                        // d3.selectAll("line")
                        //     .remove()
                        //     // .attr("stroke","black")
                        // d3.select(svgid).append("line")
                        //     .attr("x1",startp[0])
                        //     .attr("y1",startp[1])
                        //     .attr("x2",vnode[0])
                        //     .attr("y2",vnode[1])
                        //     .attr("stroke-width",2)
                        //     .attr("stroke","red")
                        //
                        // d3.select(svgid).append("line")
                        //     .attr("x1",endp[0])
                        //     .attr("y1",endp[1])
                        //     .attr("x2",vnode[0])
                        //     .attr("y2",vnode[1])
                        //     .attr("stroke-width",2)
                        //     .attr("stroke","red")

                        if(this.checkVNodeInBound(vnode,pcat)){
                            if(!swap){
                                buffer=buffer/1.5
                            }
                            swap=!swap
                            iternum+=1
                            if(iternum>10){
                                break
                            }
                        }
                        else{
                            //not in obstacle, check if this virtrual edge corssing with other edges
                            if(swap){
                                vnode1=vnode
                            }
                            else{
                                vnode2=vnode
                            }
                            swap=!swap
                            if(vnode1!=-1&&vnode2!=-1){
                                break
                            }
                            // iternum+=1
                        }

                    }

                    if(vnode1==-1&&vnode2==-1){
                        //fail to route the edge
                        this.edges[this.edges.length-1].virtrual=false
                        continue
                    }
                    else if(vnode1!=-1&&vnode2!=-1){
                        //use the one with least crossing
                        let minCross=Number.MAX_VALUE
                        let bestVnode=null
                        let potentialNode=[vnode1,vnode2]
                        for (let n=0;n<potentialNode.length;n++){
                            let pnode=potentialNode[n]
                            let count=0
                            for(let i=0;i<this.edges.length;i++){
                                let start1=this.pointData[this.edges[i].start]
                                let end1=this.pointData[this.edges[i].end]
                                if(start1.cat!=pcat){
                                    let node1={
                                        x:startp[0],
                                        y:startp[1],
                                        cat:pcat
                                    }
                                    let node2={
                                        x:pnode[0],
                                        y:pnode[1],
                                        cat:pcat
                                    }
                                    let node3={
                                        x:endp[0],
                                        y:endp[1],
                                        cat:pcat
                                    }
                                    if(this.checkEdgeCrossing(start1,end1,node1,node2)){
                                        count+=1
                                    }
                                    if(this.checkEdgeCrossing(start1,end1,node2,node3)){
                                        count+=1
                                    }
                                }
                            }
                            if(count<minCross){
                                minCross=count
                                bestVnode=potentialNode[n]
                            }

                        }
                        vnode=bestVnode

                    }
                    else{
                        if(vnode1!=-1){
                            vnode=vnode1
                        }
                        else{
                            vnode=vnode2
                        }
                    }

                }
                else{
                    //neighbouring edges
                    //find the corner point on the rectangle
                    let temppoint=[point1.x,point2.y]
                    let cornerpoint=[]
                    if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x+rec.width,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                    }
                    else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x,rec.y+rec.height]
                    }
                    else{
                        temppoint=[point2.x,point1.y]
                        if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                            cornerpoint=[rec.x,rec.y]
                        }
                        else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                            cornerpoint=[rec.x+rec.width,rec.y]
                        }
                        else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                            cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                        }
                        else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                            cornerpoint=[rec.x,rec.y+rec.height]
                        }
                    }

                    let centerpoint=[rec.x+rec.width/2,rec.y+rec.height/2]
                    let movevec=[cornerpoint[0]-centerpoint[0],cornerpoint[1]-centerpoint[1]]
                    let movenorm=this.getVecNorm(movevec)
                    movevec[0]=movevec[0]/movenorm
                    movevec[1]=movevec[1]/movenorm

                    vnode=[cornerpoint[0]+buffer*movevec[0],cornerpoint[1]+buffer*movevec[1]]
                }


                // d3.selectAll("line")
                //     .remove()
                // // .attr("stroke","black")
                // d3.select(svgid).append("line")
                //     .attr("x1",startp[0])
                //     .attr("y1",startp[1])
                //     .attr("x2",vnode[0])
                //     .attr("y2",vnode[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")
                //
                // d3.select(svgid).append("line")
                //     .attr("x1",endp[0])
                //     .attr("y1",endp[1])
                //     .attr("x2",vnode[0])
                //     .attr("y2",vnode[1])
                //     .attr("stroke-width",2)
                //     .attr("stroke","red")


                let samepoiint=false
                for (let m=0;m<virtrualNodes.length;m++){
                    if(vnode[0]==virtrualNodes[m][0]&&vnode[1]==virtrualNodes[m][1]){
                        samepoiint=true
                        break
                    }
                }
                if(samepoiint){
                    continue
                }

                let newid


                newid=ids[0]+1


                virtrualNodes.splice(newid,0,vnode)

                for (let n=0;n<linesToCheck.length;n++){
                    if(linesToCheck[n].ids[0]>=newid){
                        linesToCheck[n].ids[0]=linesToCheck[n].ids[0]+1
                    }
                    if(linesToCheck[n].ids[1]>=newid){
                        linesToCheck[n].ids[1]=linesToCheck[n].ids[1]+1
                    }
                }
                // virtrualNodes.push(vnode)
                linesToCheck.push({
                    start:startp,
                    end:vnode,
                    ids:[ids[0],newid]
                })
                linesToCheck.push({
                    start:vnode,
                    end:endp,
                    ids:[newid,ids[1]+1]
                })

                // console.log(linesToCheck)

            }

            virtrualNodes.pop()
            virtrualNodes.splice(0,1)
            this.edges[this.edges.length-1].virtrualNodes=virtrualNodes

        }
    }

    mergeCluster(){
        //average distance as distance between clusters
        //find an optimal link with least crossing

        let sortEdgeDict={}
        let sortedEdges=[]
        let removeEdggeList=[]

        sortedEdges=this.sortEdgesGlobalWithCluster()

        for (let i=0;i<sortedEdges.length;i++){
            let start=sortedEdges[i][0]
            let end=sortedEdges[i][1]
            let weight=sortedEdges[i][2]
            let dis=sortedEdges[i][3]
            // let mess=sortedEdges[i][4]



            if(this.clusterArr[start].cat!=this.clusterArr[end].cat)
                continue

            var dfs = new jsgraphs.DepthFirstSearch(this.clustergraph, start);

            if(!dfs.hasPathTo(end)){

                let link=this.findLinkBetweenCluster(this.clusterArr[start].points,this.clusterArr[end].points)

                if(link[0]){
                    this.clustergraph.addEdge(start,end)
                    this.graph.addEdge(link[1].id,link[2].id)
                    // this.graph.edge(start,end).label=sortedEdges[i][2]
                    this.edges.push({
                        start:link[1].id,
                        end:link[2].id,
                        weight:link[3],
                        dis:link[3],
                        // mess:mess
                    })
                    // this.graph.node(start).label=true
                    // this.graph.node(end).label=true
                }
                else{
                    removeEdggeList.push({
                        start:start,
                        end:end,
                        weight:weight,
                        dis:dis,
                        crossnum:-1,
                        // mess:mess
                    })
                }
                // this.graph.addEdge(new jsgraphs.Edge(start, end, sortedEdges[i][2]))

                // console.log(this.graph.adj(start))
                // this.drawLine(this.pointData)
            }
        }
        // this.drawEdges()

        while(!this.checkConnectBetweenCluster()){
            let tempEdgeList=[]
            for(let i=0;i<removeEdggeList.length;i++){
                let start=removeEdggeList[i].start
                let end=removeEdggeList[i].end


                var dfs = new jsgraphs.DepthFirstSearch(this.clustergraph, start);
                if(!dfs.hasPathTo(end)){
                    let scores=this.findOptimalLink(this.clusterArr[start].points,this.clusterArr[end].points)
                    removeEdggeList[i].weight=scores[3]
                    removeEdggeList[i].crossnum=scores[3]
                    tempEdgeList.push({
                        clusterstart:start,
                        clusterend:end,
                        start:scores[0].id,
                        end:scores[1].id,
                        weight:scores[2],
                        crossnum:scores[2]
                    })
                    // filteredRemoveList.push(removeEdggeList[i])
                }
            }
            let minCost=Number.MAX_VALUE
            let maxindex=-1
            for (let i=0;i<tempEdgeList.length;i++){
                if(minCost>tempEdgeList[i].weight){
                    minCost=tempEdgeList[i].weight
                    maxindex=i
                }
            }

            let start=tempEdgeList[maxindex].start
            let end=tempEdgeList[maxindex].end
            this.graph.addEdge(start,end)
            this.clustergraph.addEdge(tempEdgeList[maxindex].clusterstart,tempEdgeList[maxindex].clusterend)
            this.edges.push({
                start:start,
                end:end,
                weight:tempEdgeList[maxindex].weight,
                // dis:tempEdgeList[maxindex].dis,
                // mess:tempEdgeList[maxindex].mess,
                crossnum:tempEdgeList[maxindex].crossnum
            })

            // this.drawEdges()
            console.log()

            // tempEdgeList.splice(maxindex,1)

        }

        // filteredRemoveList=this.sortRemoveEdges(filteredRemoveList)
        // console.log(filteredRemoveList)

    }

    editBackbone(){

        editView = !editView
        this.setState({
            editV:editView
        })

        if(editView){
            d3.select("svg")
                .selectAll(".dataPoint")
                .remove()
//
            d3.select("svg")
                .selectAll("line")
                .remove()

            //offsetX = 20;
            //offsetY = 20;
            //viewWidth = 40;
            //viewHeight = 40
//
            //this.child.setViewBox(offsetX, offsetY, viewWidth, viewHeight)
            //d3.select("#mainsvg")
            //    .attr("viewBox",offsetX+" "+offsetY+" "+viewWidth+" "+viewHeight)

            /*
            let tx,ty,s
            if(document.getElementsByTagName('g')[0].attributes.hasOwnProperty("transform")){
                let infostr = document.getElementsByTagName('g')[0].attributes.transform.value.toString()
                for(let i = 0; i < infostr.length; i ++){
                    if(infostr[i] == '('){
                        i ++
                        while(infostr[i] != ','){
                            tx += infostr[i ++]
                        }
                        i ++
                        while(infostr[i] != ')'){
                            ty += infostr[i ++]
                        }
                        while(infostr[i] != '('){
                            i ++
                        }
                        i ++
                        while(infostr[i] != ')'){
                            s += infostr[i ++]
                        }
                        break
                    }
                }
                tx = parseFloat(tx)
                ty = parseFloat(ty)
                s = parseFloat(s)
            }

             */


            // d3.select(svgid).selectAll("*").remove();
            this.drawPointData()
            this.drawEdges()

            if(document.getElementsByTagName('g')[0].attributes.hasOwnProperty("transform")){
                let infostr = document.getElementsByTagName('g')[0].attributes.transform.value.toString()
                d3.selectAll('g').attr("transform", infostr);
            }

            this.props.handleManually(false)
            //this.child.getData()
        }
        else{
            d3.selectAll("#edgeGroup")
                .remove()
            d3.selectAll("#pointGroup")
                .remove()
            this.child.afterEditReDraw()
            //d3.selectAll("")
        }
    }

    editMST(){

        this.issplit = !this.issplit;

        if(this.issplit == true){

            d3.select("#mainsvg")
                .attr("width",580 * ScreenWidth / BeforeWidth)
                .attr("height",750 * ScreenHeight / BeforeHeight)

            d3.select("#leftsvg")
                .attr("width",580 * ScreenWidth / BeforeWidth)
                .attr("height",750 * ScreenHeight / BeforeHeight)
                .attr("style","border:1px solid #000000")

            svgid = "#leftsvg"
            opsvgid = '#mainsvg'
            d3.select(svgid).selectAll("*").remove();

            this.drawPointData()

            this.drawEdges()

            this.props.handleManually(false)

            //this.setState({
            //    pointData: this.pointData
            //})
            //this.setState({
            //    edges: this.edges
            //})
            //this.setState({
            //    hasinit:true
            //})
//
            //this.child.getData()

        }
        else{

            d3.select(svgid).selectAll("*").remove();
            d3.selectAll("#edgeGroup")
                .remove()
            d3.selectAll("#pointGroup")
                .remove()
            this.child.afterEditReDraw()

            d3.select("#mainsvg")
                .attr("width",1200 * ScreenWidth / BeforeWidth)
                .attr("height",750 * ScreenHeight / BeforeHeight)

            d3.select("#leftsvg")
                .attr("width",0)
                .attr("height",0)
                .attr("style","border:0px solid #000000")



            svgid = "#mainsvg"
            opsvgid = '#leftsvg'

        }

    }

    handleCreated(){
        this.setState({
            hascreated:true
        })
    }

    onRef = (ref) => {
        this.child = ref
    }

    saveSVG(){

    }

    saveData(){
        let data
        if(!this.state.hasinit){
            data=this.props.pointData
        }
        else{
            data=this.pointData
        }
        let content = JSON.stringify(data);
        let blob = new Blob([content], {type: "text/plain;charset=utf-8"});

        FileSaver.saveAs(blob, "data.json");

    }

    render(){
        //return (
        //    <div id={"svgcontainer"}>
        //        <svg id={"mainsvg"} width={"1000px"} height={"1000px"}>
        //        </svg>
        //        <button onClick={this.saveEdgeData.bind(this)}> Save </button>
        //        <button onClick={this.loadEdgeData.bind(this)}> Load Edges </button>
        //    </div>)
        return (
            <div>
                <div>
                    {/*<Button onClick={this.saveData.bind(this)}>Save Data</Button>*/}
                    {/*<Button onClick={this.saveSVG}>Save SVG</Button>*/}

                </div>
                <div style={{marginTop: 20 * ScreenHeight / BeforeHeight}}>
                        <Button onClick = {this.getData.bind(this)} disabled={this.props.hasLoadData&&!this.state.hasinit||this.state.hasEdit? false:true}>
                        {
                            this.state.hasinit? "Apply Changes":"Create Backbone"
                        }
                    </Button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Switch checkedChildren="Edit Backbone" unCheckedChildren="Edit Backbone"  onClick={this.editBackbone.bind(this)} checked={this.state.editV} disabled={this.state.hascreated? false:true}/>
                    </div>

                <AdaptiveIsovalue pointData={this.state.pointData} hasLoadData={this.props.hasLoadData} edges={this.state.edges} handleCreated={this.handleCreated.bind(this)} createMST={this.getData.bind(this)} onRef={this.onRef} colorArray={this.props.colorArray}/>
            </div>
        );
    }
}

export default HierarchicalCluster